(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["vue"], factory);
	else if(typeof exports === 'object')
		exports["ot"] = factory(require("vue"));
	else
		root["ot"] = factory(root["vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__8bbf__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "04e2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PaginationTable_vue_vue_type_style_index_0_id_723d9fa0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7579");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PaginationTable_vue_vue_type_style_index_0_id_723d9fa0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PaginationTable_vue_vue_type_style_index_0_id_723d9fa0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "05cf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardContent_vue_vue_type_style_index_0_id_1b6969fb_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9d37");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardContent_vue_vue_type_style_index_0_id_1b6969fb_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardContent_vue_vue_type_style_index_0_id_1b6969fb_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0773":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-0c9735e5],.ot-vars[data-v-0c9735e5]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.form-collapse[data-v-0c9735e5]{background:var(--ot-color-core-accent-tertiary);padding:var(--ot-spacing-xl) var(--ot-spacing-xl) 0 var(--ot-spacing-xl)}.form-collapse__header[data-v-0c9735e5]{cursor:pointer;border-bottom:1px solid transparent;display:flex;align-items:center;padding-bottom:var(--ot-spacing-xl)}.form-collapse__content[data-v-0c9735e5]{padding-top:var(--ot-spacing-xl)}.form-collapse.open[data-v-0c9735e5]{padding:var(--ot-spacing-xl)}.form-collapse.open .form-collapse__header[data-v-0c9735e5]{border-bottom:1px solid var(--ot-color-core-accent-secondary)}.form-collapse.disabled[data-v-0c9735e5]{opacity:.5;cursor:not-allowed}.form-collapse.disabled .form-collapse__header[data-v-0c9735e5]{pointer-events:none}.header__title[data-v-0c9735e5]{font-family:var(--ot-text-font-family);color:var(--ot-color-core-foreground-secondary)}.header__text[data-v-0c9735e5]{margin:.25rem 0 0;font-size:.9rem;color:var(--ot-color-core-accent-primary)}.header__content[data-v-0c9735e5]{flex:1}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "07db":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_style_index_0_id_026b715c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5e0e");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_style_index_0_id_026b715c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Sidebar_vue_vue_type_style_index_0_id_026b715c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0872":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudSorter_vue_vue_type_style_index_0_id_7a14db59_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("804a");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudSorter_vue_vue_type_style_index_0_id_7a14db59_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudSorter_vue_vue_type_style_index_0_id_7a14db59_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0962":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5ded");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5239578d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "0a80":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudPicker_vue_vue_type_style_index_0_id_188cf208_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2608");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudPicker_vue_vue_type_style_index_0_id_188cf208_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudPicker_vue_vue_type_style_index_0_id_188cf208_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "0ee7":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-c808982e],.ot-vars[data-v-c808982e]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.crud-select__empty[data-v-c808982e]{color:var(--ot-color-core-accent-primary)}.crud-select__filters[data-v-c808982e]{padding:var(--ot-spacing-unit);display:flex;align-items:center}.crud-select__filters>button[data-v-c808982e]{margin-left:.5rem}.crud-select__list__item[data-v-c808982e]{font-weight:500;display:flex}.crud-select__list__item[data-v-c808982e]:after{content:\"\";position:absolute;bottom:0;left:var(--ot-spacing-unit);width:calc(100% - var(--ot-spacing-unit)*2);background:var(--ot-color-core-background-secondary);height:1px}.crud-select__list__item[data-v-c808982e]:last-child{border:none}.crud-select__list__item.selected[data-v-c808982e],.crud-select__list__item[data-v-c808982e]:hover{cursor:pointer;color:var(--ot-color-core-brand);background:var(--ot-color-core-background-secondary)}.crud-select__list__item__content[data-v-c808982e]{flex:1;align-items:center;padding:var(--ot-spacing-unit) var(--ot-spacing-unit)}.crud-select__list__item__action[data-v-c808982e]{padding:0 var(--ot-spacing-unit);margin:var(--ot-spacing-2xs);display:flex;align-items:center}.crud-select__list__item__action[data-v-c808982e]:hover{background:var(--ot-color-core-brand);color:var(--ot-color-core-white)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "1105":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-1401f924],.ot-vars[data-v-1401f924]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.splash-screen[data-v-1401f924]{position:fixed;top:0;left:0;display:flex;align-items:center;width:100%;height:100vh;flex-direction:column;justify-content:center;background-color:var(--ot-color-core-background-primary);transition:opacity .3s ease;z-index:99}.splash-screen__spinner[data-v-1401f924]{height:3rem}.splash-screen h5[data-v-1401f924]{margin-top:1rem;flex:0}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "11b0":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? factory(exports) :
	undefined;
}(this, (function (exports) { 'use strict';

// Export Sortable Element Component Mixin
var ElementMixin = {
  inject: ['manager'],
  props: {
    index: {
      type: Number,
      required: true
    },
    collection: {
      type: [String, Number],
      default: 'default'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  mounted: function mounted() {
    var _$props = this.$props,
        collection = _$props.collection,
        disabled = _$props.disabled,
        index = _$props.index;


    if (!disabled) {
      this.setDraggable(collection, index);
    }
  },


  watch: {
    index: function index(newIndex) {
      if (this.$el && this.$el.sortableInfo) {
        this.$el.sortableInfo.index = newIndex;
      }
    },
    disabled: function disabled(isDisabled) {
      if (isDisabled) {
        this.removeDraggable(this.collection);
      } else {
        this.setDraggable(this.collection, this.index);
      }
    },
    collection: function collection(newCollection, oldCollection) {
      this.removeDraggable(oldCollection);
      this.setDraggable(newCollection, this.index);
    }
  },

  beforeDestroy: function beforeDestroy() {
    var collection = this.collection,
        disabled = this.disabled;


    if (!disabled) this.removeDraggable(collection);
  },

  methods: {
    setDraggable: function setDraggable(collection, index) {
      var node = this.$el;

      node.sortableInfo = {
        index: index,
        collection: collection,
        manager: this.manager
      };

      this.ref = { node: node };
      this.manager.add(collection, this.ref);
    },
    removeDraggable: function removeDraggable(collection) {
      this.manager.remove(collection, this.ref);
    }
  }
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();



























var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();













var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var Manager = function () {
  function Manager() {
    classCallCheck(this, Manager);

    this.refs = {};
  }

  createClass(Manager, [{
    key: "add",
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: "remove",
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.active;
    }
  }, {
    key: "getActive",
    value: function getActive() {
      var _this = this;

      return this.refs[this.active.collection].find(function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: "getIndex",
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: "getOrderedRefs",
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;

      return this.refs[collection].sort(function (a, b) {
        return a.node.sortableInfo.index - b.node.sortableInfo.index;
      });
    }
  }]);
  return Manager;
}();

function arrayMove(arr, previousIndex, newIndex) {
  var array = arr.slice(0);
  if (newIndex >= array.length) {
    var k = newIndex - array.length;
    while (k-- + 1) {
      array.push(undefined);
    }
  }
  array.splice(newIndex, 0, array.splice(previousIndex, 1)[0]);
  return array;
}

var events = {
  start: ['touchstart', 'mousedown'],
  move: ['touchmove', 'mousemove'],
  end: ['touchend', 'touchcancel', 'mouseup']
};

var vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return ''; // server environment
  // fix for:
  //    https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  //    window.getComputedStyle() returns null inside an iframe with display: none
  // in this case return an array with a fake mozilla style in it.
  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';
    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();

function closest(el, fn) {
  while (el) {
    if (fn(el)) return el;
    el = el.parentNode;
  }
}

function limit(min, max, value) {
  if (value < min) {
    return min;
  }
  if (value > max) {
    return max;
  }
  return value;
}

function getCSSPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }
  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);

  return {
    top: getCSSPixelValue(style.marginTop),
    right: getCSSPixelValue(style.marginRight),
    bottom: getCSSPixelValue(style.marginBottom),
    left: getCSSPixelValue(style.marginLeft)
  };
}

// Export Sortable Container Component Mixin
var ContainerMixin = {
  data: function data() {
    return {
      sorting: false,
      sortingIndex: null,
      manager: new Manager(),
      events: {
        start: this.handleStart,
        move: this.handleMove,
        end: this.handleEnd
      }
    };
  },


  props: {
    value: { type: Array, required: true },
    axis: { type: String, default: 'y' }, // 'x', 'y', 'xy'
    distance: { type: Number, default: 0 },
    pressDelay: { type: Number, default: 0 },
    pressThreshold: { type: Number, default: 5 },
    useDragHandle: { type: Boolean, default: false },
    useWindowAsScrollContainer: { type: Boolean, default: false },
    hideSortableGhost: { type: Boolean, default: true },
    lockToContainerEdges: { type: Boolean, default: false },
    lockOffset: { type: [String, Number, Array], default: '50%' },
    transitionDuration: { type: Number, default: 300 },
    appendTo: { type: String, default: 'body' },
    draggedSettlingDuration: { type: Number, default: null },
    lockAxis: String,
    helperClass: String,
    contentWindow: Object,
    shouldCancelStart: {
      type: Function,
      default: function _default(e) {
        // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
        var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];
        return disabledElements.indexOf(e.target.tagName.toLowerCase()) !== -1;
      }
    },
    getHelperDimensions: {
      type: Function,
      default: function _default(_ref) {
        var node = _ref.node;
        return {
          width: node.offsetWidth,
          height: node.offsetHeight
        };
      }
    }
  },

  provide: function provide() {
    return {
      manager: this.manager
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.container = this.$el;
    this.document = this.container.ownerDocument || document;
    this._window = this.contentWindow || window;
    this.scrollContainer = this.useWindowAsScrollContainer ? this.document.body : this.container;

    var _loop = function _loop(key) {
      if (_this.events.hasOwnProperty(key)) {
        events[key].forEach(function (eventName) {
          return _this.container.addEventListener(eventName, _this.events[key], { passive: true });
        });
      }
    };

    for (var key in this.events) {
      _loop(key);
    }
  },
  beforeDestroy: function beforeDestroy() {
    var _this2 = this;

    var _loop2 = function _loop2(key) {
      if (_this2.events.hasOwnProperty(key)) {
        events[key].forEach(function (eventName) {
          return _this2.container.removeEventListener(eventName, _this2.events[key]);
        });
      }
    };

    for (var key in this.events) {
      _loop2(key);
    }
  },


  methods: {
    handleStart: function handleStart(e) {
      var _this3 = this;

      var _$props = this.$props,
          distance = _$props.distance,
          shouldCancelStart = _$props.shouldCancelStart;


      if (e.button === 2 || shouldCancelStart(e)) {
        return false;
      }

      this._touched = true;
      this._pos = this.getOffset(e);

      var node = closest(e.target, function (el) {
        return el.sortableInfo != null;
      });

      if (node && node.sortableInfo && this.nodeIsChild(node) && !this.sorting) {
        var useDragHandle = this.$props.useDragHandle;
        var _node$sortableInfo = node.sortableInfo,
            index = _node$sortableInfo.index,
            collection = _node$sortableInfo.collection;


        if (useDragHandle && !closest(e.target, function (el) {
          return el.sortableHandle != null;
        })) return;

        this.manager.active = { index: index, collection: collection };

        /*
        * Fixes a bug in Firefox where the :active state of anchor tags
        * prevent subsequent 'mousemove' events from being fired
        * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
        */
        if (e.target.tagName.toLowerCase() === 'a') {
          e.preventDefault();
        }

        if (!distance) {
          if (this.$props.pressDelay === 0) {
            this.handlePress(e);
          } else {
            this.pressTimer = setTimeout(function () {
              return _this3.handlePress(e);
            }, this.$props.pressDelay);
          }
        }
      }
    },
    nodeIsChild: function nodeIsChild(node) {
      return node.sortableInfo.manager === this.manager;
    },
    handleMove: function handleMove(e) {
      var _$props2 = this.$props,
          distance = _$props2.distance,
          pressThreshold = _$props2.pressThreshold;


      if (!this.sorting && this._touched) {
        var offset = this.getOffset(e);
        this._delta = {
          x: this._pos.x - offset.x,
          y: this._pos.y - offset.y
        };
        var delta = Math.abs(this._delta.x) + Math.abs(this._delta.y);

        if (!distance && (!pressThreshold || pressThreshold && delta >= pressThreshold)) {
          clearTimeout(this.cancelTimer);
          this.cancelTimer = setTimeout(this.cancel, 0);
        } else if (distance && delta >= distance && this.manager.isActive()) {
          this.handlePress(e);
        }
      }
    },
    handleEnd: function handleEnd() {
      var distance = this.$props.distance;


      this._touched = false;

      if (!distance) {
        this.cancel();
      }
    },
    cancel: function cancel() {
      if (!this.sorting) {
        clearTimeout(this.pressTimer);
        this.manager.active = null;
      }
    },
    handlePress: function handlePress(e) {
      var _this4 = this;

      e.stopPropagation();
      var active = this.manager.getActive();

      if (active) {
        var _$props3 = this.$props,
            axis = _$props3.axis,
            getHelperDimensions = _$props3.getHelperDimensions,
            helperClass = _$props3.helperClass,
            hideSortableGhost = _$props3.hideSortableGhost,
            useWindowAsScrollContainer = _$props3.useWindowAsScrollContainer,
            appendTo = _$props3.appendTo;
        var node = active.node,
            collection = active.collection;
        var index = node.sortableInfo.index;

        var margin = getElementMargin(node);

        var containerBoundingRect = this.container.getBoundingClientRect();
        var dimensions = getHelperDimensions({ index: index, node: node, collection: collection });

        this.node = node;
        this.margin = margin;
        this.width = dimensions.width;
        this.height = dimensions.height;
        this.marginOffset = {
          x: this.margin.left + this.margin.right,
          y: Math.max(this.margin.top, this.margin.bottom)
        };
        this.boundingClientRect = node.getBoundingClientRect();
        this.containerBoundingRect = containerBoundingRect;
        this.index = index;
        this.newIndex = index;

        this._axis = {
          x: axis.indexOf('x') >= 0,
          y: axis.indexOf('y') >= 0
        };
        this.offsetEdge = this.getEdgeOffset(node);
        this.initialOffset = this.getOffset(e);
        this.initialScroll = {
          top: this.scrollContainer.scrollTop,
          left: this.scrollContainer.scrollLeft
        };

        this.initialWindowScroll = {
          top: window.pageYOffset,
          left: window.pageXOffset
        };

        var fields = node.querySelectorAll('input, textarea, select');
        var clonedNode = node.cloneNode(true);
        var clonedFields = [].concat(toConsumableArray(clonedNode.querySelectorAll('input, textarea, select'))); // Convert NodeList to Array

        clonedFields.forEach(function (field, index) {
          if (field.type !== 'file' && fields[index]) {
            field.value = fields[index].value;
          }
        });

        this.helper = this.document.querySelector(appendTo).appendChild(clonedNode);

        this.helper.style.position = 'fixed';
        this.helper.style.top = this.boundingClientRect.top - margin.top + 'px';
        this.helper.style.left = this.boundingClientRect.left - margin.left + 'px';
        this.helper.style.width = this.width + 'px';
        this.helper.style.height = this.height + 'px';
        this.helper.style.boxSizing = 'border-box';
        this.helper.style.pointerEvents = 'none';

        if (hideSortableGhost) {
          this.sortableGhost = node;
          node.style.visibility = 'hidden';
          node.style.opacity = 0;
        }

        this.translate = {};
        this.minTranslate = {};
        this.maxTranslate = {};
        if (this._axis.x) {
          this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - this.boundingClientRect.left - this.width / 2;
          this.maxTranslate.x = (useWindowAsScrollContainer ? this._window.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - this.boundingClientRect.left - this.width / 2;
        }
        if (this._axis.y) {
          this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - this.boundingClientRect.top - this.height / 2;
          this.maxTranslate.y = (useWindowAsScrollContainer ? this._window.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - this.boundingClientRect.top - this.height / 2;
        }

        if (helperClass) {
          var _helper$classList;

          (_helper$classList = this.helper.classList).add.apply(_helper$classList, toConsumableArray(helperClass.split(' ')));
        }

        this.listenerNode = e.touches ? node : this._window;
        events.move.forEach(function (eventName) {
          return _this4.listenerNode.addEventListener(eventName, _this4.handleSortMove, false);
        });
        events.end.forEach(function (eventName) {
          return _this4.listenerNode.addEventListener(eventName, _this4.handleSortEnd, false);
        });

        this.sorting = true;
        this.sortingIndex = index;

        this.$emit('sort-start', { event: e, node: node, index: index, collection: collection });
      }
    },
    handleSortMove: function handleSortMove(e) {
      e.preventDefault(); // Prevent scrolling on mobile

      this.updatePosition(e);
      this.animateNodes();
      this.autoscroll();

      this.$emit('sort-move', { event: e });
    },
    handleSortEnd: function handleSortEnd(e) {
      var _this5 = this;

      var collection = this.manager.active.collection;

      // Remove the event listeners if the node is still in the DOM

      if (this.listenerNode) {
        events.move.forEach(function (eventName) {
          return _this5.listenerNode.removeEventListener(eventName, _this5.handleSortMove);
        });
        events.end.forEach(function (eventName) {
          return _this5.listenerNode.removeEventListener(eventName, _this5.handleSortEnd);
        });
      }

      var nodes = this.manager.refs[collection];

      var onEnd = function onEnd() {
        // Remove the helper from the DOM
        _this5.helper.parentNode.removeChild(_this5.helper);

        if (_this5.hideSortableGhost && _this5.sortableGhost) {
          _this5.sortableGhost.style.visibility = '';
          _this5.sortableGhost.style.opacity = '';
        }

        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i];
          var el = node.node;

          // Clear the cached offsetTop / offsetLeft value
          node.edgeOffset = null;

          // Remove the transforms / transitions
          el.style[vendorPrefix + 'Transform'] = '';
          el.style[vendorPrefix + 'TransitionDuration'] = '';
        }

        // Stop autoscroll
        clearInterval(_this5.autoscrollInterval);
        _this5.autoscrollInterval = null;

        // Update state
        _this5.manager.active = null;

        _this5.sorting = false;
        _this5.sortingIndex = null;

        _this5.$emit('sort-end', {
          event: e,
          oldIndex: _this5.index,
          newIndex: _this5.newIndex,
          collection: collection
        });
        _this5.$emit('input', arrayMove(_this5.value, _this5.index, _this5.newIndex));

        _this5._touched = false;
      };

      if (this.$props.transitionDuration || this.$props.draggedSettlingDuration) {
        this.transitionHelperIntoPlace(nodes).then(function () {
          return onEnd();
        });
      } else {
        onEnd();
      }
    },
    transitionHelperIntoPlace: function transitionHelperIntoPlace(nodes) {
      var _this6 = this;

      if (this.$props.draggedSettlingDuration === 0 || nodes.length === 0) {
        return Promise.resolve();
      }

      var deltaScroll = {
        left: this.scrollContainer.scrollLeft - this.initialScroll.left,
        top: this.scrollContainer.scrollTop - this.initialScroll.top
      };
      var indexNode = nodes[this.index].node;
      var newIndexNode = nodes[this.newIndex].node;

      var targetX = -deltaScroll.left;
      if (this.translate && this.translate.x > 0) {
        // Diff against right edge when moving to the right
        targetX += newIndexNode.offsetLeft + newIndexNode.offsetWidth - (indexNode.offsetLeft + indexNode.offsetWidth);
      } else {
        targetX += newIndexNode.offsetLeft - indexNode.offsetLeft;
      }

      var targetY = -deltaScroll.top;
      if (this.translate && this.translate.y > 0) {
        // Diff against the bottom edge when moving down
        targetY += newIndexNode.offsetTop + newIndexNode.offsetHeight - (indexNode.offsetTop + indexNode.offsetHeight);
      } else {
        targetY += newIndexNode.offsetTop - indexNode.offsetTop;
      }

      var duration = this.$props.draggedSettlingDuration !== null ? this.$props.draggedSettlingDuration : this.$props.transitionDuration;

      this.helper.style[vendorPrefix + 'Transform'] = 'translate3d(' + targetX + 'px,' + targetY + 'px, 0)';
      this.helper.style[vendorPrefix + 'TransitionDuration'] = duration + 'ms';

      return new Promise(function (resolve) {
        // Register an event handler to clean up styles when the transition
        // finishes.
        var cleanup = function cleanup(event) {
          if (!event || event.propertyName === 'transform') {
            clearTimeout(cleanupTimer);
            _this6.helper.style[vendorPrefix + 'Transform'] = '';
            _this6.helper.style[vendorPrefix + 'TransitionDuration'] = '';
            resolve();
          }
        };
        // Force cleanup in case 'transitionend' never fires
        var cleanupTimer = setTimeout(cleanup, duration + 10);
        _this6.helper.addEventListener('transitionend', cleanup, false);
      });
    },
    getEdgeOffset: function getEdgeOffset(node) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { top: 0, left: 0 };

      // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested
      if (node) {
        var nodeOffset = {
          top: offset.top + node.offsetTop,
          left: offset.left + node.offsetLeft
        };
        if (node.parentNode !== this.container) {
          return this.getEdgeOffset(node.parentNode, nodeOffset);
        } else {
          return nodeOffset;
        }
      }
    },
    getOffset: function getOffset(e) {
      var _ref2 = e.touches ? e.touches[0] : e,
          pageX = _ref2.pageX,
          pageY = _ref2.pageY;

      return {
        x: pageX,
        y: pageY
      };
    },
    getLockPixelOffsets: function getLockPixelOffsets() {
      var lockOffset = this.$props.lockOffset;


      if (!Array.isArray(this.lockOffset)) {
        lockOffset = [lockOffset, lockOffset];
      }

      if (lockOffset.length !== 2) {
        throw new Error('lockOffset prop of SortableContainer should be a single value or an array of exactly two values. Given ' + lockOffset);
      }

      var _lockOffset = lockOffset,
          _lockOffset2 = slicedToArray(_lockOffset, 2),
          minLockOffset = _lockOffset2[0],
          maxLockOffset = _lockOffset2[1];

      return [this.getLockPixelOffset(minLockOffset), this.getLockPixelOffset(maxLockOffset)];
    },
    getLockPixelOffset: function getLockPixelOffset(lockOffset) {
      var offsetX = lockOffset;
      var offsetY = lockOffset;
      var unit = 'px';

      if (typeof lockOffset === 'string') {
        var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);

        if (match === null) {
          throw new Error('lockOffset value should be a number or a string of a number followed by "px" or "%". Given ' + lockOffset);
        }

        offsetX = offsetY = parseFloat(lockOffset);
        unit = match[1];
      }

      if (!isFinite(offsetX) || !isFinite(offsetY)) {
        throw new Error('lockOffset value should be a finite. Given ' + lockOffset);
      }

      if (unit === '%') {
        offsetX = offsetX * this.width / 100;
        offsetY = offsetY * this.height / 100;
      }

      return {
        x: offsetX,
        y: offsetY
      };
    },
    updatePosition: function updatePosition(e) {
      var _$props4 = this.$props,
          lockAxis = _$props4.lockAxis,
          lockToContainerEdges = _$props4.lockToContainerEdges;


      var offset = this.getOffset(e);
      var translate = {
        x: offset.x - this.initialOffset.x,
        y: offset.y - this.initialOffset.y
      };
      // Adjust for window scroll
      translate.y -= window.pageYOffset - this.initialWindowScroll.top;
      translate.x -= window.pageXOffset - this.initialWindowScroll.left;

      this.translate = translate;

      if (lockToContainerEdges) {
        var _getLockPixelOffsets = this.getLockPixelOffsets(),
            _getLockPixelOffsets2 = slicedToArray(_getLockPixelOffsets, 2),
            minLockOffset = _getLockPixelOffsets2[0],
            maxLockOffset = _getLockPixelOffsets2[1];

        var minOffset = {
          x: this.width / 2 - minLockOffset.x,
          y: this.height / 2 - minLockOffset.y
        };
        var maxOffset = {
          x: this.width / 2 - maxLockOffset.x,
          y: this.height / 2 - maxLockOffset.y
        };

        translate.x = limit(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
        translate.y = limit(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
      }

      if (lockAxis === 'x') {
        translate.y = 0;
      } else if (lockAxis === 'y') {
        translate.x = 0;
      }

      this.helper.style[vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px, 0)';
    },
    animateNodes: function animateNodes() {
      var _$props5 = this.$props,
          transitionDuration = _$props5.transitionDuration,
          hideSortableGhost = _$props5.hideSortableGhost;

      var nodes = this.manager.getOrderedRefs();
      var deltaScroll = {
        left: this.scrollContainer.scrollLeft - this.initialScroll.left,
        top: this.scrollContainer.scrollTop - this.initialScroll.top
      };
      var sortingOffset = {
        left: this.offsetEdge.left + this.translate.x + deltaScroll.left,
        top: this.offsetEdge.top + this.translate.y + deltaScroll.top
      };
      var scrollDifference = {
        top: window.pageYOffset - this.initialWindowScroll.top,
        left: window.pageXOffset - this.initialWindowScroll.left
      };
      this.newIndex = null;

      for (var i = 0, len = nodes.length; i < len; i++) {
        var node = nodes[i].node;

        var index = node.sortableInfo.index;
        var width = node.offsetWidth;
        var height = node.offsetHeight;
        var offset = {
          width: this.width > width ? width / 2 : this.width / 2,
          height: this.height > height ? height / 2 : this.height / 2
        };

        var translate = {
          x: 0,
          y: 0
        };
        var edgeOffset = nodes[i].edgeOffset;

        // If we haven't cached the node's offsetTop / offsetLeft value

        if (!edgeOffset) {
          nodes[i].edgeOffset = edgeOffset = this.getEdgeOffset(node);
        }

        // Get a reference to the next and previous node
        var nextNode = i < nodes.length - 1 && nodes[i + 1];
        var prevNode = i > 0 && nodes[i - 1];

        // Also cache the next node's edge offset if needed.
        // We need this for calculating the animation in a grid setup
        if (nextNode && !nextNode.edgeOffset) {
          nextNode.edgeOffset = this.getEdgeOffset(nextNode.node);
        }

        // If the node is the one we're currently animating, skip it
        if (index === this.index) {
          if (hideSortableGhost) {
            /*
            * With windowing libraries such as `react-virtualized`, the sortableGhost
            * node may change while scrolling down and then back up (or vice-versa),
            * so we need to update the reference to the new node just to be safe.
            */
            this.sortableGhost = node;
            node.style.visibility = 'hidden';
            node.style.opacity = 0;
          }
          continue;
        }

        if (transitionDuration) {
          node.style[vendorPrefix + 'TransitionDuration'] = transitionDuration + 'ms';
        }

        if (this._axis.x) {
          if (this._axis.y) {
            // Calculations for a grid setup
            if (index < this.index && (sortingOffset.left + scrollDifference.left - offset.width <= edgeOffset.left && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height || sortingOffset.top + scrollDifference.top + offset.height <= edgeOffset.top)) {
              // If the current node is to the left on the same row, or above the node that's being dragged
              // then move it to the right
              translate.x = this.width + this.marginOffset.x;
              if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                // If it moves passed the right bounds, then animate it to the first position of the next row.
                // We just use the offset of the next node to calculate where to move, because that node's original position
                // is exactly where we want to go
                translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                translate.y = nextNode.edgeOffset.top - edgeOffset.top;
              }
              if (this.newIndex === null) {
                this.newIndex = index;
              }
            } else if (index > this.index && (sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top || sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top + height)) {
              // If the current node is to the right on the same row, or below the node that's being dragged
              // then move it to the left
              translate.x = -(this.width + this.marginOffset.x);
              if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                // If it moves passed the left bounds, then animate it to the last position of the previous row.
                // We just use the offset of the previous node to calculate where to move, because that node's original position
                // is exactly where we want to go
                translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                translate.y = prevNode.edgeOffset.top - edgeOffset.top;
              }
              this.newIndex = index;
            }
          } else {
            if (index > this.index && sortingOffset.left + scrollDifference.left + offset.width >= edgeOffset.left) {
              translate.x = -(this.width + this.marginOffset.x);
              this.newIndex = index;
            } else if (index < this.index && sortingOffset.left + scrollDifference.left <= edgeOffset.left + offset.width) {
              translate.x = this.width + this.marginOffset.x;
              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }
        } else if (this._axis.y) {
          if (index > this.index && sortingOffset.top + scrollDifference.top + offset.height >= edgeOffset.top) {
            translate.y = -(this.height + this.marginOffset.y);
            this.newIndex = index;
          } else if (index < this.index && sortingOffset.top + scrollDifference.top <= edgeOffset.top + offset.height) {
            translate.y = this.height + this.marginOffset.y;
            if (this.newIndex == null) {
              this.newIndex = index;
            }
          }
        }
        node.style[vendorPrefix + 'Transform'] = 'translate3d(' + translate.x + 'px,' + translate.y + 'px,0)';
      }

      if (this.newIndex == null) {
        this.newIndex = this.index;
      }
    },
    autoscroll: function autoscroll() {
      var _this7 = this;

      var translate = this.translate;
      var direction = {
        x: 0,
        y: 0
      };
      var speed = {
        x: 1,
        y: 1
      };
      var acceleration = {
        x: 10,
        y: 10
      };

      if (translate.y >= this.maxTranslate.y - this.height / 2) {
        direction.y = 1; // Scroll Down
        speed.y = acceleration.y * Math.abs((this.maxTranslate.y - this.height / 2 - translate.y) / this.height);
      } else if (translate.x >= this.maxTranslate.x - this.width / 2) {
        direction.x = 1; // Scroll Right
        speed.x = acceleration.x * Math.abs((this.maxTranslate.x - this.width / 2 - translate.x) / this.width);
      } else if (translate.y <= this.minTranslate.y + this.height / 2) {
        direction.y = -1; // Scroll Up
        speed.y = acceleration.y * Math.abs((translate.y - this.height / 2 - this.minTranslate.y) / this.height);
      } else if (translate.x <= this.minTranslate.x + this.width / 2) {
        direction.x = -1; // Scroll Left
        speed.x = acceleration.x * Math.abs((translate.x - this.width / 2 - this.minTranslate.x) / this.width);
      }

      if (this.autoscrollInterval) {
        clearInterval(this.autoscrollInterval);
        this.autoscrollInterval = null;
        this.isAutoScrolling = false;
      }

      if (direction.x !== 0 || direction.y !== 0) {
        this.autoscrollInterval = setInterval(function () {
          _this7.isAutoScrolling = true;
          var offset = {
            left: 1 * speed.x * direction.x,
            top: 1 * speed.y * direction.y
          };
          _this7.scrollContainer.scrollTop += offset.top;
          _this7.scrollContainer.scrollLeft += offset.left;
          _this7.translate.x += offset.left;
          _this7.translate.y += offset.top;
          _this7.animateNodes();
        }, 5);
      }
    }
  }
};

// Export Sortable Element Handle Directive
var HandleDirective = {
  bind: function bind(el) {
    el.sortableHandle = true;
  }
};

function create(name, mixin) {
  return {
    name: name,
    mixins: [mixin],
    props: {
      tag: {
        type: String,
        default: 'div'
      }
    },
    render: function render(h) {
      return h(this.tag, this.$slots.default);
    }
  };
}

var SlickList = create('slick-list', ContainerMixin);
var SlickItem = create('slick-item', ElementMixin);

exports.ElementMixin = ElementMixin;
exports.ContainerMixin = ContainerMixin;
exports.HandleDirective = HandleDirective;
exports.SlickList = SlickList;
exports.SlickItem = SlickItem;
exports.arrayMove = arrayMove;

Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),

/***/ "1395":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("31b2");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("d3e17018", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "1445":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormRow_vue_vue_type_style_index_0_id_99c8670e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5e76");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormRow_vue_vue_type_style_index_0_id_99c8670e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormRow_vue_vue_type_style_index_0_id_99c8670e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "164e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardHeader_vue_vue_type_style_index_0_id_312c9aec_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f9c1");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardHeader_vue_vue_type_style_index_0_id_312c9aec_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardHeader_vue_vue_type_style_index_0_id_312c9aec_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "18f9":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-452944a8],.ot-vars[data-v-452944a8]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.header[data-v-452944a8]{height:var(--ot-layout-header-height,4rem);margin:0 auto;display:flex}.header[data-v-452944a8],.header__container[data-v-452944a8]{width:100%}.header__spacer[data-v-452944a8]{flex:1}.header__logo[data-v-452944a8]{width:var(--ot-layout-sidebar-width,16rem);display:flex;align-items:center}.header__logo img[data-v-452944a8]{height:2rem}@media(max-width:60rem){.header__logo[data-v-452944a8]{display:none}}.header__menu-btn[data-v-452944a8]{display:none;width:var(--ot-layout-sidebar-width,16rem);align-items:center;cursor:pointer}@media(max-width:60rem){.header__menu-btn[data-v-452944a8]{display:flex}}.header__actions[data-v-452944a8]{display:flex;align-items:center}.header[data-v-452944a8] .header__action{margin:.5rem 0;cursor:pointer;border:2px solid transparent;padding:2px;border-radius:50%;margin-right:-4px}.header[data-v-452944a8] .header__action.opened{border-color:var(--ot-color-core-brand)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "21a4":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f09b");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6b82593e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2231":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-5cf2c7e2],.ot-vars[data-v-5cf2c7e2]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.router-modal[data-v-5cf2c7e2]{width:100px}.router-modal__backdrop[data-v-5cf2c7e2]{z-index:100;position:fixed;top:0;left:0;width:100%;height:100%;background:#000;opacity:.3}.router-modal__card[data-v-5cf2c7e2]{z-index:101;position:fixed;top:50%;left:50%;max-width:calc(var(--ot-layout-width, 80rem) - var(--ot-layout-sidebar-width, 16rem));max-height:calc(100vh - var(--ot-spacing-default)*2);transform:translate(-50%,-50%);padding:0;overflow:auto}@media(max-width:60rem){.router-modal__card[data-v-5cf2c7e2]{max-width:calc(100% - var(--ot-spacing-default)*2);max-height:calc(100% - var(--ot-spacing-default)*2);display:flex}}@media(max-width:40rem){.router-modal__card[data-v-5cf2c7e2]{width:100%;height:100%;max-width:100%;max-height:100%}}.router-modal__card.fit-width[data-v-5cf2c7e2]{width:100%!important;max-width:calc(100% - var(--ot-spacing-unit))}.router-modal__card.fit-height[data-v-5cf2c7e2]{height:100%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "23f5":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("7a0a");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("416c3c28", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "243c":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-3c31179d],.ot-vars[data-v-3c31179d]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.layout[data-v-3c31179d]{min-height:100vh}.layout[data-v-3c31179d],.layout__header[data-v-3c31179d]{background:var(--ot-color-core-background-secondary)}.layout__header[data-v-3c31179d]{position:fixed;top:0;left:0;width:100%;height:var(--ot-layout-header-height,4rem);display:flex;align-items:center;z-index:99;transition:all .3s ease}.layout__content[data-v-3c31179d],.layout__header__slot[data-v-3c31179d]{width:calc(100% - var(--ot-spacing-default)*2);max-width:var(--ot-layout-width,80rem);margin:0 auto}.layout__content[data-v-3c31179d]{padding-top:var(--ot-layout-header-height,4rem);display:flex}.layout__sidebar[data-v-3c31179d]{width:var(--ot-layout-sidebar-width,16rem);background:var(--ot-color-core-background-secondary);flex-shrink:0}@media(max-width:60rem){.layout__sidebar[data-v-3c31179d]{position:fixed;left:calc(var(--ot-layout-sidebar-width, 16rem)*-1);top:0;height:100vh;z-index:100;padding:var(--ot-card-padding);box-sizing:border-box;transition:transform var(--ot-transition-default-timing-function) var(--ot-transition-default-duration)}}@media(max-width:60rem){.layout__sidebar.opened[data-v-3c31179d]{transform:translateX(var(--ot-layout-sidebar-width,16rem))}}.layout__sidebar__backdrop[data-v-3c31179d]{position:fixed;background-color:#000;top:0;left:0;height:100%;width:100%;z-index:99;transition:opacity var(--ot-transition-default-timing-function) var(--ot-transition-default-duration);opacity:0;pointer-events:none}@media(max-width:60rem){.layout__sidebar__backdrop.visible[data-v-3c31179d]{opacity:.3;pointer-events:auto}}.layout__page[data-v-3c31179d]{flex:1;width:100%;max-width:calc(var(--ot-layout-width, 80rem) - var(--ot-layout-sidebar-width, 16rem))}.layout__card[data-v-3c31179d]{padding:0}.layout.is-scrolled .layout__header[data-v-3c31179d]{box-shadow:var(--ot-shadow-lg)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "25b0":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0773");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("778d4cdd", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2608":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e5c5");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5e4e1172", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "2cf2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Card_vue_vue_type_style_index_0_id_0710eee7_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8676");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Card_vue_vue_type_style_index_0_id_0710eee7_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Card_vue_vue_type_style_index_0_id_0710eee7_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2e09":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineModal_vue_vue_type_style_index_1_id_0a66a4ae_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3c16");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineModal_vue_vue_type_style_index_1_id_0a66a4ae_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InlineModal_vue_vue_type_style_index_1_id_0a66a4ae_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "31b2":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-533652ab],.ot-vars[data-v-533652ab]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.crud-nested-picker__header[data-v-533652ab]{padding:var(--ot-spacing-unit);display:flex}.crud-nested-picker__header__back[data-v-533652ab]{display:flex;align-items:center;cursor:pointer;padding-right:var(--ot-spacing-unit)}.crud-nested-picker__header__back[data-v-533652ab]:hover{color:var(--ot-color-core-brand)}.crud-nested-picker__header__actions[data-v-533652ab]{flex:1}.crud-nested-picker__list[data-v-533652ab]{padding-bottom:var(--ot-spacing-unit)}.crud-nested-picker__item[data-v-533652ab]{cursor:pointer;display:flex;align-items:center}.crud-nested-picker__item__content[data-v-533652ab]{flex:1;display:flex;align-items:center;padding:var(--ot-spacing-xs) var(--ot-spacing-unit)}.crud-nested-picker__item__action[data-v-533652ab]{color:var(--ot-color-core-accent-secondary);padding-right:var(--ot-spacing-unit)}.crud-nested-picker__item__check[data-v-533652ab]{pointer-events:none;padding-right:var(--ot-spacing-unit)}.crud-nested-picker__item__count[data-v-533652ab]{background:var(--ot-color-core-brand);color:var(--ot-color-core-white);padding:var(--ot-spacing-2xs) var(--ot-spacing-unit);font-weight:500;border-radius:1rem;margin-right:var(--ot-spacing-unit);display:inline-flex;align-items:center}.crud-nested-picker__item__count .oti[data-v-533652ab]{color:var(--ot-color-core-black);margin-right:var(--ot-spacing-2xs)}.crud-nested-picker__item[data-v-533652ab]:hover{background:var(--ot-color-core-accent-tertiary);color:var(--ot-color-core-brand)}.crud-nested-picker__footer[data-v-533652ab]{padding:var(--ot-spacing-unit);background-color:var(--ot-color-core-accent-tertiary);display:flex;justify-content:space-between}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "33c7":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-7a14db59],.ot-vars[data-v-7a14db59]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.form-sort__wrapper[data-v-7a14db59]{width:100%;background:var(--ot-card-background)}.form-sort__list[data-v-7a14db59]{position:relative}.form-sort__item[data-v-7a14db59]{padding:.5rem 0;display:flex;align-items:center;cursor:pointer;border-bottom:1px solid var(--ot-color-core-accent-secondary);z-index:150}.form-sort__item[data-v-7a14db59]:last-child{border-bottom:none}.form-sort__item__info[data-v-7a14db59]{flex:1}.form-sort__item .oti[data-v-7a14db59]{color:var(--ot-color-core-accent-secondary)}.form-sort__content[data-v-7a14db59]{padding:var(--ot-spacing-unit);position:relative}.form-sort__footer[data-v-7a14db59]{padding:var(--ot-spacing-unit);background-color:var(--ot-color-core-accent-tertiary);display:flex;justify-content:space-between}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "346b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("6ed0");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7e7e0f24", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "3b15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LazyList_vue_vue_type_style_index_0_id_ce93c864_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("80f3");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LazyList_vue_vue_type_style_index_0_id_ce93c864_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LazyList_vue_vue_type_style_index_0_id_ce93c864_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3c16":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("d50c");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("b8311ba0", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "40c6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropdown_vue_vue_type_style_index_0_id_1cd98873_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b355");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropdown_vue_vue_type_style_index_0_id_1cd98873_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Dropdown_vue_vue_type_style_index_0_id_1cd98873_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "418f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-e83bb6b8],.ot-vars[data-v-e83bb6b8]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.pagination-container[data-v-e83bb6b8]{width:100%}.pagination-container__spinner[data-v-e83bb6b8]{height:100%;display:flex;align-items:center}.pagination-container__spinner .ot-spinner[data-v-e83bb6b8]:after{position:relative}.pagination-container__empty[data-v-e83bb6b8]{padding:var(--ot-spacing-unit) 0}.pagination-container__empty h4[data-v-e83bb6b8]{text-align:center}.pagination-container__controls[data-v-e83bb6b8]{padding-top:1rem}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "4235":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-61923796],.ot-vars[data-v-61923796]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.crud-multi-select__empty[data-v-61923796]{color:var(--ot-color-core-accent-primary)}.crud-multi-select__filters[data-v-61923796]{padding:var(--ot-spacing-unit);display:flex;align-items:center}.crud-multi-select__filters>button[data-v-61923796]{margin-left:.5rem}.crud-multi-select__list[data-v-61923796]{padding-bottom:var(--ot-spacing-unit)}.crud-multi-select__list__item[data-v-61923796]{font-weight:500;padding:var(--ot-spacing-2xs) var(--ot-spacing-unit);display:flex;align-items:center}.crud-multi-select__list__item[data-v-61923796]:after{content:\"\";position:absolute;bottom:0;left:var(--ot-spacing-unit);width:calc(100% - var(--ot-spacing-unit)*2);background:var(--ot-color-core-background-secondary);height:1px}.crud-multi-select__list__item[data-v-61923796]:last-child{border:none}.crud-multi-select__list__item.selected[data-v-61923796],.crud-multi-select__list__item[data-v-61923796]:hover{cursor:pointer;color:var(--ot-color-core-brand);background:var(--ot-color-core-background-secondary)}.crud-multi-select__list__item__check[data-v-61923796]{display:flex}.crud-multi-select__list__item__check[data-v-61923796] .ot-checkbox{height:1.25rem}.crud-multi-select__list__item__content[data-v-61923796]{flex:1;align-items:center}.crud-multi-select__list__item__action[data-v-61923796]{padding:0 var(--ot-spacing-unit);margin:var(--ot-spacing-2xs);display:flex;align-items:center}.crud-multi-select__list__item__action[data-v-61923796]:hover{background:var(--ot-color-core-brand);color:var(--ot-color-core-white)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "45d6":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-ce93c864],.ot-vars[data-v-ce93c864]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.lazy-list-controls__spinner[data-v-ce93c864]{padding:var(--ot-spacing-unit) 0}.lazy-list-controls__spinner .ot-spinner[data-v-ce93c864]:after{position:relative}.lazy-list-controls__empty[data-v-ce93c864],.lazy-list-controls__load-more[data-v-ce93c864]{text-align:center;padding:var(--ot-spacing-unit) 0}.lazy-list-controls__load-more[data-v-ce93c864]{display:block;padding-top:0;cursor:pointer}.lazy-list-controls__load-more[data-v-ce93c864]:hover{color:var(--ot-color-brand)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "4720":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("18f9");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("a8e1bc54", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "4835":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Footer_vue_vue_type_style_index_0_id_6d6241a5_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("346b");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Footer_vue_vue_type_style_index_0_id_6d6241a5_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Footer_vue_vue_type_style_index_0_id_6d6241a5_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "499e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* binding */ addStylesClient; });

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/listToStyles.js
/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}

// CONCATENATED MODULE: ./node_modules/vue-style-loader/lib/addStylesClient.js
/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/



var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

function addStylesClient (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ "4bad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),

/***/ "5086":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-668b06d4],.ot-vars[data-v-668b06d4]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.ot-input-error[data-v-668b06d4]{display:flex;align-items:center}.ot-input-error .oti[data-v-668b06d4]{margin-right:.25rem}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "5290":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudNestedPicker_vue_vue_type_style_index_0_id_533652ab_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1395");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudNestedPicker_vue_vue_type_style_index_0_id_533652ab_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudNestedPicker_vue_vue_type_style_index_0_id_533652ab_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5cf2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Avatar_vue_vue_type_style_index_0_id_7bfcd087_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ea3d");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Avatar_vue_vue_type_style_index_0_id_7bfcd087_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Avatar_vue_vue_type_style_index_0_id_7bfcd087_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5ded":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-524a5bf8],.ot-vars[data-v-524a5bf8]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.pagination-controls[data-v-524a5bf8]{display:flex;align-items:center}.pagination-controls__per-page[data-v-524a5bf8]{display:inline-flex}.pagination-controls__pages[data-v-524a5bf8]{display:inline-flex;flex-grow:1;justify-content:center;margin-top:.2rem}.pages__item[data-v-524a5bf8]{margin:0 1rem;cursor:pointer}.pages__item[disabled][data-v-524a5bf8]{opacity:.1;pointer-events:none}.pages__index[data-v-524a5bf8]{margin:.1rem 1rem 0;cursor:pointer}.pages__index[disabled][data-v-524a5bf8]{opacity:.1;pointer-events:none}.pages__index.dots[data-v-524a5bf8]{pointer-events:none}.pages__index.focus[data-v-524a5bf8]{opacity:1}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "5e0e":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ed9e");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("a303ae84", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "5e76":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("d577");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("2192563d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "6dcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardLayout_vue_vue_type_style_index_0_id_3c31179d_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8d78");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardLayout_vue_vue_type_style_index_0_id_3c31179d_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DashboardLayout_vue_vue_type_style_index_0_id_3c31179d_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6ed0":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-6d6241a5],.ot-vars[data-v-6d6241a5]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.footer[data-v-6d6241a5]{padding:var(--ot-spacing-4xl) 0;text-align:center}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "7579":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ec4b");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("1bed1c38", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "7a0a":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-18c55068],.ot-vars[data-v-18c55068]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.ot-input-label[data-v-18c55068]{height:1.5rem}.ot-input-sublabel[data-v-18c55068]{min-height:1rem}.ot-input-field__content[data-v-18c55068]{display:flex;align-items:center}.ot-input-field__content>*[data-v-18c55068]{flex:1;margin-right:var(--ot-spacing-unit)}.ot-input-field__content[data-v-18c55068]>:last-child{margin-right:0}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "804a":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("33c7");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("03b7c3c4", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "80f3":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("45d6");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("3b8acc51", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8676":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ee42");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("7034e59a", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "8d78":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("243c");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("ee290e6e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "8d9d":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("e3af");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6ef1a158", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9b1f":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-5a765f9b],.ot-vars[data-v-5a765f9b]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.spinner[data-v-5a765f9b]{width:100%;padding:var(--ot-spacing-4xl) 0;text-align:center}.spinner[data-v-5a765f9b],.spinner .ot-spinner[data-v-5a765f9b]{position:relative}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "9d37":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("d4f8");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("58d4ba71", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "9ff3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_style_index_0_id_e83bb6b8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("bd1e");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_style_index_0_id_e83bb6b8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Pagination_vue_vue_type_style_index_0_id_e83bb6b8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "a072":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("1105");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("43b357cd", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "a773":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-312c9aec],.ot-vars[data-v-312c9aec]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.header[data-v-312c9aec]{display:flex;overflow:hidden}.header__content[data-v-312c9aec]{flex:1;padding:var(--ot-spacing-2xl) var(--ot-spacing-4xl)}.header__action[data-v-312c9aec]{margin-top:var(--ot-spacing-unit)}.header__image[data-v-312c9aec]{margin:var(--ot-spacing-2xl) var(--ot-card-padding);background-size:contain;background-position:100%;background-repeat:no-repeat;flex:1}@media(max-width:40rem){.header__image[data-v-312c9aec]{display:none}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "aeab":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f0ad");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("824d035c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "af26":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardFooter_vue_vue_type_style_index_0_id_dd9fd2a0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("21a4");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardFooter_vue_vue_type_style_index_0_id_dd9fd2a0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CardFooter_vue_vue_type_style_index_0_id_dd9fd2a0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b355":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f634");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("708d653d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "b6ef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Header_vue_vue_type_style_index_0_id_452944a8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4720");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Header_vue_vue_type_style_index_0_id_452944a8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Header_vue_vue_type_style_index_0_id_452944a8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b8fd":
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
     true ? factory(exports) :
    undefined;
})(this, (function (exports) { 'use strict';

    class BaseError {
        // TODO Determine how to do this ??
        // public get level(): LevelNumber {
        //
        //     return this._level;
        //
        // }
        constructor(data) {
            this._at = new Date();
            this._url = (window && window.location && window.location.href) || '';
            this._data = data;
            // this._level = LevelNumber.Debug; // TODO??
        }
        // TODO Determine how to do this ??
        // protected _level: LevelNumber;
        get at() {
            return new Date(this._at.valueOf());
        }
        get data() {
            return this._data;
        }
        get isOpenTicketError() {
            return true;
        }
        toFlatData() {
            const slug = this.toSlug();
            let serializedSlugData = '';
            try {
                serializedSlugData = JSON.stringify(slug.data) || '';
            }
            catch (_) {
                /* No-op */
            }
            return {
                ...this.additionalFlatData(),
                at: this.at.toISOString(),
                // level: levelNumberToLevel[this.level], // TODO ??
                message: this.toString(),
                slug: this.toSlug().key,
                slugData: serializedSlugData,
                url: this._url,
            };
        }
        additionalFlatData() {
            return {};
        }
    }

    function isStringError(e) {
        return e && e._isStringError;
    }
    class StringError extends BaseError {
        constructor(slug, message) {
            if (!slug || !slug.length) {
                throw new Error('Expected first argument to be a non empty string.');
            }
            super(slug);
            this._message = message;
            this._isStringError = true;
        }
        toSlug() {
            return {
                key: this.data,
            };
        }
        toString() {
            return this._message || this.data;
        }
    }

    class UnexpectedError extends BaseError {
        toSlug() {
            return { key: 'sdkhelpers.errors.unexpected' };
        }
        toString() {
            const str = 'Unexpected error';
            if (this.data) {
                if (this.data instanceof Error) {
                    return `${str} [${this.data.name}]: ${this.data.message}`;
                }
                try {
                    return `${str}: ${JSON.stringify(this.data)}`;
                }
                catch (e) {
                    /* No-op */
                }
            }
            return str;
        }
    }

    function isFormValidationError(e) {
        return e && e._isFormValidationError;
    }
    /**
     * This error class can be used for all errors that implement the
     * CRUD validation error interface.
     */
    class FormValidationError extends BaseError {
        constructor() {
            super(...arguments);
            this._isFormValidationError = true;
        }
        toSlug() {
            return {
                key: this.data.slug,
                data: this.data.data,
            };
            // // This key can optionally be used to show a more specific
            // // error message to the user. We only pass the first error
            // // because of the translation interface requires fixed
            // // length data. The getFieldErrors method can be used
            // // to retrieve a complete set of errors per form field.
            // const firstError: { key: string; error: string } | undefined = this._getFirstErrorFromFirstField();
            //
            // if (!firstError) {
            //
            //     return {
            //         key: 'sdkhelpers.form.errors.generic_validation_error',
            //     };
            //
            // }
            //
            // return {
            //     key: 'sdkhelpers.form.errors.validation_error',
            //     data: firstError,
            // };
        }
        getFieldErrors(key) {
            return FormValidationError.getFieldErrors(this.data.messages, key);
        }
        toString() {
            const firstError = this._getFirstErrorFromFirstField();
            if (!firstError) {
                return 'Validation error';
            }
            return `First validation error ${firstError.key}: ${firstError.error}`;
        }
        additionalFlatData() {
            const errors = {};
            for (const key in this.data.messages) {
                if (Object.prototype.hasOwnProperty.call(this.data, key)) {
                    continue;
                }
                const localErrors = this.data.messages[key];
                if (localErrors) {
                    errors[key] = Array.isArray(localErrors) ? localErrors.join(', ') : localErrors;
                }
            }
            return errors;
        }
        static getFieldErrors(messages, key) {
            const errorOrErrors = messages[key];
            if (!errorOrErrors) {
                return undefined;
            }
            const errors = Array.isArray(errorOrErrors) ? errorOrErrors : [errorOrErrors];
            return errors.map((error) => ({
                key: 'sdkhelpers.form.errors.validation_error_field',
                data: {
                    key,
                    error,
                },
            }));
        }
        _getFirstErrorFromFirstField() {
            for (const key in this.data.messages) {
                if (!Object.prototype.hasOwnProperty.call(this.data, key)) {
                    continue;
                }
                const errorOrErrors = this.data.messages[key];
                if (!errorOrErrors) {
                    continue;
                }
                if (Array.isArray(errorOrErrors)) {
                    return { key, error: errorOrErrors[0] };
                }
                return { key, error: errorOrErrors };
            }
            return undefined;
        }
    }

    class Form {
        constructor(config) {
            this.props = this._buildProps(config.data);
            this.original = { ...config.data };
            this.config = config;
        }
        validate(mutate = false) {
            return this._internalValidate(mutate);
        }
        validateProp(key, mutate = false) {
            return this._internalValidate(mutate, key);
        }
        async submit() {
            const validation = await this.validate(true);
            if (!validation.valid) {
                throw new FormValidationError(validation.result);
            }
            try {
                const data = this.serialize();
                const response = await this.config.submit(data, this.original);
                this._resetErrors();
                this._applyChanges({
                    ...data,
                    ...response,
                });
            }
            catch (e) {
                if (isFormValidationError(e)) {
                    // Note:
                    // Only props with data present in the error are mutated.
                    // All other prop errors are left as is.
                    this._mutateErrors(e.data.messages);
                    throw e;
                }
                else if (isStringError(e)) {
                    throw e;
                }
                throw new UnexpectedError(e); // TODO Add possible usages of unexpected error instance to doc.
            }
        }
        undo(key) {
            this.props[key].value = this.original[key];
        }
        undoAll() {
            for (const key in this.props) {
                if (!Object.prototype.hasOwnProperty.call(this.props, key)) {
                    continue;
                }
                this.props[key].value = this.original[key];
            }
        }
        hasLocalChanges() {
            for (const key in this.props) {
                if (!Object.prototype.hasOwnProperty.call(this.props, key)) {
                    continue;
                }
                if (this.props[key].value !== this.original[key]) {
                    return true;
                }
            }
            return false;
        }
        serialize(key) {
            const data = {};
            if (key) {
                if (this.original[key] !== this.props[key].value) {
                    data[key] = this.props[key].value;
                }
                return data;
            }
            for (const propKey in this.props) {
                if (!Object.prototype.hasOwnProperty.call(this.props, propKey)) {
                    continue;
                }
                data[propKey] = this.props[propKey].value;
            }
            return data;
        }
        /**
         * Run validation and return results.
         *
         * A prop will only be validated if it is dirty.
         *
         * When a key is given, only that prop is checked if it is dirty.
         * Without a key, all dirty props are checked.
         *
         * When mutate is true, prop errors are mutated for all checked props.
         *
         * @private
         */
        async _internalValidate(mutate = false, key) {
            if (!this.config.validate) {
                return { valid: true };
            }
            const data = this.serialize(key);
            const result = await this.config.validate(data);
            if (!result.valid && mutate) {
                this._mutateErrors(result.result.messages, !key);
            }
            return result;
        }
        /**
         * Mutates all given prop errors in keys.
         *
         * If no error is present in the validation data,
         * it is set to an empty array.
         *
         * @private
         */
        _mutateErrors(validationData, clearAll = true) {
            for (const key in this.props) {
                if (!Object.prototype.hasOwnProperty.call(this.props, key)) {
                    continue;
                }
                if (validationData[key]) {
                    const sluggedErrors = FormValidationError.getFieldErrors(validationData, key);
                    this.props[key].errors = sluggedErrors || [];
                }
                else if (clearAll && this.props[key].errors.length) {
                    this.props[key].errors = [];
                }
            }
        }
        /**
         * Removes all errors from  props
         *
         * @private
         */
        _resetErrors() {
            this._mutateErrors({});
        }
        _applyChanges(data) {
            for (const key in data) {
                const value = data[key];
                this.original[key] = value;
                this.props[key].value = value;
            }
        }
        _buildProps(props) {
            const map = {};
            for (const key in props) {
                if (!Object.prototype.hasOwnProperty.call(props, key)) {
                    continue;
                }
                map[key] = {
                    errors: [],
                    rules: [],
                    value: props[key],
                };
            }
            return map;
        }
    }

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function commonjsRequire (path) {
    	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
    }

    function leapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }

    function checkFalsePositiveDates(dateString = '') {
      if (dateString.length === 10) {
        // massage input to use yyyy-mm-dd format
        // we support yyyy/mm/dd or yyyy.mm.dd
        let normalizedDate = dateString.replace('.', '-').replace('/', '-');
        let parts = normalizedDate.split('-');

        if (parts.length === 3) {
          if (parts[0].length === 4) {
            // yyyy-mm-dd format
            let y = parseInt(parts[0]);
            let m = parseInt(parts[1]);
            let d = parseInt(parts[2]);

            if (m === 2) {
              // return leapYear(y) ? d <= 29 : d <= 28;
              if (leapYear(y)) {
                if (d > 29) {
                  return false;
                }
              } else {
                if (d > 28) {
                  return false;
                }
              }
            }

            if (m === 4 || m === 6 || m === 9 || m === 11) {
              if (d > 30) {
                return false;
              }
            }
          }
        }

        return true; // we are not in feburary, proceed
      }

      return true; // we are not testing formatted date, proceed to rest of validation
    }

    function isValidDate(dateString) {
      let testDate;

      if (typeof dateString === 'number') {
        testDate = new Date(dateString);

        if (typeof testDate === 'object') {
          return true;
        }
      } // first convert incoming string to date object and see if it correct date and format


      testDate = new Date(dateString);

      if (typeof testDate === 'object') {
        if (testDate.toString() === 'Invalid Date') {
          return false;
        }
        /**
         * Check for false positive dates
         * perform special check on february as JS `new Date` incorrectly returns valid date
         * Eg.  let newDate = new Date('2020-02-29')  // returns as March 02 2020
         * Eg.  let newDate = new Date('2019-02-29')  // returns as March 01 2020
         * Eg.  let newDate = new Date('2019-04-31')  // returns as April 30 2020
         */


        if (!checkFalsePositiveDates(dateString)) {
          return false;
        } // valid date object and not a february date


        return true;
      } // First check for the pattern


      var regex_date = /^\d{4}\-\d{1,2}\-\d{1,2}$/;

      if (!regex_date.test(dateString)) {
        return false;
      } // Parse the date parts to integers


      var parts = dateString.split("-");
      var day = parseInt(parts[2], 10);
      var month = parseInt(parts[1], 10);
      var year = parseInt(parts[0], 10); // Check the ranges of month and year

      if (year < 1000 || year > 3000 || month == 0 || month > 12) {
        return false;
      }

      var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // Adjust for leap years

      if (year % 400 == 0 || year % 100 != 0 && year % 4 == 0) {
        monthLength[1] = 29;
      } // Check the range of the day


      return day > 0 && day <= monthLength[month - 1];
    }

    var rules = {
      required: function (val) {
        var str;

        if (val === undefined || val === null) {
          return false;
        }

        str = String(val).replace(/\s/g, "");
        return str.length > 0 ? true : false;
      },
      required_if: function (val, req, attribute) {
        req = this.getParameters();

        if (this.validator._objectPath(this.validator.input, req[0]) === req[1]) {
          return this.validator.getRule("required").validate(val);
        }

        return true;
      },
      required_unless: function (val, req, attribute) {
        req = this.getParameters();

        if (this.validator._objectPath(this.validator.input, req[0]) !== req[1]) {
          return this.validator.getRule("required").validate(val);
        }

        return true;
      },
      required_with: function (val, req, attribute) {
        if (this.validator._objectPath(this.validator.input, req)) {
          return this.validator.getRule("required").validate(val);
        }

        return true;
      },
      required_with_all: function (val, req, attribute) {
        req = this.getParameters();

        for (var i = 0; i < req.length; i++) {
          if (!this.validator._objectPath(this.validator.input, req[i])) {
            return true;
          }
        }

        return this.validator.getRule("required").validate(val);
      },
      required_without: function (val, req, attribute) {
        if (this.validator._objectPath(this.validator.input, req)) {
          return true;
        }

        return this.validator.getRule("required").validate(val);
      },
      required_without_all: function (val, req, attribute) {
        req = this.getParameters();

        for (var i = 0; i < req.length; i++) {
          if (this.validator._objectPath(this.validator.input, req[i])) {
            return true;
          }
        }

        return this.validator.getRule("required").validate(val);
      },
      boolean: function (val) {
        return val === true || val === false || val === 0 || val === 1 || val === "0" || val === "1" || val === "true" || val === "false";
      },
      // compares the size of strings
      // with numbers, compares the value
      size: function (val, req, attribute) {
        if (val) {
          req = parseFloat(req);
          var size = this.getSize();
          return size === req;
        }

        return true;
      },
      string: function (val, req, attribute) {
        return typeof val === "string";
      },
      sometimes: function (val) {
        return true;
      },

      /**
       * Compares the size of strings or the value of numbers if there is a truthy value
       */
      min: function (val, req, attribute) {
        var size = this.getSize();
        return size >= req;
      },

      /**
       * Compares the size of strings or the value of numbers if there is a truthy value
       */
      max: function (val, req, attribute) {
        var size = this.getSize();
        return size <= req;
      },
      between: function (val, req, attribute) {
        req = this.getParameters();
        var size = this.getSize();
        var min = parseFloat(req[0], 10);
        var max = parseFloat(req[1], 10);
        return size >= min && size <= max;
      },
      email: function (val) {
        // Added umlaut support https://github.com/skaterdav85/validatorjs/issues/308
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!re.test(val)) {
          // added support domain 3-n level https://github.com/skaterdav85/validatorjs/issues/384
          re = /^((?:[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]|[^\u0000-\u007F])+@(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?(?:\.(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:(?:[a-zA-Z0-9-]|[^\u0000-\u007F]){0,61}(?:[a-zA-Z0-9]|[^\u0000-\u007F]))?)+)*$/;
        }

        return re.test(val);
      },
      numeric: function (val) {
        var num;
        num = Number(val); // tries to convert value to a number. useful if value is coming from form element

        if (typeof num === "number" && !isNaN(num) && typeof val !== "boolean") {
          return true;
        } else {
          return false;
        }
      },
      array: function (val) {
        return val instanceof Array;
      },
      url: function (url) {
        return /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&/=]*)/i.test(url);
      },
      alpha: function (val) {
        return /^[a-zA-Z]+$/.test(val);
      },
      alpha_dash: function (val) {
        return /^[a-zA-Z0-9_\-]+$/.test(val);
      },
      alpha_num: function (val) {
        return /^[a-zA-Z0-9]+$/.test(val);
      },
      same: function (val, req) {
        var val1 = this.validator._flattenObject(this.validator.input)[req];

        var val2 = val;

        if (val1 === val2) {
          return true;
        }

        return false;
      },
      different: function (val, req) {
        var val1 = this.validator._flattenObject(this.validator.input)[req];

        var val2 = val;

        if (val1 !== val2) {
          return true;
        }

        return false;
      },
      in: function (val, req) {
        var list, i;

        if (val) {
          list = this.getParameters();
        }

        if (val && !(val instanceof Array)) {
          var localValue = val;

          for (i = 0; i < list.length; i++) {
            if (typeof list[i] === "string") {
              localValue = String(val);
            }

            if (localValue === list[i]) {
              return true;
            }
          }

          return false;
        }

        if (val && val instanceof Array) {
          for (i = 0; i < val.length; i++) {
            if (list.indexOf(val[i]) < 0) {
              return false;
            }
          }
        }

        return true;
      },
      not_in: function (val, req) {
        var list = this.getParameters();
        var len = list.length;
        var returnVal = true;

        for (var i = 0; i < len; i++) {
          var localValue = val;

          if (typeof list[i] === "string") {
            localValue = String(val);
          }

          if (localValue === list[i]) {
            returnVal = false;
            break;
          }
        }

        return returnVal;
      },
      accepted: function (val) {
        if (val === "on" || val === "yes" || val === 1 || val === "1" || val === true) {
          return true;
        }

        return false;
      },
      confirmed: function (val, req, key) {
        var confirmedKey = key + "_confirmation";

        if (this.validator.input[confirmedKey] === val) {
          return true;
        }

        return false;
      },
      integer: function (val) {
        return String(parseInt(val, 10)) === String(val);
      },
      digits: function (val, req) {
        var numericRule = this.validator.getRule('numeric');

        if (numericRule.validate(val) && String(val.trim()).length === parseInt(req)) {
          return true;
        }

        return false;
      },
      digits_between: function (val) {
        var numericRule = this.validator.getRule("numeric");
        var req = this.getParameters();
        var valueDigitsCount = String(val).length;
        var min = parseFloat(req[0], 10);
        var max = parseFloat(req[1], 10);

        if (numericRule.validate(val) && valueDigitsCount >= min && valueDigitsCount <= max) {
          return true;
        }

        return false;
      },
      regex: function (val, req) {
        var mod = /[g|i|m]{1,3}$/;
        var flag = req.match(mod);
        flag = flag ? flag[0] : "";
        req = req.replace(mod, "").slice(1, -1);
        req = new RegExp(req, flag);
        return !!req.test(val);
      },
      date: function (val, format) {
        return isValidDate(val);
      },
      present: function (val) {
        return typeof val !== "undefined";
      },
      after: function (val, req) {
        var val1 = this.validator.input[req];
        var val2 = val;

        if (!isValidDate(val1)) {
          return false;
        }

        if (!isValidDate(val2)) {
          return false;
        }

        if (new Date(val1).getTime() < new Date(val2).getTime()) {
          return true;
        }

        return false;
      },
      after_or_equal: function (val, req) {
        var val1 = this.validator.input[req];
        var val2 = val;

        if (!isValidDate(val1)) {
          return false;
        }

        if (!isValidDate(val2)) {
          return false;
        }

        if (new Date(val1).getTime() <= new Date(val2).getTime()) {
          return true;
        }

        return false;
      },
      before: function (val, req) {
        var val1 = this.validator.input[req];
        var val2 = val;

        if (!isValidDate(val1)) {
          return false;
        }

        if (!isValidDate(val2)) {
          return false;
        }

        if (new Date(val1).getTime() > new Date(val2).getTime()) {
          return true;
        }

        return false;
      },
      before_or_equal: function (val, req) {
        var val1 = this.validator.input[req];
        var val2 = val;

        if (!isValidDate(val1)) {
          return false;
        }

        if (!isValidDate(val2)) {
          return false;
        }

        if (new Date(val1).getTime() >= new Date(val2).getTime()) {
          return true;
        }

        return false;
      },
      hex: function (val) {
        return /^[0-9a-f]+$/i.test(val);
      },
      ipv4: function (val, req, attribute) {
        if (typeof val != 'string') return false; // regex to check that each octet is valid

        var er = /^[0-9]+$/; // ipv4 octets are delimited by dot

        octets = val.split('.'); // check 1: ipv4 address should contains 4 octets

        if (octets.length != 4) return false;

        for (let i = 0; i < octets.length; i++) {
          const element = octets[i]; // check 2: each octet should be integer bigger than 0

          if (!er.test(element)) return false; // check 3: each octet value should be less than 256

          var octetValue = parseInt(element);
          if (octetValue >= 256) return false;
        } // if all checks passed, we know it's valid IPv4 address!


        return true;
      },
      ipv6: function (val, req, attribute) {
        if (typeof val != 'string') return false; // regex to check that each hextet is valid

        var er = /^[0-9a-f]+$/; // ipv6 hextets are delimited by colon

        hextets = val.split(':'); // check 1: ipv6 should contain only one consecutive colons

        colons = val.match(/::/);
        if (colons != null && val.match(/::/g).length > 1) return false; // check 2: ipv6 should not be ending or starting with colon
        //          edge case: not with consecutive colons

        if (val[0] == ':' && (colons == null || colons != null && colons.index != 0)) return false;
        if (val[val.length - 1] == ':' && (colons == null || colons != null && colons.index != val.length - 2)) return false; // check 3: ipv6 should contain no less than 3 sector
        //         minimum ipv6 addres - ::1

        if (3 > hextets.length) return false; // check 4: ipv6 should contain no more than 8 sectors
        //         only 1 edge case: when first or last sector is ommited

        var isEdgeCase = hextets.length == 9 && colons != null && (colons.index == 0 || colons.index == val.length - 2);
        if (hextets.length > 8 && !isEdgeCase) return false; // check 5: ipv6 should contain exactly one consecutive colons if it has less than 8 sectors

        if (hextets.length != 8 && colons == null) return false;

        for (let i = 0; i < hextets.length; i++) {
          const element = hextets[i];
          if (element.length == 0) continue; // check 6: all of hextets should contain numbers from 0 to f (in hexadecimal)

          if (!er.test(element)) return false; // check 7: all of hextet values should be less then ffff (in hexadeimal)
          //          checking using length of hextet. lowest invalid value's length is 5.
          //          so all valid hextets are length of 4 or less

          if (element.length > 4) return false;
        }

        return true;
      },
      ip: function (val, req, attribute) {
        return rules['ipv4'](val, req, attribute) || rules['ipv6'](val, req, attribute);
      }
    };

    var missedRuleValidator = function () {
      throw new Error("Validator `" + this.name + "` is not defined!");
    };

    var missedRuleMessage;

    function Rule(name, fn, async) {
      this.name = name;
      this.fn = fn;
      this.passes = null;
      this._customMessage = undefined;
      this.async = async;
    }

    Rule.prototype = {
      /**
       * Validate rule
       *
       * @param  {mixed} inputValue
       * @param  {mixed} ruleValue
       * @param  {string} attribute
       * @param  {function} callback
       * @return {boolean|undefined}
       */
      validate: function (inputValue, ruleValue, attribute, callback) {
        var _this = this;

        this._setValidatingData(attribute, inputValue, ruleValue);

        if (typeof callback === "function") {
          this.callback = callback;

          var handleResponse = function (passes, message) {
            _this.response(passes, message);
          };

          if (this.async) {
            return this._apply(inputValue, ruleValue, attribute, handleResponse);
          } else {
            return handleResponse(this._apply(inputValue, ruleValue, attribute));
          }
        }

        return this._apply(inputValue, ruleValue, attribute);
      },

      /**
       * Apply validation function
       *
       * @param  {mixed} inputValue
       * @param  {mixed} ruleValue
       * @param  {string} attribute
       * @param  {function} callback
       * @return {boolean|undefined}
       */
      _apply: function (inputValue, ruleValue, attribute, callback) {
        var fn = this.isMissed() ? missedRuleValidator : this.fn;
        return fn.apply(this, [inputValue, ruleValue, attribute, callback]);
      },

      /**
       * Set validating data
       *
       * @param {string} attribute
       * @param {mixed} inputValue
       * @param {mixed} ruleValue
       * @return {void}
       */
      _setValidatingData: function (attribute, inputValue, ruleValue) {
        this.attribute = attribute;
        this.inputValue = inputValue;
        this.ruleValue = ruleValue;
      },

      /**
       * Get parameters
       *
       * @return {array}
       */
      getParameters: function () {
        var value = [];

        if (typeof this.ruleValue === "string") {
          value = this.ruleValue.split(",");
        }

        if (typeof this.ruleValue === "number") {
          value.push(this.ruleValue);
        }

        if (this.ruleValue instanceof Array) {
          value = this.ruleValue;
        }

        return value;
      },

      /**
       * Get true size of value
       *
       * @return {integer|float}
       */
      getSize: function () {
        var value = this.inputValue;

        if (value instanceof Array) {
          return value.length;
        }

        if (typeof value === "number") {
          return value;
        }

        if (this.validator._hasNumericRule(this.attribute)) {
          return parseFloat(value, 10);
        }

        return value.length;
      },

      /**
       * Get the type of value being checked; numeric or string.
       *
       * @return {string}
       */
      _getValueType: function () {
        if (typeof this.inputValue === "number" || this.validator._hasNumericRule(this.attribute)) {
          return "numeric";
        }

        return "string";
      },

      /**
       * Set the async callback response
       *
       * @param  {boolean|undefined} passes  Whether validation passed
       * @param  {string|undefined} message Custom error message
       * @return {void}
       */
      response: function (passes, message) {
        this.passes = passes === undefined || passes === true;
        this._customMessage = message;
        this.callback(this.passes, message);
      },

      /**
       * Set validator instance
       *
       * @param {Validator} validator
       * @return {void}
       */
      setValidator: function (validator) {
        this.validator = validator;
      },

      /**
       * Check if rule is missed
       *
       * @return {boolean}
       */
      isMissed: function () {
        return typeof this.fn !== "function";
      },

      get customMessage() {
        return this.isMissed() ? missedRuleMessage : this._customMessage;
      }

    };
    var manager = {
      /**
       * List of async rule names
       *
       * @type {Array}
       */
      asyncRules: [],

      /**
       * Implicit rules (rules to always validate)
       *
       * @type {Array}
       */
      implicitRules: ["required", "required_if", "required_unless", "required_with", "required_with_all", "required_without", "required_without_all", "accepted", "present"],

      /**
       * Get rule by name
       *
       * @param  {string} name
       * @param {Validator}
       * @return {Rule}
       */
      make: function (name, validator) {
        var async = this.isAsync(name);
        var rule = new Rule(name, rules[name], async);
        rule.setValidator(validator);
        return rule;
      },

      /**
       * Determine if given rule is async
       *
       * @param  {string}  name
       * @return {boolean}
       */
      isAsync: function (name) {
        for (var i = 0, len = this.asyncRules.length; i < len; i++) {
          if (this.asyncRules[i] === name) {
            return true;
          }
        }

        return false;
      },

      /**
       * Determine if rule is implicit (should always validate)
       *
       * @param {string} name
       * @return {boolean}
       */
      isImplicit: function (name) {
        return this.implicitRules.indexOf(name) > -1;
      },

      /**
       * Register new rule
       *
       * @param  {string}   name
       * @param  {function} fn
       * @return {void}
       */
      register: function (name, fn) {
        rules[name] = fn;
      },

      /**
       * Register new implicit rule
       *
       * @param  {string}   name
       * @param  {function} fn
       * @return {void}
       */
      registerImplicit: function (name, fn) {
        this.register(name, fn);
        this.implicitRules.push(name);
      },

      /**
       * Register async rule
       *
       * @param  {string}   name
       * @param  {function} fn
       * @return {void}
       */
      registerAsync: function (name, fn) {
        this.register(name, fn);
        this.asyncRules.push(name);
      },

      /**
       * Register implicit async rule
       *
       * @param  {string}   name
       * @param  {function} fn
       * @return {void}
       */
      registerAsyncImplicit: function (name, fn) {
        this.registerImplicit(name, fn);
        this.asyncRules.push(name);
      },
      registerMissedRuleValidator: function (fn, message) {
        missedRuleValidator = fn;
        missedRuleMessage = message;
      }
    };
    var rules_1 = manager;

    var replacements = {
      /**
       * Between replacement (replaces :min and :max)
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      between: function (template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          min: parameters[0],
          max: parameters[1]
        });
      },

      /**
       * Digits-Between replacement (replaces :min and :max)
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      digits_between: function (template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          min: parameters[0],
          max: parameters[1]
        });
      },

      /**
       * Required_if replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      required_if: function (template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          other: this._getAttributeName(parameters[0]),
          value: parameters[1]
        });
      },

      /**
       * Required_unless replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      required_unless: function (template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          other: this._getAttributeName(parameters[0]),
          value: parameters[1]
        });
      },

      /**
       * Required_with replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      required_with: function (template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          field: this._getAttributeName(parameters[0])
        });
      },

      /**
       * Required_with_all replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      required_with_all: function (template, rule) {
        var parameters = rule.getParameters();

        var getAttributeName = this._getAttributeName.bind(this);

        return this._replacePlaceholders(rule, template, {
          fields: parameters.map(getAttributeName).join(', ')
        });
      },

      /**
       * Required_without replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      required_without: function (template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          field: this._getAttributeName(parameters[0])
        });
      },

      /**
       * Required_without_all replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      required_without_all: function (template, rule) {
        var parameters = rule.getParameters();

        var getAttributeName = this._getAttributeName.bind(this);

        return this._replacePlaceholders(rule, template, {
          fields: parameters.map(getAttributeName).join(', ')
        });
      },

      /**
       * After replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      after: function (template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          after: this._getAttributeName(parameters[0])
        });
      },

      /**
       * Before replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      before: function (template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          before: this._getAttributeName(parameters[0])
        });
      },

      /**
       * After_or_equal replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      after_or_equal: function (template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          after_or_equal: this._getAttributeName(parameters[0])
        });
      },

      /**
       * Before_or_equal replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      before_or_equal: function (template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          before_or_equal: this._getAttributeName(parameters[0])
        });
      },

      /**
       * Same replacement.
       *
       * @param  {string} template
       * @param  {Rule} rule
       * @return {string}
       */
      same: function (template, rule) {
        var parameters = rule.getParameters();
        return this._replacePlaceholders(rule, template, {
          same: this._getAttributeName(parameters[0])
        });
      }
    };

    function formatter(attribute) {
      return attribute.replace(/[_\[]/g, ' ').replace(/]/g, '');
    }

    var attributes = {
      replacements: replacements,
      formatter: formatter
    };

    var Attributes$1 = attributes;

    var Messages$1 = function (lang, messages) {
      this.lang = lang;
      this.messages = messages;
      this.customMessages = {};
      this.attributeNames = {};
    };

    Messages$1.prototype = {
      constructor: Messages$1,

      /**
       * Set custom messages
       *
       * @param {object} customMessages
       * @return {void}
       */
      _setCustom: function (customMessages) {
        this.customMessages = customMessages || {};
      },

      /**
       * Set custom attribute names.
       *
       * @param {object} attributes
       */
      _setAttributeNames: function (attributes) {
        this.attributeNames = attributes;
      },

      /**
       * Set the attribute formatter.
       *
       * @param {fuction} func
       * @return {void}
       */
      _setAttributeFormatter: function (func) {
        this.attributeFormatter = func;
      },

      /**
       * Get attribute name to display.
       *
       * @param  {string} attribute
       * @return {string}
       */
      _getAttributeName: function (attribute) {
        var name = attribute;

        if (this.attributeNames.hasOwnProperty(attribute)) {
          return this.attributeNames[attribute];
        } else if (this.messages.attributes.hasOwnProperty(attribute)) {
          name = this.messages.attributes[attribute];
        }

        if (this.attributeFormatter) {
          name = this.attributeFormatter(name);
        }

        return name;
      },

      /**
       * Get all messages
       *
       * @return {object}
       */
      all: function () {
        return this.messages;
      },

      /**
       * Render message
       *
       * @param  {Rule} rule
       * @return {string}
       */
      render: function (rule) {
        if (rule.customMessage) {
          return rule.customMessage;
        }

        var template = this._getTemplate(rule);

        var message;

        if (Attributes$1.replacements[rule.name]) {
          message = Attributes$1.replacements[rule.name].apply(this, [template, rule]);
        } else {
          message = this._replacePlaceholders(rule, template, {});
        }

        return message;
      },

      /**
       * Get the template to use for given rule
       *
       * @param  {Rule} rule
       * @return {string}
       */
      _getTemplate: function (rule) {
        var messages = this.messages;
        var template = messages.def;
        var customMessages = this.customMessages;
        var formats = [rule.name + '.' + rule.attribute, rule.name];

        for (var i = 0, format; i < formats.length; i++) {
          format = formats[i];

          if (customMessages.hasOwnProperty(format)) {
            template = customMessages[format];
            break;
          } else if (messages.hasOwnProperty(format)) {
            template = messages[format];
            break;
          }
        }

        if (typeof template === 'object') {
          template = template[rule._getValueType()];
        }

        return template;
      },

      /**
       * Replace placeholders in the template using the data object
       *
       * @param  {Rule} rule
       * @param  {string} template
       * @param  {object} data
       * @return {string}
       */
      _replacePlaceholders: function (rule, template, data) {
        var message, attribute;
        data.attribute = this._getAttributeName(rule.attribute);
        data[rule.name] = data[rule.name] || rule.getParameters().join(',');

        if (typeof template === 'string' && typeof data === 'object') {
          message = template;

          for (attribute in data) {
            message = message.replace(new RegExp(':' + attribute, 'g'), data[attribute]);
          }
        }

        return message;
      }
    };
    var messages = Messages$1;

    var en = {
      accepted: 'The :attribute must be accepted.',
      after: 'The :attribute must be after :after.',
      after_or_equal: 'The :attribute must be equal or after :after_or_equal.',
      alpha: 'The :attribute field must contain only alphabetic characters.',
      alpha_dash: 'The :attribute field may only contain alpha-numeric characters, as well as dashes and underscores.',
      alpha_num: 'The :attribute field must be alphanumeric.',
      before: 'The :attribute must be before :before.',
      before_or_equal: 'The :attribute must be equal or before :before_or_equal.',
      between: {
        numeric: 'The :attribute field must be between :min and :max.',
        string: 'The :attribute field must be between :min and :max characters.'
      },
      confirmed: 'The :attribute confirmation does not match.',
      email: 'The :attribute format is invalid.',
      date: 'The :attribute is not a valid date format.',
      def: 'The :attribute attribute has errors.',
      digits: 'The :attribute must be :digits digits.',
      digits_between: 'The :attribute field must be between :min and :max digits.',
      different: 'The :attribute and :different must be different.',
      in: 'The selected :attribute is invalid.',
      integer: 'The :attribute must be an integer.',
      hex: 'The :attribute field should have hexadecimal format',
      min: {
        numeric: 'The :attribute must be at least :min.',
        string: 'The :attribute must be at least :min characters.'
      },
      max: {
        numeric: 'The :attribute may not be greater than :max.',
        string: 'The :attribute may not be greater than :max characters.'
      },
      not_in: 'The selected :attribute is invalid.',
      numeric: 'The :attribute must be a number.',
      present: 'The :attribute field must be present (but can be empty).',
      required: 'The :attribute field is required.',
      required_if: 'The :attribute field is required when :other is :value.',
      required_unless: 'The :attribute field is required when :other is not :value.',
      required_with: 'The :attribute field is required when :field is not empty.',
      required_with_all: 'The :attribute field is required when :fields are not empty.',
      required_without: 'The :attribute field is required when :field is empty.',
      required_without_all: 'The :attribute field is required when :fields are empty.',
      same: 'The :attribute and :same fields must match.',
      size: {
        numeric: 'The :attribute must be :size.',
        string: 'The :attribute must be :size characters.'
      },
      string: 'The :attribute must be a string.',
      url: 'The :attribute format is invalid.',
      regex: 'The :attribute format is invalid.',
      attributes: {}
    };

    var Messages = messages;
    var require_method = commonjsRequire;
    var container = {
      messages: {},

      /**
       * Set messages for language
       *
       * @param {string} lang
       * @param {object} rawMessages
       * @return {void}
       */
      _set: function (lang, rawMessages) {
        this.messages[lang] = rawMessages;
      },

      /**
       * Set message for given language's rule.
       *
       * @param {string} lang
       * @param {string} attribute
       * @param {string|object} message
       * @return {void}
       */
      _setRuleMessage: function (lang, attribute, message) {
        this._load(lang);

        if (message === undefined) {
          message = this.messages[lang].def;
        }

        this.messages[lang][attribute] = message;
      },

      /**
       * Load messages (if not already loaded)
       *
       * @param  {string} lang
       * @return {void}
       */
      _load: function (lang) {
        if (!this.messages[lang]) {
          try {
            var rawMessages = require_method('./lang/' + lang);

            this._set(lang, rawMessages);
          } catch (e) {}
        }
      },

      /**
       * Get raw messages for language
       *
       * @param  {string} lang
       * @return {object}
       */
      _get: function (lang) {
        this._load(lang);

        return this.messages[lang];
      },

      /**
       * Make messages for given language
       *
       * @param  {string} lang
       * @return {Messages}
       */
      _make: function (lang) {
        this._load(lang);

        return new Messages(lang, this.messages[lang]);
      }
    };
    var lang = container;

    var Errors$1 = function () {
      this.errors = {};
    };

    Errors$1.prototype = {
      constructor: Errors$1,

      /**
       * Add new error message for given attribute
       *
       * @param  {string} attribute
       * @param  {string} message
       * @return {void}
       */
      add: function (attribute, message) {
        if (!this.has(attribute)) {
          this.errors[attribute] = [];
        }

        if (this.errors[attribute].indexOf(message) === -1) {
          this.errors[attribute].push(message);
        }
      },

      /**
       * Returns an array of error messages for an attribute, or an empty array
       *
       * @param  {string} attribute A key in the data object being validated
       * @return {array} An array of error messages
       */
      get: function (attribute) {
        if (this.has(attribute)) {
          return this.errors[attribute];
        }

        return [];
      },

      /**
       * Returns the first error message for an attribute, false otherwise
       *
       * @param  {string} attribute A key in the data object being validated
       * @return {string|false} First error message or false
       */
      first: function (attribute) {
        if (this.has(attribute)) {
          return this.errors[attribute][0];
        }

        return false;
      },

      /**
       * Get all error messages from all failing attributes
       *
       * @return {Object} Failed attribute names for keys and an array of messages for values
       */
      all: function () {
        return this.errors;
      },

      /**
       * Determine if there are any error messages for an attribute
       *
       * @param  {string}  attribute A key in the data object being validated
       * @return {boolean}
       */
      has: function (attribute) {
        if (this.errors.hasOwnProperty(attribute)) {
          return true;
        }

        return false;
      }
    };
    var errors = Errors$1;

    function AsyncResolvers$1(onFailedOne, onResolvedAll) {
      this.onResolvedAll = onResolvedAll;
      this.onFailedOne = onFailedOne;
      this.resolvers = {};
      this.resolversCount = 0;
      this.passed = [];
      this.failed = [];
      this.firing = false;
    }

    AsyncResolvers$1.prototype = {
      /**
       * Add resolver
       *
       * @param {Rule} rule
       * @return {integer}
       */
      add: function (rule) {
        var index = this.resolversCount;
        this.resolvers[index] = rule;
        this.resolversCount++;
        return index;
      },

      /**
       * Resolve given index
       *
       * @param  {integer} index
       * @return {void}
       */
      resolve: function (index) {
        var rule = this.resolvers[index];

        if (rule.passes === true) {
          this.passed.push(rule);
        } else if (rule.passes === false) {
          this.failed.push(rule);
          this.onFailedOne(rule);
        }

        this.fire();
      },

      /**
       * Determine if all have been resolved
       *
       * @return {boolean}
       */
      isAllResolved: function () {
        return this.passed.length + this.failed.length === this.resolversCount;
      },

      /**
       * Attempt to fire final all resolved callback if completed
       *
       * @return {void}
       */
      fire: function () {
        if (!this.firing) {
          return;
        }

        if (this.isAllResolved()) {
          this.onResolvedAll(this.failed.length === 0);
        }
      },

      /**
       * Enable firing
       *
       * @return {void}
       */
      enableFiring: function () {
        this.firing = true;
      }
    };
    var async = AsyncResolvers$1;

    var Rules$1 = rules_1;
    var Lang = lang;
    var Errors = errors;
    var Attributes = attributes;
    var AsyncResolvers = async;

    var Validator = function (input, rules, customMessages) {
      var lang = Validator.getDefaultLang();
      this.input = input || {};
      this.messages = Lang._make(lang);

      this.messages._setCustom(customMessages);

      this.setAttributeFormatter(Validator.prototype.attributeFormatter);
      this.errors = new Errors();
      this.errorCount = 0;
      this.hasAsync = false;
      this.rules = this._parseRules(rules);
    };

    Validator.prototype = {
      constructor: Validator,

      /**
       * Default language
       *
       * @type {string}
       */
      lang: 'en',

      /**
       * Numeric based rules
       *
       * @type {array}
       */
      numericRules: ['integer', 'numeric'],

      /**
       * Attribute formatter.
       *
       * @type {function}
       */
      attributeFormatter: Attributes.formatter,

      /**
       * Run validator
       *
       * @return {boolean} Whether it passes; true = passes, false = fails
       */
      check: function () {

        for (var attribute in this.rules) {
          var attributeRules = this.rules[attribute];

          var inputValue = this._objectPath(this.input, attribute);

          if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
            continue;
          }

          for (var i = 0, len = attributeRules.length, rule, ruleOptions, rulePassed; i < len; i++) {
            ruleOptions = attributeRules[i];
            rule = this.getRule(ruleOptions.name);

            if (!this._isValidatable(rule, inputValue)) {
              continue;
            }

            rulePassed = rule.validate(inputValue, ruleOptions.value, attribute);

            if (!rulePassed) {
              this._addFailure(rule);
            }

            if (this._shouldStopValidating(attribute, rulePassed)) {
              break;
            }
          }
        }

        return this.errorCount === 0;
      },

      /**
       * Run async validator
       *
       * @param {function} passes
       * @param {function} fails
       * @return {void}
       */
      checkAsync: function (passes, fails) {
        var _this = this;

        passes = passes || function () {};

        fails = fails || function () {};

        var failsOne = function (rule, message) {
          _this._addFailure(rule, message);
        };

        var resolvedAll = function (allPassed) {
          if (allPassed) {
            passes();
          } else {
            fails();
          }
        };

        var asyncResolvers = new AsyncResolvers(failsOne, resolvedAll);

        var validateRule = function (inputValue, ruleOptions, attribute, rule) {
          return function () {
            var resolverIndex = asyncResolvers.add(rule);
            rule.validate(inputValue, ruleOptions.value, attribute, function () {
              asyncResolvers.resolve(resolverIndex);
            });
          };
        };

        for (var attribute in this.rules) {
          var attributeRules = this.rules[attribute];

          var inputValue = this._objectPath(this.input, attribute);

          if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
            continue;
          }

          for (var i = 0, len = attributeRules.length, rule, ruleOptions; i < len; i++) {
            ruleOptions = attributeRules[i];
            rule = this.getRule(ruleOptions.name);

            if (!this._isValidatable(rule, inputValue)) {
              continue;
            }

            validateRule(inputValue, ruleOptions, attribute, rule)();
          }
        }

        asyncResolvers.enableFiring();
        asyncResolvers.fire();
      },

      /**
       * Add failure and error message for given rule
       *
       * @param {Rule} rule
       */
      _addFailure: function (rule) {
        var msg = this.messages.render(rule);
        this.errors.add(rule.attribute, msg);
        this.errorCount++;
      },

      /**
       * Flatten nested object, normalizing { foo: { bar: 1 } } into: { 'foo.bar': 1 }
       *
       * @param  {object} nested object
       * @return {object} flattened object
       */
      _flattenObject: function (obj) {
        var flattened = {};

        function recurse(current, property) {
          if (!property && Object.getOwnPropertyNames(current).length === 0) {
            return;
          }

          if (Object(current) !== current || Array.isArray(current)) {
            flattened[property] = current;
          } else {
            var isEmpty = true;

            for (var p in current) {
              isEmpty = false;
              recurse(current[p], property ? property + '.' + p : p);
            }

            if (isEmpty) {
              flattened[property] = {};
            }
          }
        }

        if (obj) {
          recurse(obj);
        }

        return flattened;
      },

      /**
       * Extract value from nested object using string path with dot notation
       *
       * @param  {object} object to search in
       * @param  {string} path inside object
       * @return {any|void} value under the path
       */
      _objectPath: function (obj, path) {
        if (Object.prototype.hasOwnProperty.call(obj, path)) {
          return obj[path];
        }

        var keys = path.replace(/\[(\w+)\]/g, '.$1').replace(/^\./, '').split('.');
        var copy = {};

        for (var attr in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, attr)) {
            copy[attr] = obj[attr];
          }
        }

        for (var i = 0, l = keys.length; i < l; i++) {
          if (typeof copy === 'object' && copy !== null && Object.hasOwnProperty.call(copy, keys[i])) {
            copy = copy[keys[i]];
          } else {
            return;
          }
        }

        return copy;
      },

      /**
       * Parse rules, normalizing format into: { attribute: [{ name: 'age', value: 3 }] }
       *
       * @param  {object} rules
       * @return {object}
       */
      _parseRules: function (rules) {
        var parsedRules = {};
        rules = this._flattenObject(rules);

        for (var attribute in rules) {
          var rulesArray = rules[attribute];

          this._parseRulesCheck(attribute, rulesArray, parsedRules);
        }

        return parsedRules;
      },
      _parseRulesCheck: function (attribute, rulesArray, parsedRules, wildCardValues) {
        if (attribute.indexOf('*') > -1) {
          this._parsedRulesRecurse(attribute, rulesArray, parsedRules, wildCardValues);
        } else {
          this._parseRulesDefault(attribute, rulesArray, parsedRules, wildCardValues);
        }
      },
      _parsedRulesRecurse: function (attribute, rulesArray, parsedRules, wildCardValues) {
        var parentPath = attribute.substr(0, attribute.indexOf('*') - 1);

        var propertyValue = this._objectPath(this.input, parentPath);

        if (propertyValue) {
          for (var propertyNumber = 0; propertyNumber < propertyValue.length; propertyNumber++) {
            var workingValues = wildCardValues ? wildCardValues.slice() : [];
            workingValues.push(propertyNumber);

            this._parseRulesCheck(attribute.replace('*', propertyNumber), rulesArray, parsedRules, workingValues);
          }
        }
      },
      _parseRulesDefault: function (attribute, rulesArray, parsedRules, wildCardValues) {
        var attributeRules = [];

        if (rulesArray instanceof Array) {
          rulesArray = this._prepareRulesArray(rulesArray);
        }

        if (typeof rulesArray === 'string') {
          rulesArray = rulesArray.split('|');
        }

        for (var i = 0, len = rulesArray.length, rule; i < len; i++) {
          rule = typeof rulesArray[i] === 'string' ? this._extractRuleAndRuleValue(rulesArray[i]) : rulesArray[i];

          if (rule.value) {
            rule.value = this._replaceWildCards(rule.value, wildCardValues);

            this._replaceWildCardsMessages(wildCardValues);
          }

          if (Rules$1.isAsync(rule.name)) {
            this.hasAsync = true;
          }

          attributeRules.push(rule);
        }

        parsedRules[attribute] = attributeRules;
      },
      _replaceWildCards: function (path, nums) {
        if (!nums) {
          return path;
        }

        var path2 = path;
        nums.forEach(function (value) {
          if (Array.isArray(path2)) {
            path2 = path2[0];
          }

          const pos = path2.indexOf('*');

          if (pos === -1) {
            return path2;
          }

          path2 = path2.substr(0, pos) + value + path2.substr(pos + 1);
        });

        if (Array.isArray(path)) {
          path[0] = path2;
          path2 = path;
        }

        return path2;
      },
      _replaceWildCardsMessages: function (nums) {
        var customMessages = this.messages.customMessages;
        var self = this;
        Object.keys(customMessages).forEach(function (key) {
          if (nums) {
            var newKey = self._replaceWildCards(key, nums);

            customMessages[newKey] = customMessages[key];
          }
        });

        this.messages._setCustom(customMessages);
      },

      /**
       * Prepare rules if it comes in Array. Check for objects. Need for type validation.
       *
       * @param  {array} rulesArray
       * @return {array}
       */
      _prepareRulesArray: function (rulesArray) {
        var rules = [];

        for (var i = 0, len = rulesArray.length; i < len; i++) {
          if (typeof rulesArray[i] === 'object') {
            for (var rule in rulesArray[i]) {
              rules.push({
                name: rule,
                value: rulesArray[i][rule]
              });
            }
          } else {
            rules.push(rulesArray[i]);
          }
        }

        return rules;
      },

      /**
       * Determines if the attribute is supplied with the original data object.
       *
       * @param  {array} attribute
       * @return {boolean}
       */
      _suppliedWithData: function (attribute) {
        return this.input.hasOwnProperty(attribute);
      },

      /**
       * Extract a rule and a value from a ruleString (i.e. min:3), rule = min, value = 3
       *
       * @param  {string} ruleString min:3
       * @return {object} object containing the name of the rule and value
       */
      _extractRuleAndRuleValue: function (ruleString) {
        var rule = {},
            ruleArray;
        rule.name = ruleString;

        if (ruleString.indexOf(':') >= 0) {
          ruleArray = ruleString.split(':');
          rule.name = ruleArray[0];
          rule.value = ruleArray.slice(1).join(':');
        }

        return rule;
      },

      /**
       * Determine if attribute has any of the given rules
       *
       * @param  {string}  attribute
       * @param  {array}   findRules
       * @return {boolean}
       */
      _hasRule: function (attribute, findRules) {
        var rules = this.rules[attribute] || [];

        for (var i = 0, len = rules.length; i < len; i++) {
          if (findRules.indexOf(rules[i].name) > -1) {
            return true;
          }
        }

        return false;
      },

      /**
       * Determine if attribute has any numeric-based rules.
       *
       * @param  {string}  attribute
       * @return {Boolean}
       */
      _hasNumericRule: function (attribute) {
        return this._hasRule(attribute, this.numericRules);
      },

      /**
       * Determine if rule is validatable
       *
       * @param  {Rule}   rule
       * @param  {mixed}  value
       * @return {boolean}
       */
      _isValidatable: function (rule, value) {
        if (Array.isArray(value)) {
          return true;
        }

        if (Rules$1.isImplicit(rule.name)) {
          return true;
        }

        return this.getRule('required').validate(value);
      },

      /**
       * Determine if we should stop validating.
       *
       * @param  {string} attribute
       * @param  {boolean} rulePassed
       * @return {boolean}
       */
      _shouldStopValidating: function (attribute, rulePassed) {
        var stopOnAttributes = this.stopOnAttributes;

        if (typeof stopOnAttributes === 'undefined' || stopOnAttributes === false || rulePassed === true) {
          return false;
        }

        if (stopOnAttributes instanceof Array) {
          return stopOnAttributes.indexOf(attribute) > -1;
        }

        return true;
      },

      /**
       * Set custom attribute names.
       *
       * @param {object} attributes
       * @return {void}
       */
      setAttributeNames: function (attributes) {
        this.messages._setAttributeNames(attributes);
      },

      /**
       * Set the attribute formatter.
       *
       * @param {fuction} func
       * @return {void}
       */
      setAttributeFormatter: function (func) {
        this.messages._setAttributeFormatter(func);
      },

      /**
       * Get validation rule
       *
       * @param  {string} name
       * @return {Rule}
       */
      getRule: function (name) {
        return Rules$1.make(name, this);
      },

      /**
       * Stop on first error.
       *
       * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
       * @return {void}
       */
      stopOnError: function (attributes) {
        this.stopOnAttributes = attributes;
      },

      /**
       * Determine if validation passes
       *
       * @param {function} passes
       * @return {boolean|undefined}
       */
      passes: function (passes) {
        var async = this._checkAsync('passes', passes);

        if (async) {
          return this.checkAsync(passes);
        }

        return this.check();
      },

      /**
       * Determine if validation fails
       *
       * @param {function} fails
       * @return {boolean|undefined}
       */
      fails: function (fails) {
        var async = this._checkAsync('fails', fails);

        if (async) {
          return this.checkAsync(function () {}, fails);
        }

        return !this.check();
      },

      /**
       * Check if validation should be called asynchronously
       *
       * @param  {string}   funcName Name of the caller
       * @param  {function} callback
       * @return {boolean}
       */
      _checkAsync: function (funcName, callback) {
        var hasCallback = typeof callback === 'function';

        if (this.hasAsync && !hasCallback) {
          throw funcName + ' expects a callback when async rules are being tested.';
        }

        return this.hasAsync || hasCallback;
      }
    };
    /**
     * Set messages for language
     *
     * @param {string} lang
     * @param {object} messages
     * @return {this}
     */

    Validator.setMessages = function (lang, messages) {
      Lang._set(lang, messages);

      return this;
    };
    /**
     * Get messages for given language
     *
     * @param  {string} lang
     * @return {Messages}
     */


    Validator.getMessages = function (lang) {
      return Lang._get(lang);
    };
    /**
     * Set default language to use
     *
     * @param {string} lang
     * @return {void}
     */


    Validator.useLang = function (lang) {
      this.prototype.lang = lang;
    };
    /**
     * Get default language
     *
     * @return {string}
     */


    Validator.getDefaultLang = function () {
      return this.prototype.lang;
    };
    /**
     * Set the attribute formatter.
     *
     * @param {fuction} func
     * @return {void}
     */


    Validator.setAttributeFormatter = function (func) {
      this.prototype.attributeFormatter = func;
    };
    /**
     * Stop on first error.
     *
     * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
     * @return {void}
     */


    Validator.stopOnError = function (attributes) {
      this.prototype.stopOnAttributes = attributes;
    };
    /**
     * Register custom validation rule
     *
     * @param  {string}   name
     * @param  {function} fn
     * @param  {string}   message
     * @return {void}
     */


    Validator.register = function (name, fn, message, fnReplacement) {
      var lang = Validator.getDefaultLang();
      Rules$1.register(name, fn);

      Lang._setRuleMessage(lang, name, message);
    };
    /**
     * Register custom validation rule
     *
     * @param  {string}   name
     * @param  {function} fn
     * @param  {string}   message
     * @param  {function} fnReplacement
     * @return {void}
     */


    Validator.registerImplicit = function (name, fn, message, fnReplacement) {
      var lang = Validator.getDefaultLang();
      Rules$1.registerImplicit(name, fn);

      Lang._setRuleMessage(lang, name, message);
    };
    /**
     * Register asynchronous validation rule
     *
     * @param  {string}   name
     * @param  {function} fn
     * @param  {string}   message
     * @return {void}
     */


    Validator.registerAsync = function (name, fn, message, fnReplacement) {
      var lang = Validator.getDefaultLang();
      Rules$1.registerAsync(name, fn);

      Lang._setRuleMessage(lang, name, message);
    };
    /**
     * Register asynchronous validation rule
     *
     * @param  {string}   name
     * @param  {function} fn
     * @param  {string}   message
     * @return {void}
     */


    Validator.registerAsyncImplicit = function (name, fn, message) {
      var lang = Validator.getDefaultLang();
      Rules$1.registerAsyncImplicit(name, fn);

      Lang._setRuleMessage(lang, name, message);
    };
    /**
     * Register validator for missed validation rule
     *
     * @param  {string}   name
     * @param  {function} fn
     * @param  {string}   message
     * @return {void}
     */


    Validator.registerMissedRuleValidator = function (fn, message) {
      Rules$1.registerMissedRuleValidator(fn, message);
    };

    var validator$2 = Validator;

    validator$2.setMessages('en', en);
    /**
     * Stub or implement the rules not supported by https://github.com/mikeerickson/validatorjs,
     * but passed to the frontend by https://bitbucket.org/eventix/http/src/master/src/FrontendRules.php
     */
    const unsupportedRules = [
        'active_url',
        'alpha_numeric',
        'date_equals',
        'date_format',
        'distinct',
        'equal_to_or_greater_than',
        'filled',
        'gt',
        'gte',
        'ip',
        'ipv4',
        'ipv6',
        'json',
        'lt',
        'lte',
        'not_regex',
        'nullable',
        'timezone',
    ];
    unsupportedRules.forEach((rule) => {
        validator$2.register(rule, () => true);
    });

    function isCrudApiError(e) {
        if (!e) {
            return false;
        }
        // This type cast is as of yet not valid,
        // BUT this whole method is designed to check this validity,
        // therefore it is expected to assume it will be valid.
        const crudApiError = e;
        return !!crudApiError.response
            && crudApiError.response.status !== undefined
            && Number.isInteger(crudApiError.response.status)
            && crudApiError.response.statusText !== undefined
            && !!crudApiError.response.data
            && crudApiError.response.data.status_code !== undefined
            && crudApiError.response.data.error_description !== undefined;
    }

    function marshalCrudValidationData(data) {
        if (!isCrudApiError(data)) {
            const unexpectedError = new UnexpectedError(data);
            const unexpectedSlug = unexpectedError.toSlug();
            return {
                slug: unexpectedSlug.key,
                data: {
                    ...unexpectedSlug.data,
                    message: unexpectedError.toString(),
                },
                messages: {},
            };
        }
        const slugData = {
            status: data.response.status,
            statusText: data.response.statusText,
            statusCode: data.response.data.status_code,
        };
        if (typeof data.response.data.error_description === 'string') {
            slugData.message = data.response.data.error_description;
        }
        const messages = {};
        let errorDescription = data.response.data.error_description;
        if (typeof errorDescription === 'object') {
            if (typeof errorDescription.message === 'object') {
                errorDescription = errorDescription.message;
            }
            for (const errorDescriptionKey in errorDescription) {
                if (!Object.prototype.hasOwnProperty.call(errorDescription, errorDescriptionKey)) {
                    continue;
                }
                if (typeof errorDescription[errorDescriptionKey] === 'string' || Array.isArray(errorDescription[errorDescriptionKey])) {
                    messages[errorDescriptionKey] = errorDescription[errorDescriptionKey];
                }
            }
        }
        return {
            slug: 'sdkhelpers.crud.errors.validation_error',
            data: slugData,
            messages,
        };
    }
    function isCrudValidationError(e) {
        return e && e._isCrudValidationError;
    }
    class CrudValidationError extends BaseError {
        constructor(data) {
            super(marshalCrudValidationData(data));
            this._isCrudValidationError = true;
        }
        toString() {
            // TODO @Rik.. No clue what to make of this...
            throw new Error('CrudValidationError.toString not yet implemented.');
        }
        toSlug() {
            return {
                key: this.data.slug,
                data: this.data.data,
            };
        }
    }

    class FormValidationResult {
        constructor(data) {
            this.valid = false;
            this._data = data;
        }
        static create(data) {
            if (!data || Object.values(data.messages).every((message) => !message || !message.length)) {
                return this.valid();
            }
            return this.invalid(data);
        }
        static valid() {
            return { valid: true };
        }
        static invalid(data) {
            return new this(data);
        }
        get result() {
            return this._data;
        }
    }

    class ModelForm extends Form {
        constructor(relation, model) {
            super({
                data: model.props,
                submit: (data, original) => this._submit(data, original),
                validate: (data) => this._validate(data),
            });
            this._model = model;
            this._relation = relation;
            if (relation.rules) {
                void relation.rules().then((rules) => {
                    if (!rules) {
                        return;
                    }
                    this._rules = rules;
                    for (const key in rules) {
                        if (!this.props[key]) {
                            // Got rules for undefined prop
                            continue;
                        }
                        this.props[key].rules = rules[key];
                    }
                });
            }
        }
        async _submit(data, original) {
            // Only send props that follow one of the following constraints:
            // - The prop is `required` as implied by its rules
            // - The new value differs from the original value and has therefore changed
            const filteredData = {};
            for (const key in data) {
                if (!Object.prototype.hasOwnProperty.call(data, key)) {
                    continue;
                }
                if (original[key] !== data[key] || this.props[key].rules.includes('required')) {
                    filteredData[key] = data[key];
                }
            }
            try {
                if (this._model.isNew) {
                    await this._relation.create(filteredData, this._model);
                }
                else {
                    await this._relation.update(filteredData, this._model);
                }
            }
            catch (e) {
                if (isCrudValidationError(e)) {
                    throw new FormValidationError(e.data);
                }
                throw e;
            }
        }
        async _validate(data) {
            const validation = new validator$2(data, this._rules);
            if (validation.check()) {
                return FormValidationResult.valid();
            }
            return FormValidationResult.invalid({
                slug: 'libsdkhelpers.form.model_form.validation_error',
                messages: validation.errors.errors,
            });
        }
    }

    var urlJoin$1 = {exports: {}};

    (function (module) {
      (function (name, context, definition) {
        if (module.exports) module.exports = definition();else context[name] = definition();
      })('urljoin', commonjsGlobal, function () {
        function normalize(strArray) {
          var resultArray = [];

          if (strArray.length === 0) {
            return '';
          }

          if (typeof strArray[0] !== 'string') {
            throw new TypeError('Url must be a string. Received ' + strArray[0]);
          } // If the first part is a plain protocol, we combine it with the next part.


          if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
            var first = strArray.shift();
            strArray[0] = first + strArray[0];
          } // There must be two or three slashes in the file protocol, two slashes in anything else.


          if (strArray[0].match(/^file:\/\/\//)) {
            strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1:///');
          } else {
            strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1://');
          }

          for (var i = 0; i < strArray.length; i++) {
            var component = strArray[i];

            if (typeof component !== 'string') {
              throw new TypeError('Url must be a string. Received ' + component);
            }

            if (component === '') {
              continue;
            }

            if (i > 0) {
              // Removing the starting slashes for each component but the first.
              component = component.replace(/^[\/]+/, '');
            }

            if (i < strArray.length - 1) {
              // Removing the ending slashes for each component but the last.
              component = component.replace(/[\/]+$/, '');
            } else {
              // For the last component we will combine multiple slashes to a single one.
              component = component.replace(/[\/]+$/, '/');
            }

            resultArray.push(component);
          }

          var str = resultArray.join('/'); // Each input component is now separated by a single slash except the possible first plain protocol part.
          // remove trailing slash before parameters or hash

          str = str.replace(/\/(\?|&|#[^!])/g, '$1'); // replace ? in parameters with &

          var parts = str.split('?');
          str = parts.shift() + (parts.length > 0 ? '?' : '') + parts.join('&');
          return str;
        }

        return function () {
          var input;

          if (typeof arguments[0] === 'object') {
            input = arguments[0];
          } else {
            input = [].slice.call(arguments);
          }

          return normalize(input);
        };
      });
    })(urlJoin$1);

    var urlJoin = urlJoin$1.exports;

    class CrudNode {
        constructor(parent, type, paths) {
            this._parent = parent;
            this._type = type;
            this.paths = paths || [];
        }
        get $path() {
            throw Error('$path not implemented');
        }
        get $routes() {
            return [];
        }
        get $http() {
            return this._parent.$http;
        }
        get $log() {
            return this._parent.$log;
        }
        get $root() {
            return this._parent.$root;
        }
        get $factory() {
            return this._parent.$factory;
        }
        get type() {
            return this._type;
        }
        get parent() {
            return this._parent;
        }
    }

    class CrudToOne extends CrudNode {
        constructor(parent, type, config) {
            super(parent, type);
            this._config = config;
        }
        get $path() {
            return urlJoin(this._parent.$path, this._config.path || this.type);
        }
        async link(model) {
            const path = urlJoin(this.$path, model.guid);
            await this.$http.put(path);
            this._model = model;
        }
        async get() {
            if (this._model) {
                return this._model;
            }
            const response = await this.$http.get(this.$path);
            return this._model = this.$factory.getOrCreate(this.rootRelation, this.type, response.data);
        }
        set(data) {
            if (!data.guid) {
                throw Error('to_one.set data has not guid');
            }
            this._model = this.$factory.getOrCreate(this.rootRelation, this.type, data);
        }
        get rootRelation() {
            if (this.parent !== this.$root) {
                return this.$root.getRelation(this.type);
            }
            return this;
        }
    }

    // Add a getter so that the mixins can access methods and properties of the CrudToMany instance
    class CrudToManyMixin {
        constructor(instance) {
            this.instance = instance;
        }
        get rootRelation() {
            if (this.instance.parent !== this.instance.$root) {
                return this.instance.$root.getRelation(this.instance.type);
            }
            return this.instance;
        }
        rawDataToModels(data, type = this.instance.type) {
            return data.map((item) => this.instance.$factory.getOrCreate(this.rootRelation, type, item));
        }
    }
    CrudToManyMixin.mixin = '<mixin-name>';
    CrudToManyMixin.routes = [];

    class Sort extends CrudToManyMixin {
        constructor() {
            super(...arguments);
            this.getSortedPage = async (request) => {
                const rawResponse = await this.instance.$http.get(this.instance.$path, {
                    params: request,
                });
                return {
                    ...rawResponse.data,
                    data: this.rawDataToModels(rawResponse.data.data),
                };
            };
        }
        /**
         *
         * Used to reposition a model.
         *
         * @param model The model to reposition
         * @param order Where to position the model relative to the anchor model
         * @param anchor The model after (or before) which the given model will be positioned
         *
         */
        async sortModel(model, order, anchor) {
            const path = urlJoin(this.instance.$path, encodeURIComponent(anchor.guid), order, encodeURIComponent(model.guid));
            await this.instance.$http.put(path);
        }
    }
    Sort.mixin = 'sort';
    Sort.routes = [
        {
            method: 'PUT',
            uri: 'sort',
        },
        {
            method: 'GET|HEAD',
            uri: '',
        },
    ];

    /**
     * CRUD mixin implementation of the Pickable interface
     */
    class Pick extends CrudToManyMixin {
        constructor() {
            super(...arguments);
            this.getPickerPage = async (request) => {
                const rawResponse = await this.instance.$http.get(`${this.instance.$path}/pick`, {
                    params: request,
                });
                return {
                    ...rawResponse.data,
                    data: this.rawDataToModels(rawResponse.data.data),
                };
            };
            this.linkPickerModels = async (models) => {
                const path = urlJoin(this.instance.$path, 'multi');
                await this.instance.$http.put(path, models);
            };
            this.unlinkPickerModels = async (models) => {
                const path = urlJoin(this.instance.$path, 'multi');
                await this.instance.$http.delete(path, {
                    data: models,
                });
            };
        }
    }
    Pick.mixin = 'pick';
    Pick.routes = [
        {
            method: 'GET|HEAD',
            uri: 'pick',
        },
    ];

    /**
     * CRUD mixin implementation of the NestedPickable interface
     */
    class NestedPick extends CrudToManyMixin {
        constructor() {
            super(...arguments);
            // Returns the page of the sums pagination route
            this.getPickerSumsPage = async (request) => {
                const rawResponse = await this.instance.$http.get(`${this.instance.$path}/pick/sums`, {
                    params: request,
                });
                // The PickerSumsModel's type is not part of the default CRUD structure at the moment,
                // it is defined as an optional property in the CrudToManyConfig.
                const type = this.instance._config.pickerSumsType;
                // Since this cannot be enforced with TypeScript at the moment, do a manual runtime check
                // and throw when is is not defined.
                if (!type) {
                    throw Error('pickerSumsType is not defined on ToMany config');
                }
                return {
                    ...rawResponse.data,
                    data: this.rawDataToModels(rawResponse.data.data, type),
                };
            };
            // Returns the page of the nested pagination route, by PickerSumsModel.guid
            this.getPickerNestedPage = async (request) => {
                const rawResponse = await this.instance.$http.get(`${this.instance.$path}/pick/${request.guid}`, {
                    params: request,
                });
                return {
                    ...rawResponse.data,
                    data: this.rawDataToModels(rawResponse.data.data),
                };
            };
            this.linkPickerModels = async (models) => {
                const path = urlJoin(this.instance.$path, 'multi');
                await this.instance.$http.put(path, models);
            };
            this.unlinkPickerModels = async (models) => {
                const path = urlJoin(this.instance.$path, 'multi');
                await this.instance.$http.delete(path, {
                    data: models,
                });
            };
        }
    }
    NestedPick.mixin = 'multi_picker';
    NestedPick.routes = [
        {
            method: 'GET|HEAD',
            uri: 'pick/sums',
        },
        {
            method: 'GET|HEAD',
            uri: 'pick/{id}',
        },
    ];

    class Create extends CrudToManyMixin {
        constructor() {
            super(...arguments);
            this.create = async (data, model) => {
                try {
                    const response = await this.instance.$http.post(this.instance.$path, data);
                    model.setData(response.data);
                    this.instance.$factory.add(this.instance.type, model);
                }
                catch (e) {
                    if (isCrudApiError(e) && e.response.status === 406) {
                        throw new CrudValidationError(e);
                    }
                    throw new UnexpectedError(e);
                }
            };
        }
        new(data) {
            const newModel = this.instance.$factory.new(this.rootRelation, this.instance.type);
            if (data) {
                newModel.setData(data);
            }
            return newModel;
        }
    }
    Create.mixin = 'create';
    Create.routes = [
        {
            method: 'POST',
            uri: '',
        },
    ];

    class Link extends CrudToManyMixin {
        async link(model) {
            const path = urlJoin(this.instance.$path, encodeURIComponent(model.guid));
            await this.instance.$http.put(path);
        }
    }
    Link.mixin = 'link';
    Link.routes = [
        {
            method: 'PUT',
            uri: '{id}',
        },
    ];

    class LinkMulti extends CrudToManyMixin {
        async linkMulti(models) {
            const path = urlJoin(this.instance.$path, 'multi');
            await this.instance.$http.put(path, models.map((model) => model.guid));
        }
    }
    LinkMulti.mixin = 'link_multi';
    LinkMulti.routes = [
        {
            method: 'PUT',
            uri: 'multi',
        },
    ];

    class Rules extends CrudToManyMixin {
        constructor() {
            super(...arguments);
            this.rules = async () => {
                if (this.instance.__rules) {
                    return this.instance.__rules;
                }
                const path = urlJoin(this.instance.$path, 'rules');
                const response = await this.instance.$http.get(path);
                return this.instance.__rules = response.data;
            };
        }
    }
    Rules.mixin = 'rules';
    Rules.routes = [
        {
            method: 'GET|HEAD',
            uri: 'rules',
        },
    ];

    class Delete extends CrudToManyMixin {
        async delete(model) {
            const path = urlJoin(this.instance.$path, encodeURIComponent(model.guid));
            await this.instance.$http.delete(path);
        }
    }
    Delete.mixin = 'delete';
    Delete.routes = [
        {
            method: 'DELETE',
            uri: '{id}',
        },
    ];

    class List extends CrudToManyMixin {
        constructor() {
            super(...arguments);
            this.getPage = async (request) => {
                const rawResponse = await this.instance.$http.get(this.instance.$path, {
                    params: request,
                });
                this.instance._setAdditionalFields(rawResponse.data);
                return {
                    ...rawResponse.data,
                    data: this.rawDataToModels(rawResponse.data.data),
                };
            };
        }
        canOrder(field) {
            if (!this.instance.__filters) {
                return false;
            }
            for (const filter of Object.values(this.instance.__filters)) {
                if (filter.target !== field) {
                    continue;
                }
                return filter.match === 'exact' || filter.match === 'partial';
            }
            return false;
        }
    }
    List.mixin = 'list';
    List.routes = [
        {
            method: 'GET|HEAD',
            uri: '',
        },
    ];

    class ListAll extends CrudToManyMixin {
        constructor() {
            super(...arguments);
            this.getPageByType = async (request) => {
                const rawResponse = await this.instance.$http.get(this.instance.$path, {
                    params: request,
                });
                return {
                    ...rawResponse.data,
                    data: this.rawDataToModels(rawResponse.data.data),
                };
            };
        }
    }
    ListAll.mixin = 'list_all';
    ListAll.routes = [
        {
            method: 'GET|HEAD',
            uri: '',
        },
        {
            method: 'GET|HEAD',
            uri: 'list/{type}',
        },
    ];

    class Reinstate extends CrudToManyMixin {
        async reinstate(guid) {
            const path = urlJoin(this.instance.$path, encodeURIComponent(guid), 'reinstate');
            await this.instance.$http.post(path);
        }
    }
    Reinstate.mixin = 'reinstate';
    Reinstate.routes = [
        {
            method: 'POST',
            uri: '{id}/reinstate',
        },
    ];

    class Unlink extends CrudToManyMixin {
        async unlink(model) {
            const path = urlJoin(this.instance.$path, encodeURIComponent(model.guid));
            await this.instance.$http.delete(path);
        }
    }
    Unlink.mixin = 'detach';
    Unlink.routes = [
        {
            method: 'DELETE',
            uri: '{id}',
        },
    ];

    class UnlinkMulti extends CrudToManyMixin {
        async unlinkMulti(models) {
            const path = urlJoin(this.instance.$path, 'multi');
            await this.instance.$http.delete(path, {
                data: models.map((model) => model.guid),
            });
        }
    }
    UnlinkMulti.mixin = 'unlink_multi';
    UnlinkMulti.routes = [
        {
            method: 'DELETE',
            uri: 'multi',
        },
    ];

    class Filters extends CrudToManyMixin {
        async getFilters() {
            if (this.instance.__filters) {
                return this.instance.__filters;
            }
            const path = urlJoin(this.instance.$path, 'filters');
            const response = await this.instance.$http.get(path);
            return this.instance.__filters = response.data;
        }
    }
    Filters.mixin = 'filters';
    Filters.routes = [
        {
            method: 'GET|HEAD',
            uri: 'filters',
        },
    ];

    class Get extends CrudToManyMixin {
        async get(guid) {
            const path = urlJoin(this.instance.$path, encodeURIComponent(guid));
            const response = await this.instance.$http.get(path);
            return this.instance.$factory.getOrCreate(this.rootRelation, this.instance.type, response.data);
        }
    }
    Get.mixin = 'get';
    Get.routes = [
        {
            method: 'GET|HEAD',
            uri: '{id}',
        },
    ];

    class Update extends CrudToManyMixin {
        constructor() {
            super(...arguments);
            this.update = async (data, model) => {
                try {
                    const path = urlJoin(this.instance.$path, encodeURIComponent(model.guid));
                    await this.instance.$http.patch(path, data);
                    model.setData(data);
                }
                catch (e) {
                    if (isCrudApiError(e) && e.response.status === 406) {
                        throw new CrudValidationError(e);
                    }
                    throw new UnexpectedError(e);
                }
            };
        }
    }
    Update.mixin = 'update';
    Update.routes = [
        {
            method: 'PATCH',
            uri: '{id}',
        },
    ];

    var index = /*#__PURE__*/Object.freeze({
        __proto__: null,
        Sort: Sort,
        Pick: Pick,
        NestedPick: NestedPick,
        Create: Create,
        Link: Link,
        LinkMulti: LinkMulti,
        Rules: Rules,
        Delete: Delete,
        List: List,
        ListAll: ListAll,
        Reinstate: Reinstate,
        Unlink: Unlink,
        UnlinkMulti: UnlinkMulti,
        Filters: Filters,
        Get: Get,
        Update: Update
    });

    function toMany(parent, type, config) {
        return new CrudToMany(parent, type, config);
    }
    class CrudToMany extends CrudNode {
        constructor(parent, type, config) {
            super(parent, type);
            // Contains the identifiers of the applied mixins
            this.mixins = [];
            // Relation cache
            this.__cache = {};
            // Registered routes from the applied mixins
            this._mixinRoutes = [];
            this._config = config;
            // Add mixin helpers
            this._applyMixin(CrudToManyMixin);
        }
        get $path() {
            return urlJoin(this._parent.$path, this._config.path);
        }
        get $routes() {
            const routes = [];
            routes.push(...this._mixinRoutes);
            if (this.parent === this.$root) {
                const data = { guid: '{id}', created_at: '', updated_at: '' };
                const model = this.$factory.getOrCreate(this, this.type, data);
                routes.push(...model.$routes);
            }
            return routes;
        }
        with(ctor) {
            // Keep track of applied mixins
            this.mixins.push(ctor.mixin);
            // Add base path to mixin routes
            const routes = ctor.routes.map((route) => ({
                method: route.method,
                uri: urlJoin(this.$path, route.uri),
            }));
            // Save the routes
            this._mixinRoutes.push(...routes);
            // Copy prototype keys
            this._applyMixin(ctor);
            return this;
        }
        _applyMixin(constructor) {
            const instance = this;
            // Reference: https://www.typescriptlang.org/docs/handbook/mixins.html
            // Set properties
            const mixinInstance = new constructor(instance);
            Object.getOwnPropertyNames(mixinInstance).forEach((name) => {
                if (instance[name] === undefined) {
                    Object.defineProperty(instance, name, Object.getOwnPropertyDescriptor(mixinInstance, name) || Object.create(null));
                }
            });
            // Set methods
            Object.getOwnPropertyNames(constructor.prototype).forEach((name) => {
                if (instance[name] === undefined) {
                    Object.defineProperty(instance, name, Object.getOwnPropertyDescriptor(constructor.prototype, name) || Object.create(null));
                }
            });
            return this;
        }
        _setAdditionalFields(response) {
            this.__appends = this.__appends || response.__appends;
            this.__filters = this.__filters || response.__filters;
            this.__includes = this.__includes || response.__includes;
            this.__rules = this.__rules || response.__rules;
        }
    }

    exports.CrudModelPropType = void 0;
    (function (CrudModelPropType) {
        CrudModelPropType["String"] = "string";
        CrudModelPropType["Boolean"] = "boolean";
        CrudModelPropType["Number"] = "number";
        CrudModelPropType["Date"] = "date";
        CrudModelPropType["Array"] = "array";
    })(exports.CrudModelPropType || (exports.CrudModelPropType = {}));

    const CrudModelProps = {
        guid: exports.CrudModelPropType.String,
    };
    class CrudModel extends CrudNode {
        constructor(parent, type, config) {
            super(parent, type);
            if (parent !== this.$root && parent.parent !== this.$root) {
                throw Error(`Invalid parent for model of type ${type}`);
            }
            this._props = CrudModel.parsePropConfig({
                ...config.props,
                ...CrudModelProps,
            });
            this.raw = { ...config.data }; // Here
            this.props = this._getPropValues(this._props, config.data);
            this._config = config;
        }
        static parsePropConfig(config) {
            const props = {};
            Object.keys(config).forEach((key) => {
                let propConfig = config[key];
                if (typeof propConfig !== 'object') {
                    propConfig = {
                        type: propConfig,
                    };
                }
                props[key] = {
                    type: propConfig.type,
                    default: propConfig.default !== undefined ? propConfig.default : null,
                    props: propConfig.props,
                    value: null,
                    rules: propConfig.rules || [],
                };
            });
            return props;
        }
        get guid() {
            return this.props.guid;
        }
        get isNew() {
            return !this.props.guid;
        }
        get $path() {
            if (this.parent instanceof CrudToMany && this.props.guid) {
                return urlJoin(this.parent.$path, encodeURIComponent(this.props.guid));
            }
            return urlJoin(this.parent.$path, this.type);
        }
        get $routes() {
            const routes = [];
            for (const node of Object.values(this)) {
                if (node instanceof CrudNode && node !== this.parent) {
                    routes.push(...node.$routes);
                }
            }
            return routes;
        }
        setData(data) {
            Object.keys(data).forEach((strKey) => {
                const key = strKey;
                this.props[key] = data[key];
            });
        }
        _getPropValues(props, data) {
            const _props = {};
            for (const key of Object.keys(props)) {
                if (data && data[key] !== undefined) {
                    _props[key] = data[key];
                }
                else {
                    _props[key] = props[key].value;
                }
            }
            return _props;
        }
    }
    CrudModel.type = '<type>';
    CrudModel.props = CrudModel.parsePropConfig(CrudModelProps);

    class CrudFactory {
        constructor(config) {
            this._blueprints = {};
            this._cache = {};
            this._config = config;
            for (const blueprint of config.models) {
                this._blueprints[blueprint.type] = blueprint;
                this._cache[blueprint.type] = {};
            }
        }
        new(parent, type) {
            return new this._blueprints[type](parent);
        }
        add(type, model) {
            if (!model.props.guid) {
                throw Error('No guid set on model');
            }
            this._cache[type][model.props.guid] = model;
        }
        getOrCreate(parent, type, data) {
            let model = this._cache[type][data.guid];
            if (model) {
                model.setData(data);
                return model;
            }
            model = new this._blueprints[type](parent, data);
            this.add(type, model);
            return model;
        }
    }

    var axios$2 = {exports: {}};

    var bind$2 = function bind(fn, thisArg) {
      return function wrap() {
        var args = new Array(arguments.length);

        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }

        return fn.apply(thisArg, args);
      };
    };

    var bind$1 = bind$2; // utils is a library of generic helper functions non-specific to axios

    var toString = Object.prototype.toString;
    /**
     * Determine if a value is an Array
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is an Array, otherwise false
     */

    function isArray(val) {
      return toString.call(val) === '[object Array]';
    }
    /**
     * Determine if a value is undefined
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if the value is undefined, otherwise false
     */


    function isUndefined(val) {
      return typeof val === 'undefined';
    }
    /**
     * Determine if a value is a Buffer
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a Buffer, otherwise false
     */


    function isBuffer(val) {
      return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
    }
    /**
     * Determine if a value is an ArrayBuffer
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is an ArrayBuffer, otherwise false
     */


    function isArrayBuffer(val) {
      return toString.call(val) === '[object ArrayBuffer]';
    }
    /**
     * Determine if a value is a FormData
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is an FormData, otherwise false
     */


    function isFormData(val) {
      return typeof FormData !== 'undefined' && val instanceof FormData;
    }
    /**
     * Determine if a value is a view on an ArrayBuffer
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
     */


    function isArrayBufferView(val) {
      var result;

      if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val);
      } else {
        result = val && val.buffer && val.buffer instanceof ArrayBuffer;
      }

      return result;
    }
    /**
     * Determine if a value is a String
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a String, otherwise false
     */


    function isString(val) {
      return typeof val === 'string';
    }
    /**
     * Determine if a value is a Number
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a Number, otherwise false
     */


    function isNumber(val) {
      return typeof val === 'number';
    }
    /**
     * Determine if a value is an Object
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is an Object, otherwise false
     */


    function isObject(val) {
      return val !== null && typeof val === 'object';
    }
    /**
     * Determine if a value is a plain Object
     *
     * @param {Object} val The value to test
     * @return {boolean} True if value is a plain Object, otherwise false
     */


    function isPlainObject(val) {
      if (toString.call(val) !== '[object Object]') {
        return false;
      }

      var prototype = Object.getPrototypeOf(val);
      return prototype === null || prototype === Object.prototype;
    }
    /**
     * Determine if a value is a Date
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a Date, otherwise false
     */


    function isDate(val) {
      return toString.call(val) === '[object Date]';
    }
    /**
     * Determine if a value is a File
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a File, otherwise false
     */


    function isFile(val) {
      return toString.call(val) === '[object File]';
    }
    /**
     * Determine if a value is a Blob
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a Blob, otherwise false
     */


    function isBlob(val) {
      return toString.call(val) === '[object Blob]';
    }
    /**
     * Determine if a value is a Function
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a Function, otherwise false
     */


    function isFunction(val) {
      return toString.call(val) === '[object Function]';
    }
    /**
     * Determine if a value is a Stream
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a Stream, otherwise false
     */


    function isStream(val) {
      return isObject(val) && isFunction(val.pipe);
    }
    /**
     * Determine if a value is a URLSearchParams object
     *
     * @param {Object} val The value to test
     * @returns {boolean} True if value is a URLSearchParams object, otherwise false
     */


    function isURLSearchParams(val) {
      return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
    }
    /**
     * Trim excess whitespace off the beginning and end of a string
     *
     * @param {String} str The String to trim
     * @returns {String} The String freed of excess whitespace
     */


    function trim(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    /**
     * Determine if we're running in a standard browser environment
     *
     * This allows axios to run in a web worker, and react-native.
     * Both environments support XMLHttpRequest, but not fully standard globals.
     *
     * web workers:
     *  typeof window -> undefined
     *  typeof document -> undefined
     *
     * react-native:
     *  navigator.product -> 'ReactNative'
     * nativescript
     *  navigator.product -> 'NativeScript' or 'NS'
     */


    function isStandardBrowserEnv() {
      if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
        return false;
      }

      return typeof window !== 'undefined' && typeof document !== 'undefined';
    }
    /**
     * Iterate over an Array or an Object invoking a function for each item.
     *
     * If `obj` is an Array callback will be called passing
     * the value, index, and complete array for each item.
     *
     * If 'obj' is an Object callback will be called passing
     * the value, key, and complete object for each property.
     *
     * @param {Object|Array} obj The object to iterate
     * @param {Function} fn The callback to invoke for each item
     */


    function forEach(obj, fn) {
      // Don't bother if no value provided
      if (obj === null || typeof obj === 'undefined') {
        return;
      } // Force an array if not already something iterable


      if (typeof obj !== 'object') {
        /*eslint no-param-reassign:0*/
        obj = [obj];
      }

      if (isArray(obj)) {
        // Iterate over array values
        for (var i = 0, l = obj.length; i < l; i++) {
          fn.call(null, obj[i], i, obj);
        }
      } else {
        // Iterate over object keys
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn.call(null, obj[key], key, obj);
          }
        }
      }
    }
    /**
     * Accepts varargs expecting each argument to be an object, then
     * immutably merges the properties of each object and returns result.
     *
     * When multiple objects contain the same key the later object in
     * the arguments list will take precedence.
     *
     * Example:
     *
     * ```js
     * var result = merge({foo: 123}, {foo: 456});
     * console.log(result.foo); // outputs 456
     * ```
     *
     * @param {Object} obj1 Object to merge
     * @returns {Object} Result of all merge properties
     */


    function
      /* obj1, obj2, obj3, ... */
    merge() {
      var result = {};

      function assignValue(val, key) {
        if (isPlainObject(result[key]) && isPlainObject(val)) {
          result[key] = merge(result[key], val);
        } else if (isPlainObject(val)) {
          result[key] = merge({}, val);
        } else if (isArray(val)) {
          result[key] = val.slice();
        } else {
          result[key] = val;
        }
      }

      for (var i = 0, l = arguments.length; i < l; i++) {
        forEach(arguments[i], assignValue);
      }

      return result;
    }
    /**
     * Extends object a by mutably adding to it the properties of object b.
     *
     * @param {Object} a The object to be extended
     * @param {Object} b The object to copy properties from
     * @param {Object} thisArg The object to bind function to
     * @return {Object} The resulting value of object a
     */


    function extend(a, b, thisArg) {
      forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') {
          a[key] = bind$1(val, thisArg);
        } else {
          a[key] = val;
        }
      });
      return a;
    }
    /**
     * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
     *
     * @param {string} content with BOM
     * @return {string} content value without BOM
     */


    function stripBOM(content) {
      if (content.charCodeAt(0) === 0xFEFF) {
        content = content.slice(1);
      }

      return content;
    }

    var utils$d = {
      isArray: isArray,
      isArrayBuffer: isArrayBuffer,
      isBuffer: isBuffer,
      isFormData: isFormData,
      isArrayBufferView: isArrayBufferView,
      isString: isString,
      isNumber: isNumber,
      isObject: isObject,
      isPlainObject: isPlainObject,
      isUndefined: isUndefined,
      isDate: isDate,
      isFile: isFile,
      isBlob: isBlob,
      isFunction: isFunction,
      isStream: isStream,
      isURLSearchParams: isURLSearchParams,
      isStandardBrowserEnv: isStandardBrowserEnv,
      forEach: forEach,
      merge: merge,
      extend: extend,
      trim: trim,
      stripBOM: stripBOM
    };

    var utils$c = utils$d;

    function encode(val) {
      return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    }
    /**
     * Build a URL by appending params to the end
     *
     * @param {string} url The base of the url (e.g., http://www.google.com)
     * @param {object} [params] The params to be appended
     * @returns {string} The formatted url
     */


    var buildURL$2 = function buildURL(url, params, paramsSerializer) {
      /*eslint no-param-reassign:0*/
      if (!params) {
        return url;
      }

      var serializedParams;

      if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
      } else if (utils$c.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils$c.forEach(params, function serialize(val, key) {
          if (val === null || typeof val === 'undefined') {
            return;
          }

          if (utils$c.isArray(val)) {
            key = key + '[]';
          } else {
            val = [val];
          }

          utils$c.forEach(val, function parseValue(v) {
            if (utils$c.isDate(v)) {
              v = v.toISOString();
            } else if (utils$c.isObject(v)) {
              v = JSON.stringify(v);
            }

            parts.push(encode(key) + '=' + encode(v));
          });
        });
        serializedParams = parts.join('&');
      }

      if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');

        if (hashmarkIndex !== -1) {
          url = url.slice(0, hashmarkIndex);
        }

        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
      }

      return url;
    };

    var utils$b = utils$d;

    function InterceptorManager$1() {
      this.handlers = [];
    }
    /**
     * Add a new interceptor to the stack
     *
     * @param {Function} fulfilled The function to handle `then` for a `Promise`
     * @param {Function} rejected The function to handle `reject` for a `Promise`
     *
     * @return {Number} An ID used to remove interceptor later
     */


    InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    };
    /**
     * Remove an interceptor from the stack
     *
     * @param {Number} id The ID that was returned by `use`
     */


    InterceptorManager$1.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    /**
     * Iterate over all the registered interceptors
     *
     * This method is particularly useful for skipping over any
     * interceptors that may have become `null` calling `eject`.
     *
     * @param {Function} fn The function to call for each interceptor
     */


    InterceptorManager$1.prototype.forEach = function forEach(fn) {
      utils$b.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    };

    var InterceptorManager_1 = InterceptorManager$1;

    var utils$a = utils$d;

    var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
      utils$a.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };

    /**
     * Update an Error with the specified config, error code, and response.
     *
     * @param {Error} error The error to update.
     * @param {Object} config The config.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     * @returns {Error} The error.
     */


    var enhanceError$2 = function enhanceError(error, config, code, request, response) {
      error.config = config;

      if (code) {
        error.code = code;
      }

      error.request = request;
      error.response = response;
      error.isAxiosError = true;

      error.toJSON = function toJSON() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code,
          status: this.response && this.response.status ? this.response.status : null
        };
      };

      return error;
    };

    var enhanceError$1 = enhanceError$2;
    /**
     * Create an Error with the specified message, config, error code, request and response.
     *
     * @param {string} message The error message.
     * @param {Object} config The config.
     * @param {string} [code] The error code (for example, 'ECONNABORTED').
     * @param {Object} [request] The request.
     * @param {Object} [response] The response.
     * @returns {Error} The created error.
     */

    var createError$2 = function createError(message, config, code, request, response) {
      var error = new Error(message);
      return enhanceError$1(error, config, code, request, response);
    };

    var createError$1 = createError$2;
    /**
     * Resolve or reject a Promise based on response status.
     *
     * @param {Function} resolve A function that resolves the promise.
     * @param {Function} reject A function that rejects the promise.
     * @param {object} response The response.
     */

    var settle$1 = function settle(resolve, reject, response) {
      var validateStatus = response.config.validateStatus;

      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(createError$1('Request failed with status code ' + response.status, response.config, null, response.request, response));
      }
    };

    var utils$9 = utils$d;
    var cookies$1 = utils$9.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
    function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils$9.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils$9.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils$9.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },
        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    }() : // Non standard browser env (web workers, react-native) lack needed support.
    function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() {
          return null;
        },
        remove: function remove() {}
      };
    }();

    /**
     * Determines whether the specified URL is absolute
     *
     * @param {string} url The URL to test
     * @returns {boolean} True if the specified URL is absolute, otherwise false
     */


    var isAbsoluteURL$1 = function isAbsoluteURL(url) {
      // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
      // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
      // by any combination of letters, digits, plus, period, or hyphen.
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
    };

    /**
     * Creates a new URL by combining the specified URLs
     *
     * @param {string} baseURL The base URL
     * @param {string} relativeURL The relative URL
     * @returns {string} The combined URL
     */


    var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
    };

    var isAbsoluteURL = isAbsoluteURL$1;
    var combineURLs = combineURLs$1;
    /**
     * Creates a new URL by combining the baseURL with the requestedURL,
     * only when the requestedURL is not already an absolute URL.
     * If the requestURL is absolute, this function returns the requestedURL untouched.
     *
     * @param {string} baseURL The base URL
     * @param {string} requestedURL Absolute or relative URL to combine
     * @returns {string} The combined full path
     */

    var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
      }

      return requestedURL;
    };

    var utils$8 = utils$d; // Headers whose duplicates are ignored by node
    // c.f. https://nodejs.org/api/http.html#http_message_headers

    var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
    /**
     * Parse headers into an object
     *
     * ```
     * Date: Wed, 27 Aug 2014 08:58:49 GMT
     * Content-Type: application/json
     * Connection: keep-alive
     * Transfer-Encoding: chunked
     * ```
     *
     * @param {String} headers Headers needing to be parsed
     * @returns {Object} Headers parsed into an object
     */

    var parseHeaders$1 = function parseHeaders(headers) {
      var parsed = {};
      var key;
      var val;
      var i;

      if (!headers) {
        return parsed;
      }

      utils$8.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = utils$8.trim(line.substr(0, i)).toLowerCase();
        val = utils$8.trim(line.substr(i + 1));

        if (key) {
          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
            return;
          }

          if (key === 'set-cookie') {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
          }
        }
      });
      return parsed;
    };

    var utils$7 = utils$d;
    var isURLSameOrigin$1 = utils$7.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;
      /**
      * Parse a URL to discover it's components
      *
      * @param {String} url The URL to be parsed
      * @returns {Object}
      */

      function resolveURL(url) {
        var href = url;

        if (msie) {
          // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);
      /**
      * Determine if a URL shares the same origin as the current location
      *
      * @param {String} requestURL The URL to test
      * @returns {boolean} True if URL shares the same origin, otherwise false
      */

      return function isURLSameOrigin(requestURL) {
        var parsed = utils$7.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
      };
    }() : // Non standard browser envs (web workers, react-native) lack needed support.
    function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    }();

    /**
     * A `Cancel` is an object that is thrown when an operation is canceled.
     *
     * @class
     * @param {string=} message The message.
     */


    function Cancel$3(message) {
      this.message = message;
    }

    Cancel$3.prototype.toString = function toString() {
      return 'Cancel' + (this.message ? ': ' + this.message : '');
    };

    Cancel$3.prototype.__CANCEL__ = true;
    var Cancel_1 = Cancel$3;

    var utils$6 = utils$d;
    var settle = settle$1;
    var cookies = cookies$1;
    var buildURL$1 = buildURL$2;
    var buildFullPath = buildFullPath$1;
    var parseHeaders = parseHeaders$1;
    var isURLSameOrigin = isURLSameOrigin$1;
    var createError = createError$2;
    var defaults$4 = defaults_1;
    var Cancel$2 = Cancel_1;

    var xhr = function xhrAdapter(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;

        function done() {
          if (config.cancelToken) {
            config.cancelToken.unsubscribe(onCanceled);
          }

          if (config.signal) {
            config.signal.removeEventListener('abort', onCanceled);
          }
        }

        if (utils$6.isFormData(requestData)) {
          delete requestHeaders['Content-Type']; // Let the browser set it
        }

        var request = new XMLHttpRequest(); // HTTP basic authentication

        if (config.auth) {
          var username = config.auth.username || '';
          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
          requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }

        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

        request.timeout = config.timeout;

        function onloadend() {
          if (!request) {
            return;
          } // Prepare the response


          var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
          var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
          var response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config: config,
            request: request
          };
          settle(function _resolve(value) {
            resolve(value);
            done();
          }, function _reject(err) {
            reject(err);
            done();
          }, response); // Clean up request

          request = null;
        }

        if ('onloadend' in request) {
          // Use onloadend if available
          request.onloadend = onloadend;
        } else {
          // Listen for ready state to emulate onloadend
          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            } // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request


            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
              return;
            } // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'


            setTimeout(onloadend);
          };
        } // Handle browser request cancellation (as opposed to a manual cancellation)


        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }

          reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

          request = null;
        }; // Handle low level network errors


        request.onerror = function handleError() {
          // Real errors are hidden from us by the browser
          // onerror should only fire if it's a network error
          reject(createError('Network Error', config, null, request)); // Clean up request

          request = null;
        }; // Handle timeout


        request.ontimeout = function handleTimeout() {
          var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
          var transitional = config.transitional || defaults$4.transitional;

          if (config.timeoutErrorMessage) {
            timeoutErrorMessage = config.timeoutErrorMessage;
          }

          reject(createError(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request)); // Clean up request

          request = null;
        }; // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.


        if (utils$6.isStandardBrowserEnv()) {
          // Add xsrf header
          var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

          if (xsrfValue) {
            requestHeaders[config.xsrfHeaderName] = xsrfValue;
          }
        } // Add headers to the request


        if ('setRequestHeader' in request) {
          utils$6.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
              // Remove Content-Type if data is undefined
              delete requestHeaders[key];
            } else {
              // Otherwise add header to the request
              request.setRequestHeader(key, val);
            }
          });
        } // Add withCredentials to request if needed


        if (!utils$6.isUndefined(config.withCredentials)) {
          request.withCredentials = !!config.withCredentials;
        } // Add responseType to request if needed


        if (responseType && responseType !== 'json') {
          request.responseType = config.responseType;
        } // Handle progress if needed


        if (typeof config.onDownloadProgress === 'function') {
          request.addEventListener('progress', config.onDownloadProgress);
        } // Not all browsers support upload events


        if (typeof config.onUploadProgress === 'function' && request.upload) {
          request.upload.addEventListener('progress', config.onUploadProgress);
        }

        if (config.cancelToken || config.signal) {
          // Handle cancellation
          // eslint-disable-next-line func-names
          onCanceled = function (cancel) {
            if (!request) {
              return;
            }

            reject(!cancel || cancel && cancel.type ? new Cancel$2('canceled') : cancel);
            request.abort();
            request = null;
          };

          config.cancelToken && config.cancelToken.subscribe(onCanceled);

          if (config.signal) {
            config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
          }
        }

        if (!requestData) {
          requestData = null;
        } // Send the request


        request.send(requestData);
      });
    };

    var utils$5 = utils$d;
    var normalizeHeaderName = normalizeHeaderName$1;
    var enhanceError = enhanceError$2;
    var DEFAULT_CONTENT_TYPE = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };

    function setContentTypeIfUnset(headers, value) {
      if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers['Content-Type'])) {
        headers['Content-Type'] = value;
      }
    }

    function getDefaultAdapter() {
      var adapter;

      if (typeof XMLHttpRequest !== 'undefined') {
        // For browsers use XHR adapter
        adapter = xhr;
      } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
        // For node use HTTP adapter
        adapter = xhr;
      }

      return adapter;
    }

    function stringifySafely(rawValue, parser, encoder) {
      if (utils$5.isString(rawValue)) {
        try {
          (parser || JSON.parse)(rawValue);
          return utils$5.trim(rawValue);
        } catch (e) {
          if (e.name !== 'SyntaxError') {
            throw e;
          }
        }
      }

      return (encoder || JSON.stringify)(rawValue);
    }

    var defaults$3 = {
      transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
      },
      adapter: getDefaultAdapter(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, 'Accept');
        normalizeHeaderName(headers, 'Content-Type');

        if (utils$5.isFormData(data) || utils$5.isArrayBuffer(data) || utils$5.isBuffer(data) || utils$5.isStream(data) || utils$5.isFile(data) || utils$5.isBlob(data)) {
          return data;
        }

        if (utils$5.isArrayBufferView(data)) {
          return data.buffer;
        }

        if (utils$5.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
          return data.toString();
        }

        if (utils$5.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
          setContentTypeIfUnset(headers, 'application/json');
          return stringifySafely(data);
        }

        return data;
      }],
      transformResponse: [function transformResponse(data) {
        var transitional = this.transitional || defaults$3.transitional;
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

        if (strictJSONParsing || forcedJSONParsing && utils$5.isString(data) && data.length) {
          try {
            return JSON.parse(data);
          } catch (e) {
            if (strictJSONParsing) {
              if (e.name === 'SyntaxError') {
                throw enhanceError(e, this, 'E_JSON_PARSE');
              }

              throw e;
            }
          }
        }

        return data;
      }],

      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: 'XSRF-TOKEN',
      xsrfHeaderName: 'X-XSRF-TOKEN',
      maxContentLength: -1,
      maxBodyLength: -1,
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      },
      headers: {
        common: {
          'Accept': 'application/json, text/plain, */*'
        }
      }
    };
    utils$5.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
      defaults$3.headers[method] = {};
    });
    utils$5.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
      defaults$3.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
    });
    var defaults_1 = defaults$3;

    var utils$4 = utils$d;
    var defaults$2 = defaults_1;
    /**
     * Transform the data for a request or a response
     *
     * @param {Object|String} data The data to be transformed
     * @param {Array} headers The headers for the request or response
     * @param {Array|Function} fns A single function or Array of functions
     * @returns {*} The resulting transformed data
     */

    var transformData$1 = function transformData(data, headers, fns) {
      var context = this || defaults$2;
      /*eslint no-param-reassign:0*/

      utils$4.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
      });
      return data;
    };

    var isCancel$1 = function isCancel(value) {
      return !!(value && value.__CANCEL__);
    };

    var utils$3 = utils$d;
    var transformData = transformData$1;
    var isCancel = isCancel$1;
    var defaults$1 = defaults_1;
    var Cancel$1 = Cancel_1;
    /**
     * Throws a `Cancel` if cancellation has been requested.
     */

    function throwIfCancellationRequested(config) {
      if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
      }

      if (config.signal && config.signal.aborted) {
        throw new Cancel$1('canceled');
      }
    }
    /**
     * Dispatch a request to the server using the configured adapter.
     *
     * @param {object} config The config that is to be used for the request
     * @returns {Promise} The Promise to be fulfilled
     */


    var dispatchRequest$1 = function dispatchRequest(config) {
      throwIfCancellationRequested(config); // Ensure headers exist

      config.headers = config.headers || {}; // Transform request data

      config.data = transformData.call(config, config.data, config.headers, config.transformRequest); // Flatten headers

      config.headers = utils$3.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
      utils$3.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
        delete config.headers[method];
      });
      var adapter = config.adapter || defaults$1.adapter;
      return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config); // Transform response data

        response.data = transformData.call(config, response.data, response.headers, config.transformResponse);
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config); // Transform response data

          if (reason && reason.response) {
            reason.response.data = transformData.call(config, reason.response.data, reason.response.headers, config.transformResponse);
          }
        }

        return Promise.reject(reason);
      });
    };

    var utils$2 = utils$d;
    /**
     * Config-specific merge-function which creates a new config-object
     * by merging two configuration objects together.
     *
     * @param {Object} config1
     * @param {Object} config2
     * @returns {Object} New object resulting from merging config2 to config1
     */

    var mergeConfig$2 = function mergeConfig(config1, config2) {
      // eslint-disable-next-line no-param-reassign
      config2 = config2 || {};
      var config = {};

      function getMergedValue(target, source) {
        if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
          return utils$2.merge(target, source);
        } else if (utils$2.isPlainObject(source)) {
          return utils$2.merge({}, source);
        } else if (utils$2.isArray(source)) {
          return source.slice();
        }

        return source;
      } // eslint-disable-next-line consistent-return


      function mergeDeepProperties(prop) {
        if (!utils$2.isUndefined(config2[prop])) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (!utils$2.isUndefined(config1[prop])) {
          return getMergedValue(undefined, config1[prop]);
        }
      } // eslint-disable-next-line consistent-return


      function valueFromConfig2(prop) {
        if (!utils$2.isUndefined(config2[prop])) {
          return getMergedValue(undefined, config2[prop]);
        }
      } // eslint-disable-next-line consistent-return


      function defaultToConfig2(prop) {
        if (!utils$2.isUndefined(config2[prop])) {
          return getMergedValue(undefined, config2[prop]);
        } else if (!utils$2.isUndefined(config1[prop])) {
          return getMergedValue(undefined, config1[prop]);
        }
      } // eslint-disable-next-line consistent-return


      function mergeDirectKeys(prop) {
        if (prop in config2) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
          return getMergedValue(undefined, config1[prop]);
        }
      }

      var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
      };
      utils$2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        utils$2.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
      });
      return config;
    };

    var data = {
      "version": "0.24.0"
    };

    var VERSION = data.version;
    var validators$1 = {}; // eslint-disable-next-line func-names

    ['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function (type, i) {
      validators$1[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
      };
    });
    var deprecatedWarnings = {};
    /**
     * Transitional option validator
     * @param {function|boolean?} validator - set to false if the transitional option has been removed
     * @param {string?} version - deprecated version / removed since version
     * @param {string?} message - some message with additional info
     * @returns {function}
     */

    validators$1.transitional = function transitional(validator, version, message) {
      function formatMessage(opt, desc) {
        return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
      } // eslint-disable-next-line func-names


      return function (value, opt, opts) {
        if (validator === false) {
          throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
        }

        if (version && !deprecatedWarnings[opt]) {
          deprecatedWarnings[opt] = true; // eslint-disable-next-line no-console

          console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }

        return validator ? validator(value, opt, opts) : true;
      };
    };
    /**
     * Assert object's properties type
     * @param {object} options
     * @param {object} schema
     * @param {boolean?} allowUnknown
     */


    function assertOptions(options, schema, allowUnknown) {
      if (typeof options !== 'object') {
        throw new TypeError('options must be an object');
      }

      var keys = Object.keys(options);
      var i = keys.length;

      while (i-- > 0) {
        var opt = keys[i];
        var validator = schema[opt];

        if (validator) {
          var value = options[opt];
          var result = value === undefined || validator(value, opt, options);

          if (result !== true) {
            throw new TypeError('option ' + opt + ' must be ' + result);
          }

          continue;
        }

        if (allowUnknown !== true) {
          throw Error('Unknown option ' + opt);
        }
      }
    }

    var validator$1 = {
      assertOptions: assertOptions,
      validators: validators$1
    };

    var utils$1 = utils$d;
    var buildURL = buildURL$2;
    var InterceptorManager = InterceptorManager_1;
    var dispatchRequest = dispatchRequest$1;
    var mergeConfig$1 = mergeConfig$2;
    var validator = validator$1;
    var validators = validator.validators;
    /**
     * Create a new instance of Axios
     *
     * @param {Object} instanceConfig The default config for the instance
     */

    function Axios$1(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }
    /**
     * Dispatch a request
     *
     * @param {Object} config The config specific for this request (merged with this.defaults)
     */


    Axios$1.prototype.request = function request(config) {
      /*eslint no-param-reassign:0*/
      // Allow for axios('example/url'[, config]) a la fetch API
      if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
      } else {
        config = config || {};
      }

      config = mergeConfig$1(this.defaults, config); // Set config.method

      if (config.method) {
        config.method = config.method.toLowerCase();
      } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
      } else {
        config.method = 'get';
      }

      var transitional = config.transitional;

      if (transitional !== undefined) {
        validator.assertOptions(transitional, {
          silentJSONParsing: validators.transitional(validators.boolean),
          forcedJSONParsing: validators.transitional(validators.boolean),
          clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
      } // filter out skipped interceptors


      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
          return;
        }

        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      var promise;

      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest, undefined];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);

        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }

        return promise;
      }

      var newConfig = config;

      while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();

        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected(error);
          break;
        }
      }

      try {
        promise = dispatchRequest(newConfig);
      } catch (error) {
        return Promise.reject(error);
      }

      while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
      }

      return promise;
    };

    Axios$1.prototype.getUri = function getUri(config) {
      config = mergeConfig$1(this.defaults, config);
      return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
    }; // Provide aliases for supported request methods


    utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
      /*eslint func-names:0*/
      Axios$1.prototype[method] = function (url, config) {
        return this.request(mergeConfig$1(config || {}, {
          method: method,
          url: url,
          data: (config || {}).data
        }));
      };
    });
    utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
      /*eslint func-names:0*/
      Axios$1.prototype[method] = function (url, data, config) {
        return this.request(mergeConfig$1(config || {}, {
          method: method,
          url: url,
          data: data
        }));
      };
    });
    var Axios_1 = Axios$1;

    var Cancel = Cancel_1;
    /**
     * A `CancelToken` is an object that can be used to request cancellation of an operation.
     *
     * @class
     * @param {Function} executor The executor function.
     */

    function CancelToken(executor) {
      if (typeof executor !== 'function') {
        throw new TypeError('executor must be a function.');
      }

      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this; // eslint-disable-next-line func-names

      this.promise.then(function (cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;

        for (i = 0; i < l; i++) {
          token._listeners[i](cancel);
        }

        token._listeners = null;
      }); // eslint-disable-next-line func-names

      this.promise.then = function (onfulfilled) {
        var _resolve; // eslint-disable-next-line func-names


        var promise = new Promise(function (resolve) {
          token.subscribe(resolve);
          _resolve = resolve;
        }).then(onfulfilled);

        promise.cancel = function reject() {
          token.unsubscribe(_resolve);
        };

        return promise;
      };

      executor(function cancel(message) {
        if (token.reason) {
          // Cancellation has already been requested
          return;
        }

        token.reason = new Cancel(message);
        resolvePromise(token.reason);
      });
    }
    /**
     * Throws a `Cancel` if cancellation has been requested.
     */


    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    /**
     * Subscribe to the cancel signal
     */


    CancelToken.prototype.subscribe = function subscribe(listener) {
      if (this.reason) {
        listener(this.reason);
        return;
      }

      if (this._listeners) {
        this._listeners.push(listener);
      } else {
        this._listeners = [listener];
      }
    };
    /**
     * Unsubscribe from the cancel signal
     */


    CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
      if (!this._listeners) {
        return;
      }

      var index = this._listeners.indexOf(listener);

      if (index !== -1) {
        this._listeners.splice(index, 1);
      }
    };
    /**
     * Returns an object that contains a new `CancelToken` and a function that, when called,
     * cancels the `CancelToken`.
     */


    CancelToken.source = function source() {
      var cancel;
      var token = new CancelToken(function executor(c) {
        cancel = c;
      });
      return {
        token: token,
        cancel: cancel
      };
    };

    var CancelToken_1 = CancelToken;

    /**
     * Syntactic sugar for invoking a function and expanding an array for arguments.
     *
     * Common use case would be to use `Function.prototype.apply`.
     *
     *  ```js
     *  function f(x, y, z) {}
     *  var args = [1, 2, 3];
     *  f.apply(null, args);
     *  ```
     *
     * With `spread` this example can be re-written.
     *
     *  ```js
     *  spread(function(x, y, z) {})([1, 2, 3]);
     *  ```
     *
     * @param {Function} callback
     * @returns {Function}
     */


    var spread = function spread(callback) {
      return function wrap(arr) {
        return callback.apply(null, arr);
      };
    };

    /**
     * Determines whether the payload is an error thrown by Axios
     *
     * @param {*} payload The value to test
     * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
     */


    var isAxiosError = function isAxiosError(payload) {
      return typeof payload === 'object' && payload.isAxiosError === true;
    };

    var utils = utils$d;
    var bind = bind$2;
    var Axios = Axios_1;
    var mergeConfig = mergeConfig$2;
    var defaults = defaults_1;
    /**
     * Create an instance of Axios
     *
     * @param {Object} defaultConfig The default config for the instance
     * @return {Axios} A new instance of Axios
     */

    function createInstance(defaultConfig) {
      var context = new Axios(defaultConfig);
      var instance = bind(Axios.prototype.request, context); // Copy axios.prototype to instance

      utils.extend(instance, Axios.prototype, context); // Copy context to instance

      utils.extend(instance, context); // Factory for creating new instances

      instance.create = function create(instanceConfig) {
        return createInstance(mergeConfig(defaultConfig, instanceConfig));
      };

      return instance;
    } // Create the default instance to be exported


    var axios$1 = createInstance(defaults); // Expose Axios class to allow class inheritance

    axios$1.Axios = Axios; // Expose Cancel & CancelToken

    axios$1.Cancel = Cancel_1;
    axios$1.CancelToken = CancelToken_1;
    axios$1.isCancel = isCancel$1;
    axios$1.VERSION = data.version; // Expose all/spread

    axios$1.all = function all(promises) {
      return Promise.all(promises);
    };

    axios$1.spread = spread; // Expose isAxiosError

    axios$1.isAxiosError = isAxiosError;
    axios$2.exports = axios$1; // Allow use of default import syntax in TypeScript

    axios$2.exports.default = axios$1;

    var axios = axios$2.exports;

    exports.Level = void 0;
    (function (Level) {
        Level["None"] = "none";
        Level["Fatal"] = "fatal";
        Level["Error"] = "error";
        Level["Warning"] = "warning";
        Level["Info"] = "info";
        Level["Debug"] = "debug";
    })(exports.Level || (exports.Level = {}));
    exports.LevelNumber = void 0;
    (function (LevelNumber) {
        LevelNumber[LevelNumber["None"] = 1] = "None";
        LevelNumber[LevelNumber["Fatal"] = 2] = "Fatal";
        LevelNumber[LevelNumber["Error"] = 3] = "Error";
        LevelNumber[LevelNumber["Warning"] = 4] = "Warning";
        LevelNumber[LevelNumber["Info"] = 5] = "Info";
        LevelNumber[LevelNumber["Debug"] = 6] = "Debug";
    })(exports.LevelNumber || (exports.LevelNumber = {}));
    const levelNumberToLevel = {
        [exports.LevelNumber.None]: exports.Level.None,
        [exports.LevelNumber.Fatal]: exports.Level.Fatal,
        [exports.LevelNumber.Error]: exports.Level.Error,
        [exports.LevelNumber.Warning]: exports.Level.Warning,
        [exports.LevelNumber.Info]: exports.Level.Info,
        [exports.LevelNumber.Debug]: exports.Level.Debug,
    };
    const levelToLevelNumber = {
        [exports.Level.None]: exports.LevelNumber.None,
        [exports.Level.Fatal]: exports.LevelNumber.Fatal,
        [exports.Level.Error]: exports.LevelNumber.Error,
        [exports.Level.Warning]: exports.LevelNumber.Warning,
        [exports.Level.Info]: exports.LevelNumber.Info,
        [exports.Level.Debug]: exports.LevelNumber.Debug,
    };

    class BaseOutput {
        constructor(sessionId, origin, settings) {
            this._level = exports.LevelNumber.None;
            if (!sessionId || !sessionId.length) {
                throw new Error('Invalid first argument sessionsId. Expected a non zero length string.');
            }
            if (!origin || !origin) {
                throw new Error('Invalid second argument origin. Expected a non zero length string.');
            }
            this._sessionId = sessionId;
            this._origin = origin;
            if (settings && settings.level) {
                this.setLevel(settings.level);
            }
            else {
                this.setLevel(exports.Level.Info);
            }
        }
        setLevel(level) {
            if (!levelToLevelNumber[level]) {
                console.warn('hello');
                throw new Error('Invalid level, cannot transform to level number');
            }
            this._level = levelToLevelNumber[level];
        }
    }

    class ConsoleOutput extends BaseOutput {
        constructor() {
            super(...arguments);
            this._level = exports.LevelNumber.Debug;
        }
        send(err) {
            const consoleMethod = this._getConsoleMethod(exports.LevelNumber.Debug); // TODO err.level !!!
            consoleMethod(this._marshalMessage(err), err.toFlatData());
        }
        /**
         *  Retrieve the correct console processor.
         *
         *  Depends on the console logging level.
         */
        _getConsoleMethod(errorLevel) {
            // If the logging level is higher (e.g.: Less important)
            // than the set level, return a no-op function
            if (errorLevel > this._level) {
                return () => { };
            }
            switch (errorLevel) {
                case exports.LevelNumber.Debug:
                    // eslint-disable-next-line no-console
                    return window.console.debug;
                case exports.LevelNumber.Info:
                    // eslint-disable-next-line no-console
                    return window.console.info;
                case exports.LevelNumber.Warning:
                    return window.console.warn;
                case exports.LevelNumber.Error:
                case exports.LevelNumber.Fatal:
                default:
                    return window.console.error;
            }
        }
        _marshalMessage(error) {
            const parts = [
                [
                    this._sessionId,
                    this._origin,
                    error.at.toLocaleTimeString(),
                ].join(' | '),
                error.toSlug().key,
                error.toString(),
            ];
            return parts.join('\n');
        }
    }

    const SIZEOF_SHORT = 2;
    const SIZEOF_INT = 4;
    const FILE_IDENTIFIER_LENGTH = 4;
    const SIZE_PREFIX_LENGTH = 4;

    const int32 = new Int32Array(2);
    const float32 = new Float32Array(int32.buffer);
    const float64 = new Float64Array(int32.buffer);
    const isLittleEndian = new Uint16Array(new Uint8Array([1, 0]).buffer)[0] === 1;

    class Long {
      constructor(low, high) {
        this.low = low | 0;
        this.high = high | 0;
      }

      static create(low, high) {
        // Special-case zero to avoid GC overhead for default values
        return low == 0 && high == 0 ? Long.ZERO : new Long(low, high);
      }

      toFloat64() {
        return (this.low >>> 0) + this.high * 0x100000000;
      }

      equals(other) {
        return this.low == other.low && this.high == other.high;
      }

    }
    Long.ZERO = new Long(0, 0);

    var Encoding;

    (function (Encoding) {
      Encoding[Encoding["UTF8_BYTES"] = 1] = "UTF8_BYTES";
      Encoding[Encoding["UTF16_STRING"] = 2] = "UTF16_STRING";
    })(Encoding || (Encoding = {}));

    class ByteBuffer {
      /**
       * Create a new ByteBuffer with a given array of bytes (`Uint8Array`)
       */
      constructor(bytes_) {
        this.bytes_ = bytes_;
        this.position_ = 0;
      }
      /**
       * Create and allocate a new ByteBuffer with a given size.
       */


      static allocate(byte_size) {
        return new ByteBuffer(new Uint8Array(byte_size));
      }

      clear() {
        this.position_ = 0;
      }
      /**
       * Get the underlying `Uint8Array`.
       */


      bytes() {
        return this.bytes_;
      }
      /**
       * Get the buffer's position.
       */


      position() {
        return this.position_;
      }
      /**
       * Set the buffer's position.
       */


      setPosition(position) {
        this.position_ = position;
      }
      /**
       * Get the buffer's capacity.
       */


      capacity() {
        return this.bytes_.length;
      }

      readInt8(offset) {
        return this.readUint8(offset) << 24 >> 24;
      }

      readUint8(offset) {
        return this.bytes_[offset];
      }

      readInt16(offset) {
        return this.readUint16(offset) << 16 >> 16;
      }

      readUint16(offset) {
        return this.bytes_[offset] | this.bytes_[offset + 1] << 8;
      }

      readInt32(offset) {
        return this.bytes_[offset] | this.bytes_[offset + 1] << 8 | this.bytes_[offset + 2] << 16 | this.bytes_[offset + 3] << 24;
      }

      readUint32(offset) {
        return this.readInt32(offset) >>> 0;
      }

      readInt64(offset) {
        return new Long(this.readInt32(offset), this.readInt32(offset + 4));
      }

      readUint64(offset) {
        return new Long(this.readUint32(offset), this.readUint32(offset + 4));
      }

      readFloat32(offset) {
        int32[0] = this.readInt32(offset);
        return float32[0];
      }

      readFloat64(offset) {
        int32[isLittleEndian ? 0 : 1] = this.readInt32(offset);
        int32[isLittleEndian ? 1 : 0] = this.readInt32(offset + 4);
        return float64[0];
      }

      writeInt8(offset, value) {
        this.bytes_[offset] = value;
      }

      writeUint8(offset, value) {
        this.bytes_[offset] = value;
      }

      writeInt16(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
      }

      writeUint16(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
      }

      writeInt32(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
        this.bytes_[offset + 2] = value >> 16;
        this.bytes_[offset + 3] = value >> 24;
      }

      writeUint32(offset, value) {
        this.bytes_[offset] = value;
        this.bytes_[offset + 1] = value >> 8;
        this.bytes_[offset + 2] = value >> 16;
        this.bytes_[offset + 3] = value >> 24;
      }

      writeInt64(offset, value) {
        this.writeInt32(offset, value.low);
        this.writeInt32(offset + 4, value.high);
      }

      writeUint64(offset, value) {
        this.writeUint32(offset, value.low);
        this.writeUint32(offset + 4, value.high);
      }

      writeFloat32(offset, value) {
        float32[0] = value;
        this.writeInt32(offset, int32[0]);
      }

      writeFloat64(offset, value) {
        float64[0] = value;
        this.writeInt32(offset, int32[isLittleEndian ? 0 : 1]);
        this.writeInt32(offset + 4, int32[isLittleEndian ? 1 : 0]);
      }
      /**
       * Return the file identifier.   Behavior is undefined for FlatBuffers whose
       * schema does not include a file_identifier (likely points at padding or the
       * start of a the root vtable).
       */


      getBufferIdentifier() {
        if (this.bytes_.length < this.position_ + SIZEOF_INT + FILE_IDENTIFIER_LENGTH) {
          throw new Error('FlatBuffers: ByteBuffer is too short to contain an identifier.');
        }

        let result = "";

        for (let i = 0; i < FILE_IDENTIFIER_LENGTH; i++) {
          result += String.fromCharCode(this.readInt8(this.position_ + SIZEOF_INT + i));
        }

        return result;
      }
      /**
       * Look up a field in the vtable, return an offset into the object, or 0 if the
       * field is not present.
       */


      __offset(bb_pos, vtable_offset) {
        const vtable = bb_pos - this.readInt32(bb_pos);
        return vtable_offset < this.readInt16(vtable) ? this.readInt16(vtable + vtable_offset) : 0;
      }
      /**
       * Initialize any Table-derived type to point to the union at the given offset.
       */


      __union(t, offset) {
        t.bb_pos = offset + this.readInt32(offset);
        t.bb = this;
        return t;
      }
      /**
       * Create a JavaScript string from UTF-8 data stored inside the FlatBuffer.
       * This allocates a new string and converts to wide chars upon each access.
       *
       * To avoid the conversion to UTF-16, pass Encoding.UTF8_BYTES as
       * the "optionalEncoding" argument. This is useful for avoiding conversion to
       * and from UTF-16 when the data will just be packaged back up in another
       * FlatBuffer later on.
       *
       * @param offset
       * @param opt_encoding Defaults to UTF16_STRING
       */


      __string(offset, opt_encoding) {
        offset += this.readInt32(offset);
        const length = this.readInt32(offset);
        let result = '';
        let i = 0;
        offset += SIZEOF_INT;

        if (opt_encoding === Encoding.UTF8_BYTES) {
          return this.bytes_.subarray(offset, offset + length);
        }

        while (i < length) {
          let codePoint; // Decode UTF-8

          const a = this.readUint8(offset + i++);

          if (a < 0xC0) {
            codePoint = a;
          } else {
            const b = this.readUint8(offset + i++);

            if (a < 0xE0) {
              codePoint = (a & 0x1F) << 6 | b & 0x3F;
            } else {
              const c = this.readUint8(offset + i++);

              if (a < 0xF0) {
                codePoint = (a & 0x0F) << 12 | (b & 0x3F) << 6 | c & 0x3F;
              } else {
                const d = this.readUint8(offset + i++);
                codePoint = (a & 0x07) << 18 | (b & 0x3F) << 12 | (c & 0x3F) << 6 | d & 0x3F;
              }
            }
          } // Encode UTF-16


          if (codePoint < 0x10000) {
            result += String.fromCharCode(codePoint);
          } else {
            codePoint -= 0x10000;
            result += String.fromCharCode((codePoint >> 10) + 0xD800, (codePoint & (1 << 10) - 1) + 0xDC00);
          }
        }

        return result;
      }
      /**
       * Handle unions that can contain string as its member, if a Table-derived type then initialize it,
       * if a string then return a new one
       *
       * WARNING: strings are immutable in JS so we can't change the string that the user gave us, this
       * makes the behaviour of __union_with_string different compared to __union
       */


      __union_with_string(o, offset) {
        if (typeof o === 'string') {
          return this.__string(offset);
        }

        return this.__union(o, offset);
      }
      /**
       * Retrieve the relative offset stored at "offset"
       */


      __indirect(offset) {
        return offset + this.readInt32(offset);
      }
      /**
       * Get the start of data of a vector whose offset is stored at "offset" in this object.
       */


      __vector(offset) {
        return offset + this.readInt32(offset) + SIZEOF_INT; // data starts after the length
      }
      /**
       * Get the length of a vector whose offset is stored at "offset" in this object.
       */


      __vector_len(offset) {
        return this.readInt32(offset + this.readInt32(offset));
      }

      __has_identifier(ident) {
        if (ident.length != FILE_IDENTIFIER_LENGTH) {
          throw new Error('FlatBuffers: file identifier must be length ' + FILE_IDENTIFIER_LENGTH);
        }

        for (let i = 0; i < FILE_IDENTIFIER_LENGTH; i++) {
          if (ident.charCodeAt(i) != this.readInt8(this.position() + SIZEOF_INT + i)) {
            return false;
          }
        }

        return true;
      }
      /**
       * A helper function to avoid generated code depending on this file directly.
       */


      createLong(low, high) {
        return Long.create(low, high);
      }
      /**
       * A helper function for generating list for obj api
       */


      createScalarList(listAccessor, listLength) {
        const ret = [];

        for (let i = 0; i < listLength; ++i) {
          if (listAccessor(i) !== null) {
            ret.push(listAccessor(i));
          }
        }

        return ret;
      }
      /**
       * A helper function for generating list for obj api
       * @param listAccessor function that accepts an index and return data at that index
       * @param listLength listLength
       * @param res result list
       */


      createObjList(listAccessor, listLength) {
        const ret = [];

        for (let i = 0; i < listLength; ++i) {
          const val = listAccessor(i);

          if (val !== null) {
            ret.push(val.unpack());
          }
        }

        return ret;
      }

    }

    class Builder {
      /**
       * Create a FlatBufferBuilder.
       */
      constructor(opt_initial_size) {
        /** Minimum alignment encountered so far. */
        this.minalign = 1;
        /** The vtable for the current table. */

        this.vtable = null;
        /** The amount of fields we're actually using. */

        this.vtable_in_use = 0;
        /** Whether we are currently serializing a table. */

        this.isNested = false;
        /** Starting offset of the current struct/table. */

        this.object_start = 0;
        /** List of offsets of all vtables. */

        this.vtables = [];
        /** For the current vector being built. */

        this.vector_num_elems = 0;
        /** False omits default values from the serialized data */

        this.force_defaults = false;
        this.string_maps = null;
        let initial_size;

        if (!opt_initial_size) {
          initial_size = 1024;
        } else {
          initial_size = opt_initial_size;
        }
        /**
         * @type {ByteBuffer}
         * @private
         */


        this.bb = ByteBuffer.allocate(initial_size);
        this.space = initial_size;
      }

      clear() {
        this.bb.clear();
        this.space = this.bb.capacity();
        this.minalign = 1;
        this.vtable = null;
        this.vtable_in_use = 0;
        this.isNested = false;
        this.object_start = 0;
        this.vtables = [];
        this.vector_num_elems = 0;
        this.force_defaults = false;
        this.string_maps = null;
      }
      /**
       * In order to save space, fields that are set to their default value
       * don't get serialized into the buffer. Forcing defaults provides a
       * way to manually disable this optimization.
       *
       * @param forceDefaults true always serializes default values
       */


      forceDefaults(forceDefaults) {
        this.force_defaults = forceDefaults;
      }
      /**
       * Get the ByteBuffer representing the FlatBuffer. Only call this after you've
       * called finish(). The actual data starts at the ByteBuffer's current position,
       * not necessarily at 0.
       */


      dataBuffer() {
        return this.bb;
      }
      /**
       * Get the bytes representing the FlatBuffer. Only call this after you've
       * called finish().
       */


      asUint8Array() {
        return this.bb.bytes().subarray(this.bb.position(), this.bb.position() + this.offset());
      }
      /**
       * Prepare to write an element of `size` after `additional_bytes` have been
       * written, e.g. if you write a string, you need to align such the int length
       * field is aligned to 4 bytes, and the string data follows it directly. If all
       * you need to do is alignment, `additional_bytes` will be 0.
       *
       * @param size This is the of the new element to write
       * @param additional_bytes The padding size
       */


      prep(size, additional_bytes) {
        // Track the biggest thing we've ever aligned to.
        if (size > this.minalign) {
          this.minalign = size;
        } // Find the amount of alignment needed such that `size` is properly
        // aligned after `additional_bytes`


        const align_size = ~(this.bb.capacity() - this.space + additional_bytes) + 1 & size - 1; // Reallocate the buffer if needed.

        while (this.space < align_size + size + additional_bytes) {
          const old_buf_size = this.bb.capacity();
          this.bb = Builder.growByteBuffer(this.bb);
          this.space += this.bb.capacity() - old_buf_size;
        }

        this.pad(align_size);
      }

      pad(byte_size) {
        for (let i = 0; i < byte_size; i++) {
          this.bb.writeInt8(--this.space, 0);
        }
      }

      writeInt8(value) {
        this.bb.writeInt8(this.space -= 1, value);
      }

      writeInt16(value) {
        this.bb.writeInt16(this.space -= 2, value);
      }

      writeInt32(value) {
        this.bb.writeInt32(this.space -= 4, value);
      }

      writeInt64(value) {
        this.bb.writeInt64(this.space -= 8, value);
      }

      writeFloat32(value) {
        this.bb.writeFloat32(this.space -= 4, value);
      }

      writeFloat64(value) {
        this.bb.writeFloat64(this.space -= 8, value);
      }
      /**
       * Add an `int8` to the buffer, properly aligned, and grows the buffer (if necessary).
       * @param value The `int8` to add the the buffer.
       */


      addInt8(value) {
        this.prep(1, 0);
        this.writeInt8(value);
      }
      /**
       * Add an `int16` to the buffer, properly aligned, and grows the buffer (if necessary).
       * @param value The `int16` to add the the buffer.
       */


      addInt16(value) {
        this.prep(2, 0);
        this.writeInt16(value);
      }
      /**
       * Add an `int32` to the buffer, properly aligned, and grows the buffer (if necessary).
       * @param value The `int32` to add the the buffer.
       */


      addInt32(value) {
        this.prep(4, 0);
        this.writeInt32(value);
      }
      /**
       * Add an `int64` to the buffer, properly aligned, and grows the buffer (if necessary).
       * @param value The `int64` to add the the buffer.
       */


      addInt64(value) {
        this.prep(8, 0);
        this.writeInt64(value);
      }
      /**
       * Add a `float32` to the buffer, properly aligned, and grows the buffer (if necessary).
       * @param value The `float32` to add the the buffer.
       */


      addFloat32(value) {
        this.prep(4, 0);
        this.writeFloat32(value);
      }
      /**
       * Add a `float64` to the buffer, properly aligned, and grows the buffer (if necessary).
       * @param value The `float64` to add the the buffer.
       */


      addFloat64(value) {
        this.prep(8, 0);
        this.writeFloat64(value);
      }

      addFieldInt8(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
          this.addInt8(value);
          this.slot(voffset);
        }
      }

      addFieldInt16(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
          this.addInt16(value);
          this.slot(voffset);
        }
      }

      addFieldInt32(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
          this.addInt32(value);
          this.slot(voffset);
        }
      }

      addFieldInt64(voffset, value, defaultValue) {
        if (this.force_defaults || !value.equals(defaultValue)) {
          this.addInt64(value);
          this.slot(voffset);
        }
      }

      addFieldFloat32(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
          this.addFloat32(value);
          this.slot(voffset);
        }
      }

      addFieldFloat64(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
          this.addFloat64(value);
          this.slot(voffset);
        }
      }

      addFieldOffset(voffset, value, defaultValue) {
        if (this.force_defaults || value != defaultValue) {
          this.addOffset(value);
          this.slot(voffset);
        }
      }
      /**
       * Structs are stored inline, so nothing additional is being added. `d` is always 0.
       */


      addFieldStruct(voffset, value, defaultValue) {
        if (value != defaultValue) {
          this.nested(value);
          this.slot(voffset);
        }
      }
      /**
       * Structures are always stored inline, they need to be created right
       * where they're used.  You'll get this assertion failure if you
       * created it elsewhere.
       */


      nested(obj) {
        if (obj != this.offset()) {
          throw new Error('FlatBuffers: struct must be serialized inline.');
        }
      }
      /**
       * Should not be creating any other object, string or vector
       * while an object is being constructed
       */


      notNested() {
        if (this.isNested) {
          throw new Error('FlatBuffers: object serialization must not be nested.');
        }
      }
      /**
       * Set the current vtable at `voffset` to the current location in the buffer.
       */


      slot(voffset) {
        if (this.vtable !== null) this.vtable[voffset] = this.offset();
      }
      /**
       * @returns Offset relative to the end of the buffer.
       */


      offset() {
        return this.bb.capacity() - this.space;
      }
      /**
       * Doubles the size of the backing ByteBuffer and copies the old data towards
       * the end of the new buffer (since we build the buffer backwards).
       *
       * @param bb The current buffer with the existing data
       * @returns A new byte buffer with the old data copied
       * to it. The data is located at the end of the buffer.
       *
       * uint8Array.set() formally takes {Array<number>|ArrayBufferView}, so to pass
       * it a uint8Array we need to suppress the type check:
       * @suppress {checkTypes}
       */


      static growByteBuffer(bb) {
        const old_buf_size = bb.capacity(); // Ensure we don't grow beyond what fits in an int.

        if (old_buf_size & 0xC0000000) {
          throw new Error('FlatBuffers: cannot grow buffer beyond 2 gigabytes.');
        }

        const new_buf_size = old_buf_size << 1;
        const nbb = ByteBuffer.allocate(new_buf_size);
        nbb.setPosition(new_buf_size - old_buf_size);
        nbb.bytes().set(bb.bytes(), new_buf_size - old_buf_size);
        return nbb;
      }
      /**
       * Adds on offset, relative to where it will be written.
       *
       * @param offset The offset to add.
       */


      addOffset(offset) {
        this.prep(SIZEOF_INT, 0); // Ensure alignment is already done.

        this.writeInt32(this.offset() - offset + SIZEOF_INT);
      }
      /**
       * Start encoding a new object in the buffer.  Users will not usually need to
       * call this directly. The FlatBuffers compiler will generate helper methods
       * that call this method internally.
       */


      startObject(numfields) {
        this.notNested();

        if (this.vtable == null) {
          this.vtable = [];
        }

        this.vtable_in_use = numfields;

        for (let i = 0; i < numfields; i++) {
          this.vtable[i] = 0; // This will push additional elements as needed
        }

        this.isNested = true;
        this.object_start = this.offset();
      }
      /**
       * Finish off writing the object that is under construction.
       *
       * @returns The offset to the object inside `dataBuffer`
       */


      endObject() {
        if (this.vtable == null || !this.isNested) {
          throw new Error('FlatBuffers: endObject called without startObject');
        }

        this.addInt32(0);
        const vtableloc = this.offset(); // Trim trailing zeroes.

        let i = this.vtable_in_use - 1; // eslint-disable-next-line no-empty

        for (; i >= 0 && this.vtable[i] == 0; i--) {}

        const trimmed_size = i + 1; // Write out the current vtable.

        for (; i >= 0; i--) {
          // Offset relative to the start of the table.
          this.addInt16(this.vtable[i] != 0 ? vtableloc - this.vtable[i] : 0);
        }

        const standard_fields = 2; // The fields below:

        this.addInt16(vtableloc - this.object_start);
        const len = (trimmed_size + standard_fields) * SIZEOF_SHORT;
        this.addInt16(len); // Search for an existing vtable that matches the current one.

        let existing_vtable = 0;
        const vt1 = this.space;

        outer_loop: for (i = 0; i < this.vtables.length; i++) {
          const vt2 = this.bb.capacity() - this.vtables[i];

          if (len == this.bb.readInt16(vt2)) {
            for (let j = SIZEOF_SHORT; j < len; j += SIZEOF_SHORT) {
              if (this.bb.readInt16(vt1 + j) != this.bb.readInt16(vt2 + j)) {
                continue outer_loop;
              }
            }

            existing_vtable = this.vtables[i];
            break;
          }
        }

        if (existing_vtable) {
          // Found a match:
          // Remove the current vtable.
          this.space = this.bb.capacity() - vtableloc; // Point table to existing vtable.

          this.bb.writeInt32(this.space, existing_vtable - vtableloc);
        } else {
          // No match:
          // Add the location of the current vtable to the list of vtables.
          this.vtables.push(this.offset()); // Point table to current vtable.

          this.bb.writeInt32(this.bb.capacity() - vtableloc, this.offset() - vtableloc);
        }

        this.isNested = false;
        return vtableloc;
      }
      /**
       * Finalize a buffer, poiting to the given `root_table`.
       */


      finish(root_table, opt_file_identifier, opt_size_prefix) {
        const size_prefix = opt_size_prefix ? SIZE_PREFIX_LENGTH : 0;

        if (opt_file_identifier) {
          const file_identifier = opt_file_identifier;
          this.prep(this.minalign, SIZEOF_INT + FILE_IDENTIFIER_LENGTH + size_prefix);

          if (file_identifier.length != FILE_IDENTIFIER_LENGTH) {
            throw new Error('FlatBuffers: file identifier must be length ' + FILE_IDENTIFIER_LENGTH);
          }

          for (let i = FILE_IDENTIFIER_LENGTH - 1; i >= 0; i--) {
            this.writeInt8(file_identifier.charCodeAt(i));
          }
        }

        this.prep(this.minalign, SIZEOF_INT + size_prefix);
        this.addOffset(root_table);

        if (size_prefix) {
          this.addInt32(this.bb.capacity() - this.space);
        }

        this.bb.setPosition(this.space);
      }
      /**
       * Finalize a size prefixed buffer, pointing to the given `root_table`.
       */


      finishSizePrefixed(root_table, opt_file_identifier) {
        this.finish(root_table, opt_file_identifier, true);
      }
      /**
       * This checks a required field has been set in a given table that has
       * just been constructed.
       */


      requiredField(table, field) {
        const table_start = this.bb.capacity() - table;
        const vtable_start = table_start - this.bb.readInt32(table_start);
        const ok = this.bb.readInt16(vtable_start + field) != 0; // If this fails, the caller will show what field needs to be set.

        if (!ok) {
          throw new Error('FlatBuffers: field ' + field + ' must be set');
        }
      }
      /**
       * Start a new array/vector of objects.  Users usually will not call
       * this directly. The FlatBuffers compiler will create a start/end
       * method for vector types in generated code.
       *
       * @param elem_size The size of each element in the array
       * @param num_elems The number of elements in the array
       * @param alignment The alignment of the array
       */


      startVector(elem_size, num_elems, alignment) {
        this.notNested();
        this.vector_num_elems = num_elems;
        this.prep(SIZEOF_INT, elem_size * num_elems);
        this.prep(alignment, elem_size * num_elems); // Just in case alignment > int.
      }
      /**
       * Finish off the creation of an array and all its elements. The array must be
       * created with `startVector`.
       *
       * @returns The offset at which the newly created array
       * starts.
       */


      endVector() {
        this.writeInt32(this.vector_num_elems);
        return this.offset();
      }
      /**
       * Encode the string `s` in the buffer using UTF-8. If the string passed has
       * already been seen, we return the offset of the already written string
       *
       * @param s The string to encode
       * @return The offset in the buffer where the encoded string starts
       */


      createSharedString(s) {
        if (!s) {
          return 0;
        }

        if (!this.string_maps) {
          this.string_maps = new Map();
        }

        if (this.string_maps.has(s)) {
          return this.string_maps.get(s);
        }

        const offset = this.createString(s);
        this.string_maps.set(s, offset);
        return offset;
      }
      /**
       * Encode the string `s` in the buffer using UTF-8. If a Uint8Array is passed
       * instead of a string, it is assumed to contain valid UTF-8 encoded data.
       *
       * @param s The string to encode
       * @return The offset in the buffer where the encoded string starts
       */


      createString(s) {
        if (!s) {
          return 0;
        }

        let utf8;

        if (s instanceof Uint8Array) {
          utf8 = s;
        } else {
          utf8 = [];
          let i = 0;

          while (i < s.length) {
            let codePoint; // Decode UTF-16

            const a = s.charCodeAt(i++);

            if (a < 0xD800 || a >= 0xDC00) {
              codePoint = a;
            } else {
              const b = s.charCodeAt(i++);
              codePoint = (a << 10) + b + (0x10000 - (0xD800 << 10) - 0xDC00);
            } // Encode UTF-8


            if (codePoint < 0x80) {
              utf8.push(codePoint);
            } else {
              if (codePoint < 0x800) {
                utf8.push(codePoint >> 6 & 0x1F | 0xC0);
              } else {
                if (codePoint < 0x10000) {
                  utf8.push(codePoint >> 12 & 0x0F | 0xE0);
                } else {
                  utf8.push(codePoint >> 18 & 0x07 | 0xF0, codePoint >> 12 & 0x3F | 0x80);
                }

                utf8.push(codePoint >> 6 & 0x3F | 0x80);
              }

              utf8.push(codePoint & 0x3F | 0x80);
            }
          }
        }

        this.addInt8(0);
        this.startVector(1, utf8.length, 1);
        this.bb.setPosition(this.space -= utf8.length);

        for (let i = 0, offset = this.space, bytes = this.bb.bytes(); i < utf8.length; i++) {
          bytes[offset++] = utf8[i];
        }

        return this.endVector();
      }
      /**
       * A helper function to avoid generated code depending on this file directly.
       */


      createLong(low, high) {
        return Long.create(low, high);
      }
      /**
       * A helper function to pack an object
       *
       * @returns offset of obj
       */


      createObjectOffset(obj) {
        if (obj === null) {
          return 0;
        }

        if (typeof obj === 'string') {
          return this.createString(obj);
        } else {
          return obj.pack(this);
        }
      }
      /**
       * A helper function to pack a list of object
       *
       * @returns list of offsets of each non null object
       */


      createObjectOffsetList(list) {
        const ret = [];

        for (let i = 0; i < list.length; ++i) {
          const val = list[i];

          if (val !== null) {
            ret.push(this.createObjectOffset(val));
          } else {
            throw new Error('FlatBuffers: Argument for createObjectOffsetList cannot contain null.');
          }
        }

        return ret;
      }

      createStructOffsetList(list, startFunc) {
        startFunc(this, list.length);
        this.createObjectOffsetList(list);
        return this.endVector();
      }

    }

    function getProtocolAndHostPathFromUrl(url) {
        const proto = url.startsWith('http://') ? 'http' : 'https';
        const hostPath = url
            .replace(/^(?:[a-z]+:)?\/\//, '')
            .replace(/\/*$/, '');
        return [proto, hostPath];
    }
    function buildFlatBuffer(level, slug, data) {
        const builder = new Builder(128);
        const messageOffset = builder.createString(slug);
        const fieldsArr = [];
        for (const [key, value] of Object.entries(data)) {
            const keyOffset = builder.createString(key);
            const valueOffset = builder.createString(value);
            builder.startObject(2);
            builder.addFieldOffset(0, keyOffset, 0);
            builder.addFieldOffset(1, valueOffset, 0);
            fieldsArr.unshift(builder.endObject());
        }
        builder.startVector(4, fieldsArr.length, 4);
        for (const offset of fieldsArr) {
            builder.addOffset(offset);
        }
        const fieldsOffset = builder.endVector();
        builder.startObject(3);
        builder.addFieldOffset(0, messageOffset, 0);
        builder.addFieldInt8(1, level, 0);
        builder.addFieldOffset(2, fieldsOffset, 0);
        builder.finish(builder.endObject());
        return builder.asUint8Array();
    }
    class ServiceOutput extends BaseOutput {
        constructor(sessionId, origin, settings) {
            super(sessionId, origin, settings);
            this._level = exports.LevelNumber.Error;
            if (!settings) {
                throw new Error('Missing settings for logging service output.');
            }
            if (!settings.baseUrl || !settings.baseUrl.trim().length) {
                throw new Error('Missing baseUrl settings for logging service output.');
            }
            const [proto, hostPath] = getProtocolAndHostPathFromUrl(settings.baseUrl);
            if (!hostPath.trim().length) {
                throw new Error('Invalid base url for logging service output, expected a host name.');
            }
            this._url = `${proto}://${hostPath}`;
            this._http = settings.http || axios.create();
        }
        async send(err) {
            try {
                // TODO err.level ?? NOW EVERYTHING IS FATAL!!!
                await this._http.post(this._url, Buffer.from(buildFlatBuffer(exports.LevelNumber.Fatal, err.toString(), {
                    ...err.toFlatData(),
                    sessionId: this._sessionId,
                    origin: this._origin,
                })));
            }
            catch (e) {
                window.console.error('Failed to send log to external service', e);
            }
        }
    }

    let random = bytes => crypto.getRandomValues(new Uint8Array(bytes));

    let customRandom = (alphabet, size, getRandom) => {
      let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
      let step = -~(1.6 * mask * size / alphabet.length);
      return () => {
        let id = '';

        while (true) {
          let bytes = getRandom(step);
          let j = step;

          while (j--) {
            id += alphabet[bytes[j] & mask] || '';
            if (id.length === size) return id;
          }
        }
      };
    };

    let customAlphabet = (alphabet, size) => customRandom(alphabet, size, random);

    // Note: with this alphabet and 12 chars, there is roughly a 1% chance of at least one collision after about 28 days.
    // This is assuming 100.000 ids per hour.
    // src: https://zelark.github.io/nano-id-cc/
    const sessionIdGenerator = customAlphabet('346789ABCDEFGHJKLMNPQRTUVWXY', 12);
    class Logger {
        constructor(origin, config) {
            this._outputs = [];
            this._origin = origin;
            this._sessionId = config && config.sessionId ? config.sessionId : Logger.generateSessionId();
            this.addOutput(ConsoleOutput);
        }
        static generateSessionId() {
            return sessionIdGenerator();
        }
        get sessionId() {
            return this._sessionId;
        }
        addOutput(OutputConstructor, ...settings) {
            const output = new OutputConstructor(this._sessionId, this._origin, ...settings);
            this._outputs.push(output);
            return output;
        }
        throw(error) {
            if (!error || !error.isOpenTicketError) {
                console.error('Failed to throw error, error object is not an OpenTicketError', error);
                this.log(new UnexpectedError(error));
            }
            else {
                this.log(error);
            }
            throw error;
        }
        log(error) {
            let err = error;
            if (!error || !error.isOpenTicketError) {
                console.error('Failed to properly log error, error object is not an OpenTicketError', error);
                err = new UnexpectedError(error);
            }
            this._send(err);
        }
        _send(err) {
            for (const output of this._outputs) {
                // Any logging should be handled outside of execution scope.
                // This should not block any other 'processes'.
                void new Promise((resolve) => {
                    output.send(err);
                    resolve();
                });
            }
        }
    }

    class CrudRoot extends CrudNode {
        constructor(config) {
            super(null, 'root');
            this.$config = config;
            this._http = config.http || axios.create();
            this._factory = new CrudFactory({
                models: config.models,
            });
            this._logger = new Logger(config.origin);
        }
        get $http() {
            return this._http;
        }
        get $root() {
            return this;
        }
        get $factory() {
            return this._factory;
        }
        get $log() {
            return this._logger;
        }
        get $path() {
            return this.$config.baseUrl;
        }
        getRelation(type) {
            for (const prop of Object.values(this)) {
                if (prop instanceof CrudToMany && prop.type === type) {
                    return prop;
                }
            }
            throw Error(`Root relation for type ${type} not found`);
        }
        get $routes() {
            const routes = [];
            for (const prop of Object.values(this)) {
                if (prop instanceof CrudNode) {
                    routes.push(...prop.$routes);
                }
            }
            return routes;
        }
    }

    /**
     * Class for interacting with Pickable implementations, such as the Pick CRUD mixin
     */
    class Picker {
        constructor(parent) {
            this.hasLocalChanges = false;
            this.count = 0;
            this.linked = {};
            this._originalLinked = {};
            this._models = {};
            this.pending = {
                link: [],
                unlink: [],
            };
            this.getPickerPage = async (request) => {
                const response = await this._parent.getPickerPage(request);
                this._updateLinkedData(response);
                return response;
            };
            this._parent = parent;
        }
        // Link a model in the local state, add as a pending operation
        link(model) {
            const unlinkIndex = this.pending.unlink.indexOf(model.guid);
            if (unlinkIndex > -1) {
                this.pending.unlink.splice(unlinkIndex, 1);
            }
            else {
                this.pending.link.push(model.guid);
            }
            this.linked[model.guid] = true;
            this.count++;
            this._updateHasLocalChanges();
        }
        // Unlink a model in the local state, add as a pending operation
        unlink(model) {
            const linkIndex = this.pending.link.indexOf(model.guid);
            if (linkIndex > -1) {
                this.pending.link.splice(linkIndex, 1);
            }
            else {
                this.pending.unlink.push(model.guid);
            }
            this.linked[model.guid] = false;
            this.count--;
            this._updateHasLocalChanges();
        }
        // Save the pending operations via the NestedPickable and apply changes
        // to the local state.
        async save() {
            const promises = [];
            if (this.pending.link.length) {
                promises.push(this._parent.linkPickerModels(this.pending.link));
            }
            if (this.pending.unlink.length) {
                promises.push(this._parent.unlinkPickerModels(this.pending.unlink));
            }
            if (!promises.length) {
                return;
            }
            await Promise.all(promises);
            for (const guid of this.pending.link) {
                this._originalLinked[guid] = true;
            }
            for (const guid of this.pending.unlink) {
                this._originalLinked[guid] = false;
            }
            // Update local state to reflect applied changes
            this.reset();
            // Recount linked items
            this.count = Object.values(this.linked).filter((linked) => linked).length;
        }
        // Undo pending changes and reset linked states
        reset() {
            this.pending.link = [];
            this.pending.unlink = [];
            Object.assign(this.linked, this._originalLinked);
            this._updateHasLocalChanges();
        }
        // set `.hasLocalChanges` depending on whether or not there are
        // pending local changes to save.
        _updateHasLocalChanges() {
            this.hasLocalChanges = !!(this.pending.link.length || this.pending.unlink.length);
        }
        // Add metadata to the local state
        _updateLinkedData(response) {
            for (let i = 0; i < response.data.length; i++) {
                const item = response.data[i];
                // Read the linked state of a model from the raw properties passed to it from the NestedPickable
                this._originalLinked[item.guid] = !!item.raw.linked;
                this.linked[item.guid] = !!item.raw.linked;
                // If linked, update the total linked count
                if (!!item.raw.linked && !this._models[item.guid]) {
                    this.count++;
                }
                this._models[item.guid] = item;
            }
        }
    }

    /**
     * Class for interacting with NestedPickable implementations, such as the NestedPick CRUD mixin
     */
    class NestedPicker {
        // NestedPicker needs a NestedPickable implementation to function, for
        // example the nested_pick CRUD mixin.
        constructor(parent) {
            // True when there are pending local changes
            this.hasLocalChanges = false;
            // Nested map with to retrieve the linked state of an item,
            // structure: [PickerSumsModel.guid][PickerModel.guid]
            this.linked = {};
            // Number of linked items per PickerSumsModel.guid
            this.count = {};
            // Pending operations
            this.pending = {};
            this._models = {};
            // Get page of PickerModels by PickerSumsModel.guid
            this.getNestedPage = async (request) => {
                // Retrieve page from NestedPickable implementations
                const response = await this._parent.getPickerNestedPage(request);
                // Set linked metadata
                this._setLinkedStatus(request, response);
                return response;
            };
            // Get page of PickerSumsModels
            this.getSumsPage = async (request) => {
                // Retrieve page from NestedPickable implementations
                const response = await this._parent.getPickerSumsPage(request);
                // Set linked metadata
                this._setSumsLinkedStatus(response);
                return response;
            };
            this._parent = parent;
        }
        // Save the pending operations via the NestedPickable and apply changes
        // to the local state.
        async save() {
            const link = [];
            const unlink = [];
            for (const nestedPending of Object.values(this.pending)) {
                link.push(...nestedPending.link);
                unlink.push(...nestedPending.unlink);
            }
            const promises = [];
            // Add link call to pending promises
            if (link.length) {
                promises.push(this._parent.linkPickerModels(link));
            }
            // Add unlink call to pending promises
            if (unlink.length) {
                promises.push(this._parent.unlinkPickerModels(unlink));
            }
            await Promise.all(promises);
            // Apply changes to local state, clear pending actions
            for (const sumsGuid of Object.keys(this.pending)) {
                for (const linked of this.pending[sumsGuid].link) {
                    this.linked[sumsGuid][linked] = true;
                }
                for (const unlinked of this.pending[sumsGuid].unlink) {
                    this.linked[sumsGuid][unlinked] = false;
                }
                this.pending[sumsGuid].link = [];
                this.pending[sumsGuid].unlink = [];
            }
            // Update local changes state, hasLocalChanges is `false` after
            // a successful `.save` operation.
            this._updateHasLocalChanges();
        }
        // Undo pending changes and reset linked states
        reset() {
            for (const sumsGuid of Object.keys(this.pending)) {
                for (const linked of this.pending[sumsGuid].link) {
                    this.linked[sumsGuid][linked] = false;
                }
                for (const unlinked of this.pending[sumsGuid].unlink) {
                    this.linked[sumsGuid][unlinked] = true;
                }
                this.pending[sumsGuid].link = [];
                this.pending[sumsGuid].unlink = [];
            }
        }
        // Link a model in the local state, add as a pending operation
        link(sumsGuid, model) {
            const unlinkIndex = this.pending[sumsGuid].unlink.indexOf(model.guid);
            if (unlinkIndex > -1) {
                this.pending[sumsGuid].unlink.splice(unlinkIndex, 1);
            }
            else {
                this.pending[sumsGuid].link.push(model.guid);
            }
            this.linked[sumsGuid][model.guid] = true;
            this.count[sumsGuid]++;
            this._updateHasLocalChanges();
        }
        // Unlink a model in the local state, add as a pending operation
        unlink(sumsGuid, model) {
            const linkIndex = this.pending[sumsGuid].link.indexOf(model.guid);
            if (linkIndex > -1) {
                this.pending[sumsGuid].link.splice(linkIndex, 1);
            }
            else {
                this.pending[sumsGuid].unlink.push(model.guid);
            }
            this.linked[sumsGuid][model.guid] = false;
            this.count[sumsGuid]--;
            this._updateHasLocalChanges();
        }
        // Add sums metadata to the local state
        _setSumsLinkedStatus(response) {
            response.data.forEach((model) => {
                if (!this.count[model.guid]) {
                    this.count[model.guid] = model.raw.linked;
                }
            });
        }
        // Add nested metadata to the local state
        _setLinkedStatus(request, response) {
            if (!this.linked[request.guid]) {
                this.linked[request.guid] = {};
            }
            if (!this.pending[request.guid]) {
                this.pending[request.guid] = {
                    link: [],
                    unlink: [],
                };
            }
            response.data.forEach((model) => {
                this._models[model.guid] = model;
                if (this.linked[request.guid][model.guid] === undefined) {
                    this.linked[request.guid][model.guid] = !!model.raw.linked;
                }
            });
        }
        // set `.hasLocalChanges` depending on whether or not there are
        // pending local changes to save.
        _updateHasLocalChanges() {
            for (const nestedPending of Object.values(this.pending)) {
                if (nestedPending.link.length || nestedPending.unlink.length) {
                    this.hasLocalChanges = true;
                    return;
                }
            }
            this.hasLocalChanges = false;
        }
    }

    function arr_move(arr, oldIndex, newIndex) {
        const element = arr[oldIndex];
        arr.splice(oldIndex, 1);
        arr.splice(newIndex, 0, element);
    }
    class Sorter {
        constructor(parent) {
            this._dirty = [];
            this._original = [];
            this._events = [];
            this.getPage = async (request) => {
                const response = await this._parent.getSortedPage(request);
                this._updateSortData(response);
                return response;
            };
            this._parent = parent;
        }
        hasLocalChanges() {
            for (let i = 0; i < this._original.length; i++) {
                if (this._original[i].guid !== this._dirty[i].guid) {
                    return true;
                }
            }
            return false;
        }
        move(oldIndex, newIndex) {
            const item = this._dirty[oldIndex];
            const anchor = this._dirty[newIndex];
            // Depending on in which direction the move is, use 'after' or 'before'
            // to specify the relative position to the anchor element
            const order = newIndex > oldIndex ? 'after' : 'before';
            arr_move(this._dirty, oldIndex, newIndex);
            this._events.push({
                item,
                order,
                anchor,
            });
        }
        async save() {
            try {
                for (const event of this._events) {
                    await this._parent.sortModel(event.item, event.order, event.anchor);
                    const oldIndex = this._dirty.findIndex((model) => model.guid === event.item.guid);
                    const newIndex = this._dirty.findIndex((model) => model.guid === event.anchor.guid);
                    arr_move(this._original, oldIndex, newIndex);
                }
            }
            finally {
                this.reset();
            }
        }
        reset() {
            this._events = [];
            this._dirty = Array.from(this._original);
        }
        _updateSortData(response) {
            this._dirty.push(...response.data);
            this._original.push(...response.data);
        }
    }

    exports.PaginationOrder = void 0;
    (function (PaginationOrder) {
        PaginationOrder["ASC"] = "asc";
        PaginationOrder["DESC"] = "desc";
    })(exports.PaginationOrder || (exports.PaginationOrder = {}));

    const REFRESH_DEBOUNCE_MILLIS$1 = 300;
    class Pagination {
        constructor(paginatable, optionals) {
            this.loading = false;
            this.page = null;
            this.filters = {};
            this._ordering = {};
            this._refreshDebounce = null;
            this._refreshPromise = null;
            this._refreshPromiseResolve = null;
            this._initialized = false;
            if (typeof paginatable === 'function') {
                this._paginatable = paginatable;
            }
            else {
                this._paginatable = paginatable.getPage;
            }
            this._optionals = optionals || {};
        }
        defaults() {
            return { ...this._request };
        }
        async init(_config) {
            const config = _config || {};
            this._request = { page: 1, ...config.defaults };
            if (config && config.filters) {
                Object.assign(this.filters, config.filters);
            }
            await this.getPage(this._request);
            this._initialized = true;
        }
        async addFilter(field, value) {
            if (!this._initialized) {
                throw new StringError('Pagination not initialized');
            }
            this.filters[field] = value;
            return this._refreshWithDebounce();
        }
        async removeFilter(field) {
            if (!this._initialized) {
                throw new StringError('Pagination not initialized');
            }
            delete this.filters[field];
            return this._refreshWithDebounce();
        }
        canOrder(field) {
            if (!this._optionals.canOrder) {
                return false;
            }
            return this._optionals.canOrder(field);
        }
        getFieldOrder(field) {
            if (this._ordering[field]) {
                return this._ordering[field];
            }
            return null;
        }
        async addOrder(field, order) {
            if (!this._initialized) {
                throw new StringError('Pagination not initialized');
            }
            if (!this.canOrder(field)) {
                throw new StringError('Field cannot be ordered');
            }
            // We only support a single sort for now
            this._ordering = {
                [field]: {
                    order,
                    index: 0,
                },
            };
            return this._refreshWithDebounce();
        }
        async removeOrder(field) {
            if (!this._initialized) {
                throw new StringError('Pagination not initialized');
            }
            // We only support a single sort for now
            this._ordering = {};
            return this._refreshWithDebounce();
        }
        async refresh(request) {
            return this.getPage(request || this._request);
        }
        async getPage(request) {
            this.loading = true;
            try {
                this.page = await this._paginatable({
                    ...this._parseFilters(),
                    ...this._parseOrdering(),
                    ...this._request,
                    ...request,
                });
                return this.page;
            }
            finally {
                this.loading = false;
            }
        }
        async nextPage() {
            if (!this.page) {
                throw Error('Pagination not initialized');
            }
            return this.getPage({
                ...this._request,
                page: this.page.current_page + 1,
            });
        }
        async prevPage() {
            if (!this.page) {
                throw Error('Pagination not initialized');
            }
            return this.getPage({
                ...this._request,
                page: this.page.current_page - 1,
            });
        }
        async _refreshWithDebounce() {
            if (!this._refreshPromise) {
                this._refreshPromise = new Promise((resolve) => {
                    this._refreshPromiseResolve = resolve;
                });
            }
            this.loading = true;
            if (this._refreshDebounce) {
                window.clearTimeout(this._refreshDebounce);
            }
            this._refreshDebounce = window.setTimeout(async () => {
                this._refreshDebounce = null;
                const p = await this.getPage(this._request);
                this._refreshPromiseResolve(p);
                this._refreshPromise = null;
                this._refreshPromiseResolve = null;
            }, REFRESH_DEBOUNCE_MILLIS$1);
            return this._refreshPromise;
        }
        _parseFilters() {
            const map = {};
            for (const key of Object.keys(this.filters)) {
                map[`filter[${key}]`] = `${this.filters[key]}`;
            }
            return map;
        }
        _parseOrdering() {
            const params = {
                sort: '',
            };
            const ordered = Object
                .entries(this._ordering)
                .map(([field, ordering]) => ({ field, ...ordering }))
                .sort((a, b) => a.index - b.index);
            for (const item of ordered) {
                params.sort += item.order === exports.PaginationOrder.DESC ? `-${item.field}` : item.field;
            }
            return params;
        }
    }

    const REFRESH_DEBOUNCE_MILLIS = 300;
    class LazyList {
        constructor(paginatable, optionals) {
            this.loading = false;
            this.filters = {};
            this.data = [];
            this.hasMore = true;
            this._refreshDebounce = null;
            this._refreshPromise = null;
            this._refreshPromiseResolve = null;
            if (typeof paginatable === 'function') {
                this._paginatable = paginatable;
            }
            else {
                this._paginatable = paginatable.getPage;
            }
            this._optionals = optionals || {};
        }
        async init(_config) {
            const config = _config || {};
            this._request = { page: 1, ...config.defaults };
            this.data = [];
            this.hasMore = true;
            if (config && config.filters) {
                Object.assign(this.filters, config.filters);
            }
            await this.loadMore();
        }
        async addFilter(key, filter) {
            this.filters[key] = filter;
            await this._refreshWithDebounce();
        }
        async removeFilter(key) {
            delete this.filters[key];
            await this._refreshWithDebounce();
        }
        async refresh() {
            await this._refreshWithDebounce();
        }
        async loadMore() {
            if (!this.hasMore) {
                throw Error('No items left to retrieve');
            }
            this.loading = true;
            try {
                const page = this._request.page++;
                const res = await this._paginatable({
                    ...this._request,
                    ...this._parseFilters(),
                    page,
                });
                this.data.push(...res.data);
                if (this.data.length === res.total) {
                    this.hasMore = false;
                }
            }
            finally {
                this.loading = false;
            }
        }
        async _refreshWithDebounce() {
            if (!this._refreshPromise) {
                this._refreshPromise = new Promise((resolve) => {
                    this._refreshPromiseResolve = resolve;
                });
            }
            this.loading = true;
            this.data = [];
            if (this._refreshDebounce) {
                window.clearTimeout(this._refreshDebounce);
            }
            this._refreshDebounce = window.setTimeout(async () => {
                this._refreshDebounce = null;
                this._request.page = 1;
                await this.init({ defaults: this._request });
                this._refreshPromiseResolve();
                this._refreshPromise = null;
                this._refreshPromiseResolve = null;
            }, REFRESH_DEBOUNCE_MILLIS);
            return this._refreshPromise;
        }
        _parseFilters() {
            const map = {};
            for (const key of Object.keys(this.filters)) {
                map[`filter[${key}]`] = `${this.filters[key]}`;
            }
            return map;
        }
    }

    class ArrayPaginatable {
        constructor(data) {
            this.getPage = async (request) => {
                const total = this._data.length;
                const page = request.page || 1;
                const perPage = request.per_page || 5;
                const lastPage = Math.ceil(total / perPage);
                const data = [];
                for (let i = 0; i < perPage; i++) {
                    const j = (perPage * (page - 1)) + i;
                    if (j >= total) {
                        break;
                    }
                    data.push(this._data[j]);
                }
                return {
                    current_page: page,
                    last_page: lastPage,
                    per_page: perPage,
                    total,
                    data,
                    path: '',
                    first_page_url: '',
                    last_page_url: '',
                    from: '',
                    to: '',
                };
            };
            this._data = data;
        }
    }

    function addGlobal(scope, ref) {
        let root = window || global;
        if (!root) {
            return;
        }
        root = root.OpenTicket = root.OpenTicket || {};
        root[scope] = ref;
    }

    exports.ArrayPaginatable = ArrayPaginatable;
    exports.BaseError = BaseError;
    exports.ConsoleOutput = ConsoleOutput;
    exports.CrudFactory = CrudFactory;
    exports.CrudModel = CrudModel;
    exports.CrudModelProps = CrudModelProps;
    exports.CrudNode = CrudNode;
    exports.CrudRoot = CrudRoot;
    exports.CrudRoute = index;
    exports.CrudToMany = CrudToMany;
    exports.CrudToManyMixin = CrudToManyMixin;
    exports.CrudToOne = CrudToOne;
    exports.Form = Form;
    exports.FormValidationError = FormValidationError;
    exports.LazyList = LazyList;
    exports.Logger = Logger;
    exports.ModelForm = ModelForm;
    exports.NestedPicker = NestedPicker;
    exports.Pagination = Pagination;
    exports.Picker = Picker;
    exports.ServiceOutput = ServiceOutput;
    exports.Sorter = Sorter;
    exports.StringError = StringError;
    exports.UnexpectedError = UnexpectedError;
    exports.addGlobal = addGlobal;
    exports.levelNumberToLevel = levelNumberToLevel;
    exports.levelToLevelNumber = levelToLevelNumber;
    exports.toMany = toMany;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=helpers.js.map


/***/ }),

/***/ "b995":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("0ee7");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6d242aad", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "bc88":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PaginationControls_vue_vue_type_style_index_0_id_524a5bf8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0962");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PaginationControls_vue_vue_type_style_index_0_id_524a5bf8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PaginationControls_vue_vue_type_style_index_0_id_524a5bf8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bd1e":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("418f");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("b1587934", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "be1a":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-7bfcd087],.ot-vars[data-v-7bfcd087]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.avatar-icon[data-v-7bfcd087]{position:relative;overflow:hidden;border-radius:50%;background-color:var(--ot-color-core-accent-primary);background-repeat:no-repeat;background-size:cover;background-position:50%;display:flex;align-items:center;justify-content:center}.avatar-icon__initials[data-v-7bfcd087]{position:absolute;font-weight:600;text-transform:uppercase;color:#fff;text-align:center;line-height:1}.avatar-icon__image[data-v-7bfcd087]{position:absolute;top:0;right:0;bottom:0;left:0;background:transparent;background-size:cover;z-index:1}.avatar-icon__edit[data-v-7bfcd087]{cursor:pointer;position:absolute;width:100%;left:0;bottom:0;font-size:.9rem;font-weight:500;color:#fff;text-align:center;padding:.4rem 0 .5rem;background-color:var(--color-primary-light)}.avatar-icon--120[data-v-7bfcd087]{width:7.5rem;height:7.5rem}.avatar-icon--120 .avatar-icon__initials[data-v-7bfcd087]{font-size:3rem}.avatar-icon--64[data-v-7bfcd087]{width:4rem;height:4rem}.avatar-icon--64 .avatar-icon__initials[data-v-7bfcd087]{font-size:1.75rem}.avatar-icon--56[data-v-7bfcd087]{width:3.5rem;height:3.5rem}.avatar-icon--56 .avatar-icon__initials[data-v-7bfcd087]{font-size:1.45rem}.avatar-icon--40[data-v-7bfcd087]{width:2.5rem;height:2.5rem}.avatar-icon--40 .avatar-icon__initials[data-v-7bfcd087]{font-size:1.1rem}.avatar-icon--48[data-v-7bfcd087]{width:3rem;height:3rem}.avatar-icon--48 .avatar-icon__initials[data-v-7bfcd087]{font-size:1.25rem}.avatar-icon--24[data-v-7bfcd087]{width:1.8rem;height:1.8rem}.avatar-icon--24 .avatar-icon__initials[data-v-7bfcd087]{font-size:.9rem}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "c25d":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("5086");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("1f48aa72", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ccbe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableColumnSelection_vue_vue_type_style_index_0_id_6a3645b5_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("aeab");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableColumnSelection_vue_vue_type_style_index_0_id_6a3645b5_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TableColumnSelection_vue_vue_type_style_index_0_id_6a3645b5_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d22b":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("4235");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("42af460c", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "d395":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormError_vue_vue_type_style_index_0_id_668b06d4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c25d");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormError_vue_vue_type_style_index_0_id_668b06d4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormError_vue_vue_type_style_index_0_id_668b06d4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d4f8":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-1b6969fb],.ot-vars[data-v-1b6969fb]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.card-content[data-v-1b6969fb]{padding:0 var(--ot-spacing-4xl)}.card-content[data-v-1b6969fb]:last-child{padding-bottom:var(--ot-spacing-4xl)}.card-content[data-v-1b6969fb]:first-child{padding-top:var(--ot-spacing-4xl)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "d507":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RouterModal_vue_vue_type_style_index_0_id_5cf2c7e2_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d7b0");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RouterModal_vue_vue_type_style_index_0_id_5cf2c7e2_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_RouterModal_vue_vue_type_style_index_0_id_5cf2c7e2_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d50c":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-0a66a4ae],.ot-vars[data-v-0a66a4ae]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.inline-modal__backdrop[data-v-0a66a4ae]{z-index:100;position:fixed;top:0;left:0;width:100%;height:100%;background:#000;opacity:.3}.inline-modal__card[data-v-0a66a4ae]{z-index:101;position:fixed;top:50%;left:50%;width:100%;max-width:calc(var(--ot-layout-width, 80rem) - var(--ot-layout-sidebar-width, 16rem));max-height:calc(100vh - var(--ot-spacing-default)*2);transform:translate(-50%,-50%);padding:0}@media(max-width:60rem){.inline-modal__card[data-v-0a66a4ae]{max-width:calc(100% - var(--ot-spacing-default)*2);max-height:calc(100% - var(--ot-spacing-default)*2);display:flex}}@media(max-width:40rem){.inline-modal__card[data-v-0a66a4ae]{width:100%;height:100%;max-width:100%;max-height:100%}}.inline-modal__card.fit-width[data-v-0a66a4ae]{width:100%!important;max-width:calc(100% - var(--ot-spacing-unit))}.inline-modal__card.fit-height[data-v-0a66a4ae]{height:100%}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "d577":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-99c8670e],.ot-vars[data-v-99c8670e]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.form-row[data-v-99c8670e]{display:flex;margin:0 -.5rem;margin-bottom:var(--ot-spacing-unit);align-items:flex-end}.form-row>*[data-v-99c8670e]{flex:1;margin:0 .5rem}.form-row[data-v-99c8670e]:last-child{margin-bottom:0}@media(max-width:40rem){.form-row[data-v-99c8670e]{display:block;margin-bottom:0}.form-row>*[data-v-99c8670e]{margin-bottom:1rem}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "d7b0":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("2231");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("5f87741e", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "da84":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Splash_vue_vue_type_style_index_0_id_1401f924_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a072");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Splash_vue_vue_type_style_index_0_id_1401f924_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Splash_vue_vue_type_style_index_0_id_1401f924_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "db0e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormCollapse_vue_vue_type_style_index_0_id_0c9735e5_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("25b0");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormCollapse_vue_vue_type_style_index_0_id_0c9735e5_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormCollapse_vue_vue_type_style_index_0_id_0c9735e5_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e239":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudMultiSelect_vue_vue_type_style_index_0_id_61923796_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d22b");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudMultiSelect_vue_vue_type_style_index_0_id_61923796_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudMultiSelect_vue_vue_type_style_index_0_id_61923796_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "e3af":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-7b97aa9b],.ot-vars[data-v-7b97aa9b]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.dialog[data-v-7b97aa9b]{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);z-index:201;width:512px;padding:var(--ot-spacing-2xl) var(--ot-spacing-4xl);text-align:center}.dialog__backdrop[data-v-7b97aa9b]{position:fixed;top:0;left:0;width:100%;height:100%;background:#000;opacity:.3;z-index:200}.dialog__icon i[data-v-7b97aa9b]:before{font-size:2.5rem}.dialog__icon.is-info[data-v-7b97aa9b]{color:var(--ot-color-core-black)}.dialog__icon.is-danger[data-v-7b97aa9b]{color:var(--ot-color-accent-orange-light)}.dialog__title[data-v-7b97aa9b]{margin:var(--ot-spacing-unit) 0}.dialog__footer[data-v-7b97aa9b]{display:flex;margin-top:var(--ot-spacing-2xl)}.dialog__footer>*[data-v-7b97aa9b]{flex:1}.dialog__footer[data-v-7b97aa9b]>:first-child{margin-right:.5rem}.dialog__footer[data-v-7b97aa9b]>:last-child{margin-left:.5rem}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "e4b6":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("9b1f");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("6443557d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "e5c5":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-188cf208],.ot-vars[data-v-188cf208]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.form-picker__filters[data-v-188cf208]{display:flex;align-items:center;padding:var(--ot-spacing-unit)}.form-picker__filters>button[data-v-188cf208]{margin-left:.5rem}.form-picker__list[data-v-188cf208]{padding-bottom:var(--ot-spacing-unit)}.form-picker__list__item[data-v-188cf208]{padding:var(--ot-spacing-2xs) var(--ot-spacing-unit);display:flex;align-items:center}.form-picker__list__item__check[data-v-188cf208]{display:flex}.form-picker__list__item__check[data-v-188cf208] .ot-checkbox{height:1.25rem}.form-picker__list__item__content[data-v-188cf208]{flex:1;display:flex;align-items:center}.form-picker__list__item__action[data-v-188cf208]{padding:var(--ot-spacing-xs)}.form-picker__list__item__action[data-v-188cf208]:hover{background-color:var(--ot-color-core-brand);color:var(--ot-color-core-white)}.form-picker__list__item[data-v-188cf208]:hover{cursor:pointer;background:var(--ot-color-core-background-secondary)}.form-picker__list__item:hover .form-picker__list__item__content[data-v-188cf208]{color:var(--ot-color-core-brand)}.form-picker__actions[data-v-188cf208]{display:flex;justify-content:flex-end}.form-picker__error[data-v-188cf208]{flex:1;display:flex;align-items:center}.form-picker__error .oti[data-v-188cf208]{margin-right:.5rem}.form-picker__sort__trigger[data-v-188cf208]{margin-top:.5rem;text-align:right}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "e9e2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Dialog_vue_vue_type_style_index_0_id_7b97aa9b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8d9d");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Dialog_vue_vue_type_style_index_0_id_7b97aa9b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Dialog_vue_vue_type_style_index_0_id_7b97aa9b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ea3d":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("be1a");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("4eea3d4d", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "ebb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Spinner_vue_vue_type_style_index_0_id_5a765f9b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("e4b6");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Spinner_vue_vue_type_style_index_0_id_5a765f9b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_Spinner_vue_vue_type_style_index_0_id_5a765f9b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "ec4b":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-723d9fa0],.ot-vars[data-v-723d9fa0]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.pagination-table__controls[data-v-723d9fa0]{padding-top:var(--ot-spacing-3xl)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ed9e":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-026b715c],.ot-vars[data-v-026b715c]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.sidebar[data-v-026b715c]{position:-webkit-sticky;position:sticky;top:var(--ot-layout-header-height,4rem)}@media(max-width:60rem){.sidebar[data-v-026b715c]{top:0}}.sidebar a[data-v-026b715c]{text-decoration:none;color:inherit}.sidebar__logo[data-v-026b715c]{display:none;margin:var(--ot-spacing-default) 0}.sidebar__logo img[data-v-026b715c]{height:2rem}@media(max-width:60rem){.sidebar__logo[data-v-026b715c]{display:block}}.sidebar__back[data-v-026b715c]{display:flex;align-items:flex-end;padding-bottom:2rem;padding-top:1rem;cursor:pointer}.sidebar__back__icon[data-v-026b715c]{margin-right:1rem;color:var(--ot-color-core-brand);padding-bottom:2rem;border-bottom:2px solid var(--ot-color-core-accent-secondary)}.sidebar__back__info[data-v-026b715c]{padding-bottom:2.375rem}.sidebar__back__label[data-v-026b715c]{opacity:.5}.sidebar__back__title[data-v-026b715c]{color:var(--ot-color-core-brand);height:1.5rem}.sidebar__item[data-v-026b715c]{display:flex;align-items:center;color:var(--ot-color-core-foreground-secondary)}.sidebar__item__container[data-v-026b715c]{padding:1.5rem 0}.sidebar__item__label[data-v-026b715c]{text-align:left;padding-left:1rem;display:flex;align-items:center}.sidebar__item--nested[data-v-026b715c]{display:flex;align-items:center;padding-top:1rem;color:var(--ot-color-core-foreground-secondary)}.sidebar__item--nested.selected[data-v-026b715c],.sidebar__item.selected[data-v-026b715c]{color:var(--ot-color-core-brand)}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "ee42":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-0710eee7],.ot-vars[data-v-0710eee7]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.card[data-v-0710eee7]{padding:0}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f09b":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-dd9fd2a0],.ot-vars[data-v-dd9fd2a0]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.card-footer[data-v-dd9fd2a0]{background:var(--ot-color-core-accent-tertiary);padding:var(--ot-spacing-2xl) var(--ot-spacing-4xl);display:flex}.card-footer.sticky[data-v-dd9fd2a0]{position:-webkit-sticky;position:sticky}.card-footer__spacer[data-v-dd9fd2a0]{flex:1}.card-footer__left[data-v-dd9fd2a0]{display:inline-flex}.card-footer__left>*[data-v-dd9fd2a0]{margin-right:1rem}.card-footer__right[data-v-dd9fd2a0]{display:inline-flex}.card-footer__right>*[data-v-dd9fd2a0]{margin-left:1rem}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f0ad":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-6a3645b5],.ot-vars[data-v-6a3645b5]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.column-selection__dropdown[data-v-6a3645b5] .column-selection__dropdown-content{padding:var(--ot-spacing-unit)}.column-selection__dropdown[data-v-6a3645b5] .column-selection__dropdown-content .ot-checkbox:not(:last-of-type){margin-bottom:var(--ot-spacing-unit)}.column-selection__dropdown[data-v-6a3645b5] .column-selection__dropdown-footer{padding:var(--ot-spacing-unit);background-color:var(--ot-color-core-background-secondary);display:flex;justify-content:space-between}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f2a9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormField_vue_vue_type_style_index_0_id_18c55068_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("23f5");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormField_vue_vue_type_style_index_0_id_18c55068_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FormField_vue_vue_type_style_index_0_id_18c55068_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f634":
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("4bad");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ot-document[data-v-1cd98873],.ot-vars[data-v-1cd98873]{--ot-layout-width:$layout-width;--ot-layout-sidebar-width:$layout-sidebar-width;--ot-layout-header-height:$layout-header-height;--ot-heading-font-weight:500}.dropdown[data-v-1cd98873]{display:inline-block;width:100%}.dropdown__placeholder[data-v-1cd98873]{position:relative}.dropdown__backdrop[data-v-1cd98873]{position:fixed;top:0;left:0;width:100%;height:100%;background:#000;opacity:0;transition:opacity var(--ot-transition-default-timing-function) var(--ot-transition-default-duration);pointer-events:none;z-index:10}.dropdown__backdrop.opened[data-v-1cd98873]{pointer-events:auto}@media(max-width:40rem){.dropdown__backdrop.opened[data-v-1cd98873]{opacity:.3}}.dropdown__dialog[data-v-1cd98873]{position:absolute;top:0;right:0;width:24rem;-webkit-animation-name:fade-in-data-v-1cd98873;animation-name:fade-in-data-v-1cd98873;-webkit-animation-duration:var(--ot-transition-default-duration);animation-duration:var(--ot-transition-default-duration);padding:0;z-index:11}@media(max-width:40rem){.dropdown__dialog[data-v-1cd98873]{position:fixed;top:50%;width:calc(100% - var(--ot-spacing-default)*2);max-width:24rem;right:50%;transform:translate(50%,-50%)}}.dropdown__dialog.fill[data-v-1cd98873]{width:100%}@-webkit-keyframes fade-in-data-v-1cd98873{0%{opacity:0}to{opacity:1}}@keyframes fade-in-data-v-1cd98873{0%{opacity:0}to{opacity:1}}", ""]);
// Exports
module.exports = exports;


/***/ }),

/***/ "f9c1":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("a773");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__("499e").default
var update = add("35508257", content, true, {"sourceMap":false,"shadowMode":false});

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "RouterModalWidth", function() { return /* reexport */ RouterModalWidth; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/layout/DashboardLayout/DashboardLayout.vue?vue&type=template&id=3c31179d&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout",class:{ 'is-scrolled': _vm.isScrolled }},[_c('div',{staticClass:"layout__header"},[_c('div',{staticClass:"layout__header__slot"},[_vm._t("header")],2)]),_c('div',{staticClass:"layout__content"},[_c('div',{staticClass:"layout__sidebar__backdrop",class:{ visible: _vm.sidebarOpened },on:{"click":function($event){_vm.sidebarOpened = false}}}),_c('div',{staticClass:"layout__sidebar",class:{ opened: _vm.sidebarOpened }},[_vm._t("sidebar")],2),_c('div',{staticClass:"layout__page"},[_c('div',{staticClass:"layout__card"},[_vm._t("content",function(){return [_c('router-view')]})],2),_vm._t("footer",function(){return [_c('OtFooter')]})],2)])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/DashboardLayout/DashboardLayout.vue?vue&type=template&id=3c31179d&scoped=true&

// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__("8bbf");
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_vue_default.a.extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) {}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof external_vue_default.a ? superProto.constructor : external_vue_default.a;
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = [// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter'];
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) {}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function vue_class_component_esm_Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

vue_class_component_esm_Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (vue_class_component_esm_Component);


// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/layout/DashboardLayout/DashboardLayout.vue?vue&type=script&lang=ts&



const SCROLL_THRESHOLD = 5;
let DashboardLayoutvue_type_script_lang_ts_OtDashboardLayout = class OtDashboardLayout extends external_vue_default.a {
    constructor() {
        super(...arguments);
        this.sidebarOpened = false;
        this.isScrolled = false;
        this.onScrollRef = null;
        this.initialized = false;
    }
    showSidebar() {
        this.sidebarOpened = true;
    }
    mounted() {
        this.onScrollRef = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollRef);
        this.initialized = true;
    }
    onScroll() {
        const offset = window.scrollY;
        if (offset > SCROLL_THRESHOLD && !this.isScrolled) {
            this.isScrolled = true;
        }
        else if (offset <= SCROLL_THRESHOLD && this.isScrolled) {
            this.isScrolled = false;
        }
    }
    onDestroy() {
        if (!this.onScrollRef) {
            return;
        }
        window.removeEventListener('scroll', this.onScrollRef);
    }
};
DashboardLayoutvue_type_script_lang_ts_OtDashboardLayout = __decorate([
    vue_class_component_esm
], DashboardLayoutvue_type_script_lang_ts_OtDashboardLayout);
/* harmony default export */ var DashboardLayoutvue_type_script_lang_ts_ = (DashboardLayoutvue_type_script_lang_ts_OtDashboardLayout);

// CONCATENATED MODULE: ./src/layout/DashboardLayout/DashboardLayout.vue?vue&type=script&lang=ts&
 /* harmony default export */ var DashboardLayout_DashboardLayoutvue_type_script_lang_ts_ = (DashboardLayoutvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/layout/DashboardLayout/DashboardLayout.vue?vue&type=style&index=0&id=3c31179d&lang=scss&scoped=true&
var DashboardLayoutvue_type_style_index_0_id_3c31179d_lang_scss_scoped_true_ = __webpack_require__("6dcf");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/layout/DashboardLayout/DashboardLayout.vue






/* normalize component */

var component = normalizeComponent(
  DashboardLayout_DashboardLayoutvue_type_script_lang_ts_,
  render,
  staticRenderFns,
  false,
  null,
  "3c31179d",
  null
  
)

/* harmony default export */ var DashboardLayout = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/layout/Header/Header.vue?vue&type=template&id=452944a8&scoped=true&
var Headervue_type_template_id_452944a8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"header__logo"},[_c('img',{attrs:{"src":_vm.logo}})]),_c('div',{staticClass:"header__menu-btn",on:{"click":function($event){return _vm.$emit('show-menu')}}},[_c('i',{staticClass:"oti oti-menu"})]),_c('div',{staticClass:"header__spacer"}),_c('div',{staticClass:"header__actions"},[_vm._t("right")],2)])])}
var Headervue_type_template_id_452944a8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/Header/Header.vue?vue&type=template&id=452944a8&scoped=true&

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Emit.js
var Emit_spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, Emit_spreadArrays([emitName], args));
                    }
                }
                else {
                    args.unshift(returnValue);
                    _this.$emit.apply(_this, Emit_spreadArrays([emitName], args));
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Inject.js

/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/helpers/provideInject.js
function needToProduceProvide(original) {
    return (typeof original !== 'function' ||
        (!original.managed && !original.managedReactive));
}
function produceProvide(original) {
    var provide = function () {
        var _this = this;
        var rv = typeof original === 'function' ? original.call(this) : original;
        rv = Object.create(rv || null);
        // set reactive services (propagates previous services if necessary)
        rv[reactiveInjectKey] = Object.create(this[reactiveInjectKey] || {});
        for (var i in provide.managed) {
            rv[provide.managed[i]] = this[i];
        }
        var _loop_1 = function (i) {
            rv[provide.managedReactive[i]] = this_1[i]; // Duplicates the behavior of `@Provide`
            Object.defineProperty(rv[reactiveInjectKey], provide.managedReactive[i], {
                enumerable: true,
                configurable: true,
                get: function () { return _this[i]; },
            });
        };
        var this_1 = this;
        for (var i in provide.managedReactive) {
            _loop_1(i);
        }
        return rv;
    };
    provide.managed = {};
    provide.managedReactive = {};
    return provide;
}
/** Used for keying reactive provide/inject properties */
var reactiveInjectKey = '__reactiveInject__';
function inheritInjected(componentOptions) {
    // inject parent reactive services (if any)
    if (!Array.isArray(componentOptions.inject)) {
        componentOptions.inject = componentOptions.inject || {};
        componentOptions.inject[reactiveInjectKey] = {
            from: reactiveInjectKey,
            default: {},
        };
    }
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/InjectReactive.js


/**
 * decorator of a reactive inject
 * @param from key
 * @return PropertyDecorator
 */
function InjectReactive(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            var fromKey_1 = !!options ? options.from || options : key;
            var defaultVal_1 = (!!options && options.default) || undefined;
            if (!componentOptions.computed)
                componentOptions.computed = {};
            componentOptions.computed[key] = function () {
                var obj = this[reactiveInjectKey];
                return obj ? obj[fromKey_1] : defaultVal_1;
            };
            componentOptions.inject[reactiveInjectKey] = reactiveInjectKey;
        }
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/helpers/metadata.js
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            !options.hasOwnProperty('type') &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Model.js


/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


/**
 * decorator of synced model and prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function ModelSync(propName, event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            componentOptions.model = { prop: propName, event: event || k };
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit(event, value);
                },
            };
        })(target, key);
    };
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Prop.js


/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Provide.js


/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        inheritInjected(componentOptions);
        if (needToProduceProvide(provide)) {
            provide = componentOptions.provide = produceProvide(provide);
        }
        provide.managed[k] = key || k;
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/ProvideReactive.js


/**
 * decorator of a reactive provide
 * @param key key
 * @return PropertyDecorator | void
 */
function ProvideReactive(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        inheritInjected(componentOptions);
        if (needToProduceProvide(provide)) {
            provide = componentOptions.provide = produceProvide(provide);
        }
        provide.managedReactive[k] = key || k;
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Ref.js

/**
 * decorator of a ref prop
 * @param refKey the ref key defined in template
 */
function Ref(refKey) {
    return createDecorator(function (options, key) {
        options.computed = options.computed || {};
        options.computed[key] = {
            cache: false,
            get: function () {
                return this.$refs[refKey || key];
            },
        };
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/VModel.js

/**
 * decorator for capturings v-model binding to component
 * @param options the options for the prop
 */
function VModel(options) {
    if (options === void 0) { options = {}; }
    var valueKey = 'value';
    return createDecorator(function (componentOptions, key) {
        ;
        (componentOptions.props || (componentOptions.props = {}))[valueKey] = options;
        (componentOptions.computed || (componentOptions.computed = {}))[key] = {
            get: function () {
                return this[valueKey];
            },
            set: function (value) {
                this.$emit('input', value);
            },
        };
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/decorators/Watch.js

/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/index.js
/** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>
















// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/layout/Header/Header.vue?vue&type=script&lang=ts&




let Headervue_type_script_lang_ts_OtHeader = class OtHeader extends external_vue_default.a {
};
__decorate([
    Prop()
], Headervue_type_script_lang_ts_OtHeader.prototype, "logo", void 0);
Headervue_type_script_lang_ts_OtHeader = __decorate([
    vue_class_component_esm
], Headervue_type_script_lang_ts_OtHeader);
/* harmony default export */ var Headervue_type_script_lang_ts_ = (Headervue_type_script_lang_ts_OtHeader);

// CONCATENATED MODULE: ./src/layout/Header/Header.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Header_Headervue_type_script_lang_ts_ = (Headervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/layout/Header/Header.vue?vue&type=style&index=0&id=452944a8&lang=scss&scoped=true&
var Headervue_type_style_index_0_id_452944a8_lang_scss_scoped_true_ = __webpack_require__("b6ef");

// CONCATENATED MODULE: ./src/layout/Header/Header.vue






/* normalize component */

var Header_component = normalizeComponent(
  Header_Headervue_type_script_lang_ts_,
  Headervue_type_template_id_452944a8_scoped_true_render,
  Headervue_type_template_id_452944a8_scoped_true_staticRenderFns,
  false,
  null,
  "452944a8",
  null
  
)

/* harmony default export */ var Header = (Header_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/layout/Header/HeaderAction.vue?vue&type=template&id=4a1bdd02&
var HeaderActionvue_type_template_id_4a1bdd02_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__action",class:{ opened: _vm.opened }},[_vm._t("default")],2)}
var HeaderActionvue_type_template_id_4a1bdd02_staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/Header/HeaderAction.vue?vue&type=template&id=4a1bdd02&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/layout/Header/HeaderAction.vue?vue&type=script&lang=ts&



let HeaderActionvue_type_script_lang_ts_HeaderAction = class HeaderAction extends external_vue_default.a {
};
__decorate([
    Prop()
], HeaderActionvue_type_script_lang_ts_HeaderAction.prototype, "opened", void 0);
HeaderActionvue_type_script_lang_ts_HeaderAction = __decorate([
    vue_class_component_esm
], HeaderActionvue_type_script_lang_ts_HeaderAction);
/* harmony default export */ var HeaderActionvue_type_script_lang_ts_ = (HeaderActionvue_type_script_lang_ts_HeaderAction);

// CONCATENATED MODULE: ./src/layout/Header/HeaderAction.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Header_HeaderActionvue_type_script_lang_ts_ = (HeaderActionvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/layout/Header/HeaderAction.vue





/* normalize component */

var HeaderAction_component = normalizeComponent(
  Header_HeaderActionvue_type_script_lang_ts_,
  HeaderActionvue_type_template_id_4a1bdd02_render,
  HeaderActionvue_type_template_id_4a1bdd02_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Header_HeaderAction = (HeaderAction_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/layout/Footer/Footer.vue?vue&type=template&id=6d6241a5&scoped=true&
var Footervue_type_template_id_6d6241a5_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v("© "+_vm._s(_vm.year)+" All Rights Reserved")])}
var Footervue_type_template_id_6d6241a5_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/Footer/Footer.vue?vue&type=template&id=6d6241a5&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/layout/Footer/Footer.vue?vue&type=script&lang=ts&



let Footervue_type_script_lang_ts_OtFooter = class OtFooter extends external_vue_default.a {
    get year() {
        return new Date().getFullYear();
    }
};
Footervue_type_script_lang_ts_OtFooter = __decorate([
    vue_class_component_esm
], Footervue_type_script_lang_ts_OtFooter);
/* harmony default export */ var Footervue_type_script_lang_ts_ = (Footervue_type_script_lang_ts_OtFooter);

// CONCATENATED MODULE: ./src/layout/Footer/Footer.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Footer_Footervue_type_script_lang_ts_ = (Footervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/layout/Footer/Footer.vue?vue&type=style&index=0&id=6d6241a5&lang=scss&scoped=true&
var Footervue_type_style_index_0_id_6d6241a5_lang_scss_scoped_true_ = __webpack_require__("4835");

// CONCATENATED MODULE: ./src/layout/Footer/Footer.vue






/* normalize component */

var Footer_component = normalizeComponent(
  Footer_Footervue_type_script_lang_ts_,
  Footervue_type_template_id_6d6241a5_scoped_true_render,
  Footervue_type_template_id_6d6241a5_scoped_true_staticRenderFns,
  false,
  null,
  "6d6241a5",
  null
  
)

/* harmony default export */ var Footer = (Footer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/layout/Sidebar/Sidebar.vue?vue&type=template&id=026b715c&scoped=true&
var Sidebarvue_type_template_id_026b715c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('div',{staticClass:"sidebar__logo"},[_c('img',{attrs:{"src":_vm.logo}})]),(_vm.parentRoute)?_c('div',{staticClass:"sidebar__back",on:{"click":function($event){return _vm.$emit('back')}}},[_vm._m(0),_c('div',{staticClass:"sidebar__back__info"},[_c('div',{staticClass:"sidebar__back__label ot-text-small"},[_vm._v("Back to")]),_c('div',{staticClass:"sidebar__back__title ot-text-body-strong"},[_vm._v(" "+_vm._s(_vm.parentRoute.title)+" ")])])]):_vm._e(),_vm._l((_vm.items),function(item,i){return _c('div',{key:i,staticClass:"sidebar__item__container"},[_c('router-link',{attrs:{"to":item.route}},[_c('div',{staticClass:"ot-text-body-strong sidebar__item",class:{ selected: _vm.isSelected(item) }},[_c('i',{staticClass:"oti",class:[item.icon]}),_c('div',{staticClass:"sidebar__item__label"},[_vm._v(" "+_vm._s(item.label)+" ")])]),(
                    item.children &&
                    item.children.length &&
                    _vm.isSelected(item)
                )?_c('div',{staticClass:"sidebate__item__children"},_vm._l((item.children),function(item,i){return _c('router-link',{key:i,attrs:{"to":item.route}},[_c('div',{staticClass:"ot-text-body-strong sidebar__item--nested",class:{ selected: _vm.isSelected(item) }},[_c('i',{staticClass:"oti",class:[item.icon]}),_c('div',{staticClass:"sidebar__item__label"},[_vm._v(" "+_vm._s(item.label)+" ")])])])}),1):_vm._e()])],1)})],2)}
var Sidebarvue_type_template_id_026b715c_scoped_true_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar__back__icon"},[_c('i',{staticClass:"oti oti-arrow-left"})])}]


// CONCATENATED MODULE: ./src/layout/Sidebar/Sidebar.vue?vue&type=template&id=026b715c&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/layout/Sidebar/Sidebar.vue?vue&type=script&lang=ts&


let Sidebarvue_type_script_lang_ts_OtSidebar = class OtSidebar extends external_vue_default.a {
};
__decorate([
    Prop()
], Sidebarvue_type_script_lang_ts_OtSidebar.prototype, "logo", void 0);
__decorate([
    Prop()
], Sidebarvue_type_script_lang_ts_OtSidebar.prototype, "parentRoute", void 0);
__decorate([
    Prop()
], Sidebarvue_type_script_lang_ts_OtSidebar.prototype, "items", void 0);
__decorate([
    Prop({
        default: () => () => false,
    })
], Sidebarvue_type_script_lang_ts_OtSidebar.prototype, "isSelected", void 0);
Sidebarvue_type_script_lang_ts_OtSidebar = __decorate([
    vue_class_component_esm
], Sidebarvue_type_script_lang_ts_OtSidebar);
/* harmony default export */ var Sidebarvue_type_script_lang_ts_ = (Sidebarvue_type_script_lang_ts_OtSidebar);

// CONCATENATED MODULE: ./src/layout/Sidebar/Sidebar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Sidebar_Sidebarvue_type_script_lang_ts_ = (Sidebarvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/layout/Sidebar/Sidebar.vue?vue&type=style&index=0&id=026b715c&lang=scss&scoped=true&
var Sidebarvue_type_style_index_0_id_026b715c_lang_scss_scoped_true_ = __webpack_require__("07db");

// CONCATENATED MODULE: ./src/layout/Sidebar/Sidebar.vue






/* normalize component */

var Sidebar_component = normalizeComponent(
  Sidebar_Sidebarvue_type_script_lang_ts_,
  Sidebarvue_type_template_id_026b715c_scoped_true_render,
  Sidebarvue_type_template_id_026b715c_scoped_true_staticRenderFns,
  false,
  null,
  "026b715c",
  null
  
)

/* harmony default export */ var Sidebar = (Sidebar_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/layout/Splash.vue?vue&type=template&id=1401f924&scoped=true&
var Splashvue_type_template_id_1401f924_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash-screen"},[_c('img',{staticClass:"splash-screen__spinner",attrs:{"src":_vm.spinner}}),(_vm.label)?_c('h5',[_vm._v(_vm._s(_vm.$t(_vm.label)))]):_vm._e()])}
var Splashvue_type_template_id_1401f924_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/layout/Splash.vue?vue&type=template&id=1401f924&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/layout/Splash.vue?vue&type=script&lang=ts&




let Splashvue_type_script_lang_ts_OtSplash = class OtSplash extends external_vue_default.a {
};
__decorate([
    Prop()
], Splashvue_type_script_lang_ts_OtSplash.prototype, "spinner", void 0);
__decorate([
    Prop()
], Splashvue_type_script_lang_ts_OtSplash.prototype, "label", void 0);
Splashvue_type_script_lang_ts_OtSplash = __decorate([
    vue_class_component_esm
], Splashvue_type_script_lang_ts_OtSplash);
/* harmony default export */ var Splashvue_type_script_lang_ts_ = (Splashvue_type_script_lang_ts_OtSplash);

// CONCATENATED MODULE: ./src/layout/Splash.vue?vue&type=script&lang=ts&
 /* harmony default export */ var layout_Splashvue_type_script_lang_ts_ = (Splashvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/layout/Splash.vue?vue&type=style&index=0&id=1401f924&lang=scss&scoped=true&
var Splashvue_type_style_index_0_id_1401f924_lang_scss_scoped_true_ = __webpack_require__("da84");

// CONCATENATED MODULE: ./src/layout/Splash.vue






/* normalize component */

var Splash_component = normalizeComponent(
  layout_Splashvue_type_script_lang_ts_,
  Splashvue_type_template_id_1401f924_scoped_true_render,
  Splashvue_type_template_id_1401f924_scoped_true_staticRenderFns,
  false,
  null,
  "1401f924",
  null
  
)

/* harmony default export */ var Splash = (Splash_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/card/Card.vue?vue&type=template&id=0710eee7&scoped=true&
var Cardvue_type_template_id_0710eee7_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ot-card card"},[_vm._t("default")],2)}
var Cardvue_type_template_id_0710eee7_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/card/Card.vue?vue&type=template&id=0710eee7&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/card/Card.vue?vue&type=script&lang=ts&




let Cardvue_type_script_lang_ts_Card = class Card extends external_vue_default.a {
};
__decorate([
    Prop()
], Cardvue_type_script_lang_ts_Card.prototype, "noPadding", void 0);
Cardvue_type_script_lang_ts_Card = __decorate([
    vue_class_component_esm
], Cardvue_type_script_lang_ts_Card);
/* harmony default export */ var Cardvue_type_script_lang_ts_ = (Cardvue_type_script_lang_ts_Card);

// CONCATENATED MODULE: ./src/card/Card.vue?vue&type=script&lang=ts&
 /* harmony default export */ var card_Cardvue_type_script_lang_ts_ = (Cardvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/card/Card.vue?vue&type=style&index=0&id=0710eee7&lang=scss&scoped=true&
var Cardvue_type_style_index_0_id_0710eee7_lang_scss_scoped_true_ = __webpack_require__("2cf2");

// CONCATENATED MODULE: ./src/card/Card.vue






/* normalize component */

var Card_component = normalizeComponent(
  card_Cardvue_type_script_lang_ts_,
  Cardvue_type_template_id_0710eee7_scoped_true_render,
  Cardvue_type_template_id_0710eee7_scoped_true_staticRenderFns,
  false,
  null,
  "0710eee7",
  null
  
)

/* harmony default export */ var card_Card = (Card_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/card/CardHeader.vue?vue&type=template&id=312c9aec&scoped=true&
var CardHeadervue_type_template_id_312c9aec_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header__content"},[_c('h1',{staticClass:"ot-heading-h1"},[_vm._v(_vm._s(_vm.title))]),_c('label',{staticClass:"ot-label"},[_vm._v(" "+_vm._s(_vm.subtitle))]),(_vm.$slots.action)?_c('div',{staticClass:"header__action"},[_vm._t("action")],2):_vm._e()]),(_vm.image)?_c('div',{staticClass:"header__image",style:({ backgroundImage: ("url(" + _vm.image + ")") })}):_vm._e()])}
var CardHeadervue_type_template_id_312c9aec_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/card/CardHeader.vue?vue&type=template&id=312c9aec&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/card/CardHeader.vue?vue&type=script&lang=ts&




let CardHeadervue_type_script_lang_ts_CardHeader = class CardHeader extends external_vue_default.a {
};
__decorate([
    Prop()
], CardHeadervue_type_script_lang_ts_CardHeader.prototype, "title", void 0);
__decorate([
    Prop()
], CardHeadervue_type_script_lang_ts_CardHeader.prototype, "subtitle", void 0);
__decorate([
    Prop()
], CardHeadervue_type_script_lang_ts_CardHeader.prototype, "image", void 0);
CardHeadervue_type_script_lang_ts_CardHeader = __decorate([
    vue_class_component_esm
], CardHeadervue_type_script_lang_ts_CardHeader);
/* harmony default export */ var CardHeadervue_type_script_lang_ts_ = (CardHeadervue_type_script_lang_ts_CardHeader);

// CONCATENATED MODULE: ./src/card/CardHeader.vue?vue&type=script&lang=ts&
 /* harmony default export */ var card_CardHeadervue_type_script_lang_ts_ = (CardHeadervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/card/CardHeader.vue?vue&type=style&index=0&id=312c9aec&lang=scss&scoped=true&
var CardHeadervue_type_style_index_0_id_312c9aec_lang_scss_scoped_true_ = __webpack_require__("164e");

// CONCATENATED MODULE: ./src/card/CardHeader.vue






/* normalize component */

var CardHeader_component = normalizeComponent(
  card_CardHeadervue_type_script_lang_ts_,
  CardHeadervue_type_template_id_312c9aec_scoped_true_render,
  CardHeadervue_type_template_id_312c9aec_scoped_true_staticRenderFns,
  false,
  null,
  "312c9aec",
  null
  
)

/* harmony default export */ var card_CardHeader = (CardHeader_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/card/CardContent.vue?vue&type=template&id=1b6969fb&scoped=true&
var CardContentvue_type_template_id_1b6969fb_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_vm._t("default")],2)}
var CardContentvue_type_template_id_1b6969fb_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/card/CardContent.vue?vue&type=template&id=1b6969fb&scoped=true&

// EXTERNAL MODULE: ./src/card/CardContent.vue?vue&type=style&index=0&id=1b6969fb&lang=scss&scoped=true&
var CardContentvue_type_style_index_0_id_1b6969fb_lang_scss_scoped_true_ = __webpack_require__("05cf");

// CONCATENATED MODULE: ./src/card/CardContent.vue

var script = {}



/* normalize component */

var CardContent_component = normalizeComponent(
  script,
  CardContentvue_type_template_id_1b6969fb_scoped_true_render,
  CardContentvue_type_template_id_1b6969fb_scoped_true_staticRenderFns,
  false,
  null,
  "1b6969fb",
  null
  
)

/* harmony default export */ var CardContent = (CardContent_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/card/CardFooter.vue?vue&type=template&id=dd9fd2a0&scoped=true&
var CardFootervue_type_template_id_dd9fd2a0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer",class:{ sticky: _vm.sticky }},[_c('div',{staticClass:"card-footer__left"},[_vm._t("left")],2),_c('div',{staticClass:"card-footer__spacer"}),_c('div',{staticClass:"card-footer__right"},[_vm._t("right")],2)])}
var CardFootervue_type_template_id_dd9fd2a0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/card/CardFooter.vue?vue&type=template&id=dd9fd2a0&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/card/CardFooter.vue?vue&type=script&lang=ts&




let CardFootervue_type_script_lang_ts_CardFooter = class CardFooter extends external_vue_default.a {
};
__decorate([
    Prop()
], CardFootervue_type_script_lang_ts_CardFooter.prototype, "sticky", void 0);
CardFootervue_type_script_lang_ts_CardFooter = __decorate([
    vue_class_component_esm
], CardFootervue_type_script_lang_ts_CardFooter);
/* harmony default export */ var CardFootervue_type_script_lang_ts_ = (CardFootervue_type_script_lang_ts_CardFooter);

// CONCATENATED MODULE: ./src/card/CardFooter.vue?vue&type=script&lang=ts&
 /* harmony default export */ var card_CardFootervue_type_script_lang_ts_ = (CardFootervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/card/CardFooter.vue?vue&type=style&index=0&id=dd9fd2a0&lang=scss&scoped=true&
var CardFootervue_type_style_index_0_id_dd9fd2a0_lang_scss_scoped_true_ = __webpack_require__("af26");

// CONCATENATED MODULE: ./src/card/CardFooter.vue






/* normalize component */

var CardFooter_component = normalizeComponent(
  card_CardFootervue_type_script_lang_ts_,
  CardFootervue_type_template_id_dd9fd2a0_scoped_true_render,
  CardFootervue_type_template_id_dd9fd2a0_scoped_true_staticRenderFns,
  false,
  null,
  "dd9fd2a0",
  null
  
)

/* harmony default export */ var card_CardFooter = (CardFooter_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/modal/RouterModal.vue?vue&type=template&id=5cf2c7e2&scoped=true&
var RouterModalvue_type_template_id_5cf2c7e2_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasModal)?_c('div',{staticClass:"router-modal"},[_c('div',{staticClass:"router-modal__backdrop",on:{"click":_vm.close}}),_c('div',{class:[
            'ot-card router-modal__card',
            { 'fit-width': _vm.fitWidth, 'fit-height': _vm.fitHeight } ],style:({ width: _vm.width })},[_c('router-view')],1)]):_vm._e()}
var RouterModalvue_type_template_id_5cf2c7e2_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/modal/RouterModal.vue?vue&type=template&id=5cf2c7e2&scoped=true&

// CONCATENATED MODULE: ./src/modal/types.ts
/**
 *
 *  Default widths for the router modal. Forward one of
 *  the values to a route's meta 'modalWidth' prop to
 *  let it use/apply that width.
 *
 *  Example:
 *
 *  {
 *      path: 'some/route',
 *      name: 'some.name',
 *      component: SomeComponent,
 *      meta: {
 *          modal: true,
 *          modalWidth: RouterModalWidth.Small,
 *      },
 *  }
 *
 */
var RouterModalWidth;
(function (RouterModalWidth) {
    RouterModalWidth["Small"] = "560px";
    RouterModalWidth["Large"] = "960px";
})(RouterModalWidth || (RouterModalWidth = {}));

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/modal/RouterModal.vue?vue&type=script&lang=ts&





let RouterModalvue_type_script_lang_ts_OtRouterModal = class OtRouterModal extends external_vue_default.a {
    constructor() {
        super(...arguments);
        // If the currently loaded route has a (router) modal
        this.hasModal = false;
        // Default to the large width
        this.width = RouterModalWidth.Large;
        this.fitWidth = false;
        this.fitHeight = false;
        this.modalController = {
            close: () => this.close(),
            registerBeforeClose: (cb) => this.registerBeforeClose(cb),
        };
    }
    registerBeforeClose(cb) {
        this.beforeCloseCallback = cb;
    }
    /**
     *
     *  Watch and update the props accordingly, because the
     *  router modal is already mounted before being used.
     *
     *  (i) Otherwise the width won't work properly
     *
     */
    check(meta) {
        this.hasModal = meta.modal === true;
        this.width = meta.modalWidth || this.width;
        this.fitWidth = !!meta.fitWidth;
        this.fitHeight = !!meta.fitHeight;
    }
    /**
     *  Make sure to let it close on escape when
     *  the modal is used (the route has a modal).
     */
    toggleEscape(hasModal) {
        if (hasModal) {
            window.addEventListener('keydown', this.escListener);
        }
        else {
            window.removeEventListener('keydown', this.escListener);
        }
    }
    escListener(event) {
        if (event.key === "Escape") {
            void this.modalController.close();
        }
    }
    async close() {
        if (this.beforeCloseCallback && !(await this.beforeCloseCallback())) {
            return;
        }
        this.beforeCloseCallback = undefined;
        for (let i = this.$router.currentRoute.matched.length - 1; i >= 0; i--) {
            const route = this.$router.currentRoute.matched[i];
            if (!route.meta || !route.meta.modal) {
                void this.$router.push(route);
                this.$emit("close");
                return;
            }
        }
    }
};
__decorate([
    Provide("modal")
], RouterModalvue_type_script_lang_ts_OtRouterModal.prototype, "modalController", void 0);
__decorate([
    Watch("$route.meta", { immediate: true, deep: true })
], RouterModalvue_type_script_lang_ts_OtRouterModal.prototype, "check", null);
__decorate([
    Watch("hasModal")
], RouterModalvue_type_script_lang_ts_OtRouterModal.prototype, "toggleEscape", null);
RouterModalvue_type_script_lang_ts_OtRouterModal = __decorate([
    vue_class_component_esm
], RouterModalvue_type_script_lang_ts_OtRouterModal);
/* harmony default export */ var RouterModalvue_type_script_lang_ts_ = (RouterModalvue_type_script_lang_ts_OtRouterModal);

// CONCATENATED MODULE: ./src/modal/RouterModal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modal_RouterModalvue_type_script_lang_ts_ = (RouterModalvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/modal/RouterModal.vue?vue&type=style&index=0&id=5cf2c7e2&lang=scss&scoped=true&
var RouterModalvue_type_style_index_0_id_5cf2c7e2_lang_scss_scoped_true_ = __webpack_require__("d507");

// CONCATENATED MODULE: ./src/modal/RouterModal.vue






/* normalize component */

var RouterModal_component = normalizeComponent(
  modal_RouterModalvue_type_script_lang_ts_,
  RouterModalvue_type_template_id_5cf2c7e2_scoped_true_render,
  RouterModalvue_type_template_id_5cf2c7e2_scoped_true_staticRenderFns,
  false,
  null,
  "5cf2c7e2",
  null
  
)

/* harmony default export */ var RouterModal = (RouterModal_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/modal/InlineModal.vue?vue&type=template&id=0a66a4ae&scoped=true&
var InlineModalvue_type_template_id_0a66a4ae_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.opened)?_c('div',{staticClass:"inline-modal"},[_c('div',{staticClass:"inline-modal__backdrop",on:{"click":_vm.close}}),_c('div',{class:[
            'inline-modal__card',
            { 'fit-width': _vm.fitWidth, 'fit-height': _vm.fitHeight } ],style:({ width: _vm.width ? _vm.width + 'px' : undefined })},[_vm._t("default")],2)]):_vm._e()}
var InlineModalvue_type_template_id_0a66a4ae_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/modal/InlineModal.vue?vue&type=template&id=0a66a4ae&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/modal/InlineModal.vue?vue&type=script&lang=ts&



let InlineModalvue_type_script_lang_ts_OtInlineModal = class OtInlineModal extends external_vue_default.a {
    constructor() {
        super(...arguments);
        this.opened = false;
        this.modalController = {
            close: () => this.close(),
            registerBeforeClose: (cb) => this.registerBeforeClose(cb),
        };
    }
    open() {
        this.opened = true;
    }
    created() {
        window.addEventListener('keydown', this.escListener);
    }
    destroyed() {
        window.removeEventListener('keydown', this.escListener);
    }
    registerBeforeClose(cb) {
        this.beforeCloseCallback = cb;
    }
    async close() {
        if (this.beforeCloseCallback && !(await this.beforeCloseCallback())) {
            return;
        }
        this.beforeCloseCallback = undefined;
        this.opened = false;
        this.$emit("close");
    }
    escListener(event) {
        if (event.key === "Escape") {
            void this.modalController.close();
        }
    }
};
__decorate([
    Prop()
], InlineModalvue_type_script_lang_ts_OtInlineModal.prototype, "width", void 0);
__decorate([
    Prop()
], InlineModalvue_type_script_lang_ts_OtInlineModal.prototype, "fitHeight", void 0);
__decorate([
    Prop()
], InlineModalvue_type_script_lang_ts_OtInlineModal.prototype, "fitWidth", void 0);
__decorate([
    Provide("modal")
], InlineModalvue_type_script_lang_ts_OtInlineModal.prototype, "modalController", void 0);
InlineModalvue_type_script_lang_ts_OtInlineModal = __decorate([
    vue_class_component_esm
], InlineModalvue_type_script_lang_ts_OtInlineModal);
/* harmony default export */ var InlineModalvue_type_script_lang_ts_ = (InlineModalvue_type_script_lang_ts_OtInlineModal);

// CONCATENATED MODULE: ./src/modal/InlineModal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var modal_InlineModalvue_type_script_lang_ts_ = (InlineModalvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/modal/InlineModal.vue?vue&type=style&index=1&id=0a66a4ae&lang=scss&scoped=true&
var InlineModalvue_type_style_index_1_id_0a66a4ae_lang_scss_scoped_true_ = __webpack_require__("2e09");

// CONCATENATED MODULE: ./src/modal/InlineModal.vue






/* normalize component */

var InlineModal_component = normalizeComponent(
  modal_InlineModalvue_type_script_lang_ts_,
  InlineModalvue_type_template_id_0a66a4ae_scoped_true_render,
  InlineModalvue_type_template_id_0a66a4ae_scoped_true_staticRenderFns,
  false,
  null,
  "0a66a4ae",
  null
  
)

/* harmony default export */ var InlineModal = (InlineModal_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Dialog/Dialog.vue?vue&type=template&id=7b97aa9b&scoped=true&
var Dialogvue_type_template_id_7b97aa9b_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog__wrapper"},[_vm._t("default"),_c('div',[(_vm.confirmConfig)?_c('div',[_c('div',{staticClass:"dialog__backdrop"}),_c('div',{staticClass:"ot-card dialog"},[_c('div',{staticClass:"dialog__icon",class:[_vm.confirmConfig.type]},[(_vm.confirmConfig.type === 'is-danger')?_c('i',{staticClass:"oti oti-warning"}):_c('i',{staticClass:"oti oti-alert"})]),_c('h2',{staticClass:"ot-heading-h2 dialog__title"},[_vm._v(" "+_vm._s(_vm.confirmConfig.title)+" ")]),_c('p',{staticClass:"dialog__message ot-label"},[_vm._v(" "+_vm._s(_vm.confirmConfig.description)+" ")]),_c('div',{staticClass:"dialog__footer"},[_c('button',{staticClass:"ot-button is-dark",on:{"click":function($event){return _vm.confirmConfig.resolve(false)}}},[_c('i',{staticClass:"ot-button-icon--left oti oti-arrow-left"}),_vm._v(" Back ")]),(_vm.confirmConfig.type === 'is-danger')?_c('button',{staticClass:"ot-button is-danger",on:{"click":function($event){return _vm.confirmConfig.resolve(true)}}},[_c('i',{staticClass:"ot-button-icon--left oti oti-close"}),_vm._v(" Confirm ")]):_c('button',{staticClass:"ot-button",on:{"click":function($event){return _vm.confirmConfig.resolve(true)}}},[_c('i',{staticClass:"ot-button-icon--left oti oti-check"}),_vm._v(" Confirm ")])])])]):_vm._e()])],2)}
var Dialogvue_type_template_id_7b97aa9b_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/Dialog/Dialog.vue?vue&type=template&id=7b97aa9b&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Dialog/Dialog.vue?vue&type=script&lang=ts&




let Dialogvue_type_script_lang_ts_OtDialog = class OtDialog extends external_vue_default.a {
    constructor() {
        super(...arguments);
        this.controller = {
            confirm: (config) => this.confirm(config),
        };
        this.confirmConfig = null;
    }
    confirm(config) {
        return new Promise((resolve) => {
            this.confirmConfig = {
                ...config,
                type: config.type || 'is-info',
                resolve: (confirm) => {
                    resolve(confirm);
                    this.confirmConfig = null;
                },
            };
        });
    }
};
__decorate([
    Provide('dialog')
], Dialogvue_type_script_lang_ts_OtDialog.prototype, "controller", void 0);
Dialogvue_type_script_lang_ts_OtDialog = __decorate([
    vue_class_component_esm
], Dialogvue_type_script_lang_ts_OtDialog);
/* harmony default export */ var Dialogvue_type_script_lang_ts_ = (Dialogvue_type_script_lang_ts_OtDialog);

// CONCATENATED MODULE: ./src/Dialog/Dialog.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Dialog_Dialogvue_type_script_lang_ts_ = (Dialogvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/Dialog/Dialog.vue?vue&type=style&index=0&id=7b97aa9b&lang=scss&scoped=true&
var Dialogvue_type_style_index_0_id_7b97aa9b_lang_scss_scoped_true_ = __webpack_require__("e9e2");

// CONCATENATED MODULE: ./src/Dialog/Dialog.vue






/* normalize component */

var Dialog_component = normalizeComponent(
  Dialog_Dialogvue_type_script_lang_ts_,
  Dialogvue_type_template_id_7b97aa9b_scoped_true_render,
  Dialogvue_type_template_id_7b97aa9b_scoped_true_staticRenderFns,
  false,
  null,
  "7b97aa9b",
  null
  
)

/* harmony default export */ var Dialog = (Dialog_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/LazyList/LazyList.vue?vue&type=template&id=ce93c864&scoped=true&
var LazyListvue_type_template_id_ce93c864_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lazy-list-controls"},[_c('div',{staticClass:"lazy-list-controls__content"},[_vm._t("default")],2),(_vm.list.loading)?_c('div',{staticClass:"lazy-list-controls__spinner"},[_c('div',{staticClass:"ot-spinner"})]):_vm._e(),(!_vm.list.loading && !_vm.list.data.length)?_c('div',{staticClass:"lazy-list-controls__empty"},[_c('label',{staticClass:"ot-label"},[_vm._v("No results")])]):_vm._e(),(_vm.list.hasMore && !_vm.list.loading && !!_vm.list.data.length && !_vm.disableControls)?_c('label',{staticClass:"ot-label lazy-list-controls__load-more",on:{"click":_vm.loadMore}},[_vm._v("Load more...")]):_vm._e()])}
var LazyListvue_type_template_id_ce93c864_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/pagination/LazyList/LazyList.vue?vue&type=template&id=ce93c864&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/LazyList/LazyList.vue?vue&type=script&lang=ts&




let LazyListvue_type_script_lang_ts_OtLazyList = class OtLazyList extends external_vue_default.a {
    async loadMore() {
        await this.list.loadMore();
    }
};
__decorate([
    Prop()
], LazyListvue_type_script_lang_ts_OtLazyList.prototype, "list", void 0);
__decorate([
    Prop()
], LazyListvue_type_script_lang_ts_OtLazyList.prototype, "disableControls", void 0);
LazyListvue_type_script_lang_ts_OtLazyList = __decorate([
    vue_class_component_esm
], LazyListvue_type_script_lang_ts_OtLazyList);
/* harmony default export */ var LazyListvue_type_script_lang_ts_ = (LazyListvue_type_script_lang_ts_OtLazyList);

// CONCATENATED MODULE: ./src/pagination/LazyList/LazyList.vue?vue&type=script&lang=ts&
 /* harmony default export */ var LazyList_LazyListvue_type_script_lang_ts_ = (LazyListvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/pagination/LazyList/LazyList.vue?vue&type=style&index=0&id=ce93c864&lang=scss&scoped=true&
var LazyListvue_type_style_index_0_id_ce93c864_lang_scss_scoped_true_ = __webpack_require__("3b15");

// CONCATENATED MODULE: ./src/pagination/LazyList/LazyList.vue






/* normalize component */

var LazyList_component = normalizeComponent(
  LazyList_LazyListvue_type_script_lang_ts_,
  LazyListvue_type_template_id_ce93c864_scoped_true_render,
  LazyListvue_type_template_id_ce93c864_scoped_true_staticRenderFns,
  false,
  null,
  "ce93c864",
  null
  
)

/* harmony default export */ var LazyList = (LazyList_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/Pagination/Pagination.vue?vue&type=template&id=e83bb6b8&scoped=true&
var Paginationvue_type_template_id_e83bb6b8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-container"},[_c('div',{ref:"wrapper"},[_c('div',{style:({ height: _vm.height ? _vm.height + 'px' : 'auto' })},[(_vm.loading || !_vm.pagination.page)?_c('div',{staticClass:"pagination-container__spinner"},[_c('div',{staticClass:"ot-spinner"})]):(!_vm.pagination.page.data.length)?_c('div',{staticClass:"pagination-container__empty"},[_c('h4',[_vm._v("No results")])]):_c('div',[_vm._t("default")],2)])]),(!_vm.disableControls)?_c('div',{staticClass:"pagination-container__controls"},[_vm._t("controls",function(){return [_c('OtPaginationControls',{attrs:{"pagination":_vm.pagination}})]})],2):_vm._e()])}
var Paginationvue_type_template_id_e83bb6b8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/pagination/Pagination/Pagination.vue?vue&type=template&id=e83bb6b8&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/Pagination/Pagination.vue?vue&type=script&lang=ts&




let Paginationvue_type_script_lang_ts_OtPagination = class OtPagination extends external_vue_default.a {
    constructor() {
        super(...arguments);
        this.height = 0;
        this.loading = false;
    }
    onLoadingChanged(loading) {
        if (loading) {
            this.height = this.wrapper.clientHeight;
        }
        else if (this.pagination.page && this.pagination.page.data.length) {
            this.height = 0;
        }
        this.loading = loading;
    }
};
__decorate([
    Prop()
], Paginationvue_type_script_lang_ts_OtPagination.prototype, "pagination", void 0);
__decorate([
    Prop()
], Paginationvue_type_script_lang_ts_OtPagination.prototype, "disableControls", void 0);
__decorate([
    Ref('wrapper')
], Paginationvue_type_script_lang_ts_OtPagination.prototype, "wrapper", void 0);
__decorate([
    Watch('pagination.loading')
], Paginationvue_type_script_lang_ts_OtPagination.prototype, "onLoadingChanged", null);
Paginationvue_type_script_lang_ts_OtPagination = __decorate([
    vue_class_component_esm
], Paginationvue_type_script_lang_ts_OtPagination);
/* harmony default export */ var Paginationvue_type_script_lang_ts_ = (Paginationvue_type_script_lang_ts_OtPagination);

// CONCATENATED MODULE: ./src/pagination/Pagination/Pagination.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Pagination_Paginationvue_type_script_lang_ts_ = (Paginationvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/pagination/Pagination/Pagination.vue?vue&type=style&index=0&id=e83bb6b8&lang=scss&scoped=true&
var Paginationvue_type_style_index_0_id_e83bb6b8_lang_scss_scoped_true_ = __webpack_require__("9ff3");

// CONCATENATED MODULE: ./src/pagination/Pagination/Pagination.vue






/* normalize component */

var Pagination_component = normalizeComponent(
  Pagination_Paginationvue_type_script_lang_ts_,
  Paginationvue_type_template_id_e83bb6b8_scoped_true_render,
  Paginationvue_type_template_id_e83bb6b8_scoped_true_staticRenderFns,
  false,
  null,
  "e83bb6b8",
  null
  
)

/* harmony default export */ var Pagination = (Pagination_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/PaginationControls/PaginationControls.vue?vue&type=template&id=524a5bf8&scoped=true&
var PaginationControlsvue_type_template_id_524a5bf8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-controls"},[(!_vm.disablePerPage)?_c('div',{staticClass:"pagination-controls__per-page"},[_c('ot-input',{attrs:{"type":"select","options":_vm.perPageOptionsMap,"value":_vm.currentPerPage},on:{"input":_vm.updatePerPage}})],1):_vm._e(),(_vm.pagination.page)?_c('div',{staticClass:"pagination-controls__pages"},[_c('div',{staticClass:"pages__item",attrs:{"disabled":_vm.currentIndex < 2 || _vm.pagination.page.last_page < 2},on:{"click":function($event){return _vm.shiftPage(-1)}}},[_c('i',{staticClass:"oti oti-carrot-left"})]),_vm._l((_vm.pageRange),function(i){return _c('div',{key:i,staticClass:"pages__index",class:{ focus: i === _vm.currentIndex, dots: i === -1 },attrs:{"disabled":_vm.pagination.page.last_page < 2},on:{"click":function($event){return _vm.pagination.getPage({ page: i })}}},[_vm._v(" "+_vm._s(i === -1 ? "..." : i)+" ")])}),_c('div',{staticClass:"pages__item",attrs:{"disabled":_vm.currentIndex >= _vm.lastIndex || _vm.pagination.page.last_page < 2},on:{"click":function($event){return _vm.shiftPage(1)}}},[_c('i',{staticClass:"oti oti-carrot-right"})])],2):_vm._e()])}
var PaginationControlsvue_type_template_id_524a5bf8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/pagination/PaginationControls/PaginationControls.vue?vue&type=template&id=524a5bf8&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/PaginationControls/PaginationControls.vue?vue&type=script&lang=ts&




let PaginationControlsvue_type_script_lang_ts_OtPaginationControls = class OtPaginationControls extends external_vue_default.a {
    get perPageOptionsMap() {
        const options = {};
        for (const number of this.perPageOptions) {
            options[number] = number;
        }
        const current = this.pagination.defaults().per_page;
        if (typeof current === "number" && options[current] === undefined) {
            options[current] = current;
        }
        return options;
    }
    get currentIndex() {
        if (!this.pagination.page) {
            return 1;
        }
        return this.pagination.page.current_page;
    }
    get lastIndex() {
        if (!this.pagination.page) {
            return 1;
        }
        return this.pagination.page.last_page;
    }
    get pageRange() {
        const arr = [];
        if (this.currentIndex > 1) {
            arr.push(1);
        }
        if (this.currentIndex > 3) {
            arr.push(-1);
        }
        if (this.currentIndex > 2) {
            arr.push(this.currentIndex - 1);
        }
        arr.push(this.currentIndex);
        if (this.lastIndex - this.currentIndex > 2) {
            arr.push(this.currentIndex + 1);
        }
        if (this.lastIndex - this.currentIndex > 3) {
            arr.push(-1);
        }
        if (this.lastIndex - this.currentIndex > 1) {
            arr.push(this.lastIndex);
        }
        return arr;
    }
    get currentPerPage() {
        return this.pagination.page ? this.pagination.page.per_page : null;
    }
    shiftPage(shift) {
        void this.pagination.getPage({ page: this.currentIndex + shift });
    }
    updatePerPage(perPage) {
        void this.pagination.refresh({ per_page: perPage });
    }
};
__decorate([
    Prop({ type: Object, required: true })
], PaginationControlsvue_type_script_lang_ts_OtPaginationControls.prototype, "pagination", void 0);
__decorate([
    Prop({ type: Array, default: () => [10, 30, 50, 100] })
], PaginationControlsvue_type_script_lang_ts_OtPaginationControls.prototype, "perPageOptions", void 0);
__decorate([
    Prop()
], PaginationControlsvue_type_script_lang_ts_OtPaginationControls.prototype, "disablePerPage", void 0);
PaginationControlsvue_type_script_lang_ts_OtPaginationControls = __decorate([
    vue_class_component_esm
], PaginationControlsvue_type_script_lang_ts_OtPaginationControls);
/* harmony default export */ var PaginationControlsvue_type_script_lang_ts_ = (PaginationControlsvue_type_script_lang_ts_OtPaginationControls);

// CONCATENATED MODULE: ./src/pagination/PaginationControls/PaginationControls.vue?vue&type=script&lang=ts&
 /* harmony default export */ var PaginationControls_PaginationControlsvue_type_script_lang_ts_ = (PaginationControlsvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/pagination/PaginationControls/PaginationControls.vue?vue&type=style&index=0&id=524a5bf8&lang=scss&scoped=true&
var PaginationControlsvue_type_style_index_0_id_524a5bf8_lang_scss_scoped_true_ = __webpack_require__("bc88");

// CONCATENATED MODULE: ./src/pagination/PaginationControls/PaginationControls.vue






/* normalize component */

var PaginationControls_component = normalizeComponent(
  PaginationControls_PaginationControlsvue_type_script_lang_ts_,
  PaginationControlsvue_type_template_id_524a5bf8_scoped_true_render,
  PaginationControlsvue_type_template_id_524a5bf8_scoped_true_staticRenderFns,
  false,
  null,
  "524a5bf8",
  null
  
)

/* harmony default export */ var PaginationControls = (PaginationControls_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/PaginationTable/PaginationTable.vue?vue&type=template&id=723d9fa0&scoped=true&
var PaginationTablevue_type_template_id_723d9fa0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-table"},[_c('Table',{attrs:{"columns":_vm.columns,"pagination":_vm.pagination,"actions-width":_vm.actionsWidth},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)}),(!_vm.disableControls)?_c('div',{staticClass:"pagination-table__controls"},[_vm._t("controls",function(){return [_c('PaginationControls',{attrs:{"pagination":_vm.pagination}})]})],2):_vm._e()],1)}
var PaginationTablevue_type_template_id_723d9fa0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/pagination/PaginationTable/PaginationTable.vue?vue&type=template&id=723d9fa0&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/PaginationTable/table/Table.vue?vue&type=template&id=6e85b8ae&
var Tablevue_type_template_id_6e85b8ae_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ot-table"},[(_vm.columns && _vm.columns.length)?_c('table',{staticClass:"ot-table__table"},[_c('TableHead',{attrs:{"actions-width":_vm.actionsWidth}}),_c('TableBody',{scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)}),_c('TableFoot',{scopedSlots:_vm._u([(_vm.$scopedSlots['foot'])?{key:"foot",fn:function(){return [_vm._t("foot")]},proxy:true}:null],null,true)})],1):_vm._e()])}
var Tablevue_type_template_id_6e85b8ae_staticRenderFns = []


// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/Table.vue?vue&type=template&id=6e85b8ae&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/PaginationTable/table/TableHead.vue?vue&type=template&id=02b1a5d7&
var TableHeadvue_type_template_id_02b1a5d7_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"ot-table__head",class:{
        'ot-table__head--disabled': _vm.empty,
    }},[_vm._l((_vm.columns),function(column){return _c('th',{key:column.prop,class:[
            'ot-table__head-cell',
            {
                'ot-table__head-cell--orderable': column.orderable,
                'ot-table__head-cell--hide': !column.show,
            },
            _vm.getColumnOrderClass(column) ],style:(_vm.getColumnWidth(column)),on:{"click":function($event){return _vm.order(column)}}},[_c('div',{staticClass:"head-cell__content"},[_c('strong',{staticClass:"head-cell__label"},[_vm._v(_vm._s(column.label))]),(column.orderable)?_c('div',{staticClass:"head-cell__sort"},[_c('i',{staticClass:"sort__icon sort__icon--asc oti oti-drop-up"}),_c('i',{staticClass:"sort__icon sort__icon--desc oti oti-drop-down"})]):_vm._e()])])}),_c('th',{staticClass:"ot-table__head-cell ot-table__head-cell--actions",attrs:{"width":(_vm.actionsWidth + "%")}},[_c('div',{staticClass:"head-cell__content"},[_c('TableColumnSelection',{attrs:{"disabled":_vm.empty}})],1)])],2)}
var TableHeadvue_type_template_id_02b1a5d7_staticRenderFns = []


// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/TableHead.vue?vue&type=template&id=02b1a5d7&

// EXTERNAL MODULE: ./node_modules/@openticket/lib-sdk-helpers/lib/helpers.js
var helpers = __webpack_require__("b8fd");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/PaginationTable/table/TableColumnSelection.vue?vue&type=template&id=6a3645b5&scoped=true&
var TableColumnSelectionvue_type_template_id_6a3645b5_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OtDropdown',{ref:"column-selection-dropdown",attrs:{"disabled":_vm.disabled},scopedSlots:_vm._u([{key:"trigger",fn:function(ref){
var opened = ref.opened;
return [_c('button',{staticClass:"ot-table__column-selection ot-button",class:{
                'ot-table__column-selection--open': opened,
                'ot-table__column-selection--active': _vm.columnSelectionActive,
            }},[_c('i',{staticClass:"column-selection__icon oti oti-menu"}),_c('i',{staticClass:"column-selection__icon oti oti-drop-up"}),_c('i',{staticClass:"column-selection__icon oti oti-drop-down"})])]}},{key:"content",fn:function(){return [_c('div',{staticClass:"column-selection__dropdown"},[_c('div',{staticClass:"column-selection__dropdown-content"},_vm._l((_vm.dirtyColumns),function(column){return _c('ot-input',{key:column.prop,attrs:{"type":"checkbox","label":column.label,"disabled":_vm.isLastSelectableColumn(column)},model:{value:(column.show),callback:function ($$v) {_vm.$set(column, "show", $$v)},expression:"column.show"}})}),1),_c('div',{staticClass:"column-selection__dropdown-footer"},[_c('button',{staticClass:"ot-button is-tiny",on:{"click":_vm.cancel}},[_c('i',{staticClass:"oti oti-icon-close"}),_vm._v(" Cancel ")]),_c('button',{staticClass:"ot-button is-tiny",on:{"click":_vm.apply}},[_c('i',{staticClass:"oti oti-icon-close"}),_vm._v(" Apply ")])])])]},proxy:true}])})}
var TableColumnSelectionvue_type_template_id_6a3645b5_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/TableColumnSelection.vue?vue&type=template&id=6a3645b5&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Dropdown.vue?vue&type=template&id=1cd98873&scoped=true&
var Dropdownvue_type_template_id_1cd98873_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown"},[_c('div',{staticClass:"dropdown__trigger",on:{"click":function($event){_vm.opened = !_vm.opened}}},[_vm._t("trigger",null,null,{ opened: _vm.opened })],2),_c('div',{staticClass:"dropdown__backdrop",class:{ opened: _vm.opened },on:{"click":function($event){_vm.opened = false}}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.opened),expression:"opened"}],staticClass:"dropdown__placeholder"},[_c('div',{staticClass:"ot-card dropdown__dialog",class:{ fill: _vm.fill }},[_vm._t("content",null,null,{ close: _vm.close })],2)])])}
var Dropdownvue_type_template_id_1cd98873_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/Dropdown.vue?vue&type=template&id=1cd98873&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Dropdown.vue?vue&type=script&lang=ts&




let Dropdownvue_type_script_lang_ts_OtDropdown = class OtDropdown extends external_vue_default.a {
    constructor() {
        super(...arguments);
        this.opened = false;
    }
    open() {
        if (this.disabled) {
            return;
        }
        this.opened = true;
    }
    close() {
        this.opened = false;
    }
};
__decorate([
    Prop({ type: Boolean })
], Dropdownvue_type_script_lang_ts_OtDropdown.prototype, "fill", void 0);
__decorate([
    Prop({ type: Boolean })
], Dropdownvue_type_script_lang_ts_OtDropdown.prototype, "disabled", void 0);
Dropdownvue_type_script_lang_ts_OtDropdown = __decorate([
    vue_class_component_esm
], Dropdownvue_type_script_lang_ts_OtDropdown);
/* harmony default export */ var Dropdownvue_type_script_lang_ts_ = (Dropdownvue_type_script_lang_ts_OtDropdown);

// CONCATENATED MODULE: ./src/Dropdown.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_Dropdownvue_type_script_lang_ts_ = (Dropdownvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/Dropdown.vue?vue&type=style&index=0&id=1cd98873&lang=scss&scoped=true&
var Dropdownvue_type_style_index_0_id_1cd98873_lang_scss_scoped_true_ = __webpack_require__("40c6");

// CONCATENATED MODULE: ./src/Dropdown.vue






/* normalize component */

var Dropdown_component = normalizeComponent(
  src_Dropdownvue_type_script_lang_ts_,
  Dropdownvue_type_template_id_1cd98873_scoped_true_render,
  Dropdownvue_type_template_id_1cd98873_scoped_true_staticRenderFns,
  false,
  null,
  "1cd98873",
  null
  
)

/* harmony default export */ var Dropdown = (Dropdown_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/PaginationTable/table/TableColumnSelection.vue?vue&type=script&lang=ts&





let TableColumnSelectionvue_type_script_lang_ts_TableColumnSelection = class TableColumnSelection extends external_vue_default.a {
    constructor() {
        super(...arguments);
        /**
         *  Holding a copy of the columns to make sure the column
         *  selection (hiding/showing columns) happens async
         *  once the user confirms the selection.
         */
        this.dirtyColumns = [];
    }
    /**
     *  Used to get the active state of the column selection, which
     *  is active if one of the columns is disabled (hidden).
     */
    get columnSelectionActive() {
        let active = false;
        for (const column of this.dirtyColumns) {
            if (column.show === false) {
                active = true;
                break;
            }
        }
        return active;
    }
    updateDirtyColumns() {
        this.dirtyColumns = this.columns.map((column) => ({
            ...column,
        }));
    }
    /**
     *  Used to reset the dirty columns, by simply overwriting
     *  them again with the original columns.
     */
    cancel() {
        this.updateDirtyColumns();
        this.dropdown.close();
    }
    /**
     *  Used to update the columns' show state once the
     *  user confirms the selection.
     */
    apply() {
        for (const dc of this.dirtyColumns) {
            for (const c of this.columns) {
                if (dc.prop === c.prop) {
                    c.show = dc.show;
                    break;
                }
            }
        }
        this.dropdown.close();
    }
    /**
     *
     *  Used to compute if the forwarded column is the last selected
     *  (activated) column in the column selection: returning true
     *  disables him in the column selection.
     *
     *  (i) Making sure a table always has at least
     *  one column selected/showing.
     *
     */
    isLastSelectableColumn(column) {
        if (!column.show) {
            return false;
        }
        let disabledColumns = 0;
        for (const dc of this.dirtyColumns) {
            if (!dc.show) {
                disabledColumns++;
            }
        }
        return disabledColumns === this.columns.length - 1;
    }
};
__decorate([
    Ref('column-selection-dropdown')
], TableColumnSelectionvue_type_script_lang_ts_TableColumnSelection.prototype, "dropdown", void 0);
__decorate([
    InjectReactive('columns')
], TableColumnSelectionvue_type_script_lang_ts_TableColumnSelection.prototype, "columns", void 0);
__decorate([
    Prop({ type: Boolean })
], TableColumnSelectionvue_type_script_lang_ts_TableColumnSelection.prototype, "disabled", void 0);
__decorate([
    Watch('columns', { immediate: true, deep: true })
], TableColumnSelectionvue_type_script_lang_ts_TableColumnSelection.prototype, "updateDirtyColumns", null);
TableColumnSelectionvue_type_script_lang_ts_TableColumnSelection = __decorate([
    vue_class_component_esm({
        components: {
            OtDropdown: Dropdown,
        },
    })
], TableColumnSelectionvue_type_script_lang_ts_TableColumnSelection);
/* harmony default export */ var TableColumnSelectionvue_type_script_lang_ts_ = (TableColumnSelectionvue_type_script_lang_ts_TableColumnSelection);

// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/TableColumnSelection.vue?vue&type=script&lang=ts&
 /* harmony default export */ var table_TableColumnSelectionvue_type_script_lang_ts_ = (TableColumnSelectionvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/pagination/PaginationTable/table/TableColumnSelection.vue?vue&type=style&index=0&id=6a3645b5&lang=scss&scoped=true&
var TableColumnSelectionvue_type_style_index_0_id_6a3645b5_lang_scss_scoped_true_ = __webpack_require__("ccbe");

// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/TableColumnSelection.vue






/* normalize component */

var TableColumnSelection_component = normalizeComponent(
  table_TableColumnSelectionvue_type_script_lang_ts_,
  TableColumnSelectionvue_type_template_id_6a3645b5_scoped_true_render,
  TableColumnSelectionvue_type_template_id_6a3645b5_scoped_true_staticRenderFns,
  false,
  null,
  "6a3645b5",
  null
  
)

/* harmony default export */ var table_TableColumnSelection = (TableColumnSelection_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/PaginationTable/table/TableHead.vue?vue&type=script&lang=ts&




// SDK

// Used for programmatically closing the column selection dropdown

let TableHeadvue_type_script_lang_ts_TableHead = class TableHead extends external_vue_default.a {
    /**
     *
     *  Used to get a column's sort class, based on his sort state.
     *
     *  (i) Used because the appearance of the sorting icons are fully CSS based.
     *
     */
    getColumnOrderClass(column) {
        if (!column.orderable || this.getOrderState(column) === 'none') {
            return null;
        }
        return `ot-table__head-cell--${this.getOrderState(column)}`;
    }
    /**
     *  Used to get the (style object for the) width of the column, which
     *  is computed based on the columns that are showing and takes
     *  the columns with a static width into account.
     */
    getColumnWidth(column) {
        // The column's width is defined as percentage
        let percentage = 0;
        if (column.show && column.width === undefined) {
            // The width that is available to divide within the table,
            // (i) Directly subtracting the width of the action's column
            let availableWidth = 100 - this.actionsWidth;
            // Compute how many columns are showing and how
            // many have a static width, in order to be able
            // to compute the correct width of the column
            let columnsShowing = 0;
            let staticWidths = 0;
            for (const c of this.columns) {
                if (c.show) {
                    columnsShowing++;
                }
                // Ignoring zero on purpose
                if (c.width) {
                    staticWidths++;
                    availableWidth -= c.width;
                }
            }
            percentage = availableWidth / (columnsShowing - staticWidths);
        }
        /**
         *
         *  The width of the column is either:
         *
         *  1. the static width of the column as forwarded/set by the parent or
         *  2. the computed width, based on the number of columns (that do not have a
         *  static width) and the available (remaining) width to divide.
         *
         */
        return {
            width: `${column.width || percentage}%`,
        };
    }
    /**
     *
     *  Used to get the current order state of the
     *  column out of the pagination.
     *
     *  (i) The pagination doesn't hold a state if
     *  there is no ordering applied for the column
     *
     */
    getOrderState(column) {
        const ordering = this.pagination.getFieldOrder(column.prop);
        return !ordering ? 'none' : ordering.order;
    }
    /**
     *  Used to get the next state of the forwarded column.
     */
    getNextOrderState(column) {
        let nextState;
        switch (this.getOrderState(column)) {
            case 'none':
                nextState = helpers["PaginationOrder"].ASC;
                break;
            case helpers["PaginationOrder"].ASC:
                nextState = helpers["PaginationOrder"].DESC;
                break;
            case helpers["PaginationOrder"].DESC:
            default:
                nextState = 'none';
                break;
        }
        return nextState;
    }
    /**
     *  Used to order the data for a column.
     */
    order(column) {
        if (!column.orderable || this.empty) {
            return;
        }
        const nextState = this.getNextOrderState(column);
        if (nextState === 'none') {
            void this.pagination.removeOrder(column.prop);
        }
        else {
            void this.pagination.addOrder(column.prop, nextState);
        }
    }
};
__decorate([
    InjectReactive('pagination')
], TableHeadvue_type_script_lang_ts_TableHead.prototype, "pagination", void 0);
__decorate([
    InjectReactive('columns')
], TableHeadvue_type_script_lang_ts_TableHead.prototype, "columns", void 0);
__decorate([
    Prop({ type: Number, default: 15 })
], TableHeadvue_type_script_lang_ts_TableHead.prototype, "actionsWidth", void 0);
__decorate([
    InjectReactive('empty')
], TableHeadvue_type_script_lang_ts_TableHead.prototype, "empty", void 0);
TableHeadvue_type_script_lang_ts_TableHead = __decorate([
    vue_class_component_esm({
        components: {
            TableColumnSelection: table_TableColumnSelection,
        },
    })
], TableHeadvue_type_script_lang_ts_TableHead);
/* harmony default export */ var TableHeadvue_type_script_lang_ts_ = (TableHeadvue_type_script_lang_ts_TableHead);

// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/TableHead.vue?vue&type=script&lang=ts&
 /* harmony default export */ var table_TableHeadvue_type_script_lang_ts_ = (TableHeadvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/TableHead.vue





/* normalize component */

var TableHead_component = normalizeComponent(
  table_TableHeadvue_type_script_lang_ts_,
  TableHeadvue_type_template_id_02b1a5d7_render,
  TableHeadvue_type_template_id_02b1a5d7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var table_TableHead = (TableHead_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/PaginationTable/table/TableBody.vue?vue&type=template&id=48de7b60&
var TableBodyvue_type_template_id_48de7b60_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',{staticClass:"ot-table__body",class:{
        'ot-table__body--loading': _vm.pagination.loading,
        'ot-table__body--empty': _vm.empty,
    }},[(_vm.pagination.loading)?_c('tr',{staticClass:"ot-table__row ot-table__row--loader"},[_c('td',{staticClass:"ot-table__cell",attrs:{"colspan":_vm.fullColspan}},[_vm._t("loader",function(){return [_c('Spinner')]})],2)]):_vm._e(),(_vm.empty)?_c('tr',{staticClass:"ot-table__row ot-table__row--empty"},[_c('td',{staticClass:"ot-table__cell",attrs:{"colspan":_vm.fullColspan}},[_vm._v(" No results.. ")])]):_vm._e(),_vm._l((_vm.records),function(record,index){return _c('tr',{key:index,staticClass:"ot-table__row"},[_vm._l((_vm.columns),function(column){return _c('td',{key:column.prop,staticClass:"ot-table__cell",class:[
                {
                    'ot-table__cell--hide': !column.show,
                },
                _vm.getColumnAlign(column) ]},[_vm._t(_vm.getColumnSlotName(column),function(){return [(column.type === 'date')?_c('span',{staticClass:"cell__content"},[_vm._v(" "+_vm._s(_vm.$localization.formatters.dateTime(_vm.getValue(record, column)))+" ")]):_vm._e(),(column.type === 'email')?_c('span',{staticClass:"cell__content"},[_c('a',{staticClass:"ot-link",attrs:{"href":("mailto:" + (_vm.getValue(record, column)))}},[_vm._v(_vm._s(_vm.getValue(record, column)))])]):_vm._e(),(column.type === 'phone')?_c('span',{staticClass:"cell__content"},[_c('a',{staticClass:"ot-link",attrs:{"href":("tel:" + (_vm.getValue(record, column.replace(/ /g, ''))))}},[_vm._v(_vm._s(_vm.getValue(record, column)))])]):_c('span',{staticClass:"cell__content"},[_vm._v(_vm._s(_vm.getValue(record, column, true)))])]},{"value":_vm.getValue(record, column),"record":record})],2)}),_c('td',{staticClass:"ot-table__cell ot-table__cell--actions"},[_vm._t("actions",null,{"record":record})],2)],2)})],2)}
var TableBodyvue_type_template_id_48de7b60_staticRenderFns = []


// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/TableBody.vue?vue&type=template&id=48de7b60&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Spinner.vue?vue&type=template&id=5a765f9b&scoped=true&
var Spinnervue_type_template_id_5a765f9b_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Spinnervue_type_template_id_5a765f9b_scoped_true_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"ot-spinner"})])}]


// CONCATENATED MODULE: ./src/Spinner.vue?vue&type=template&id=5a765f9b&scoped=true&

// EXTERNAL MODULE: ./src/Spinner.vue?vue&type=style&index=0&id=5a765f9b&lang=scss&scoped=true&
var Spinnervue_type_style_index_0_id_5a765f9b_lang_scss_scoped_true_ = __webpack_require__("ebb6");

// CONCATENATED MODULE: ./src/Spinner.vue

var Spinner_script = {}



/* normalize component */

var Spinner_component = normalizeComponent(
  Spinner_script,
  Spinnervue_type_template_id_5a765f9b_scoped_true_render,
  Spinnervue_type_template_id_5a765f9b_scoped_true_staticRenderFns,
  false,
  null,
  "5a765f9b",
  null
  
)

/* harmony default export */ var Spinner = (Spinner_component.exports);
// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/types.ts
/**
 *
 *  The type of data a columns holds.
 *
 *  (i) Used to add additional formatting or
 *  styling if needed, which happens in the
 *  TableBody component's getValue() method.
 *
 */
var ColumnType;
(function (ColumnType) {
    ColumnType["Boolean"] = "boolean";
    ColumnType["Custom"] = "custom";
    ColumnType["Date"] = "date";
    ColumnType["Email"] = "email";
    ColumnType["Number"] = "number";
    ColumnType["Phone"] = "phone";
    ColumnType["String"] = "string";
})(ColumnType || (ColumnType = {}));
/**
 *  The possible alignments of a column.
 */
var ColumnAlign;
(function (ColumnAlign) {
    ColumnAlign["Center"] = "center";
    ColumnAlign["Right"] = "right";
})(ColumnAlign || (ColumnAlign = {}));

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/PaginationTable/table/TableBody.vue?vue&type=script&lang=ts&




// Shown by default when loading

// Table types

let TableBodyvue_type_script_lang_ts_TableBody = class TableBody extends external_vue_default.a {
    constructor() {
        super(...arguments);
        // Column types that are automatically aligned right if no specific alignment is provided
        this.defaultRightAlign = [
            ColumnType.Number,
        ];
    }
    /**
     *  Checking if a template is provided for columns
     *  that have a custom column type set.
     */
    mounted() {
        const providedTpls = Object.keys(this.$scopedSlots);
        for (const column of this.columns) {
            if (column.type === ColumnType.Custom
                && !providedTpls.includes(this.getColumnSlotName(column))) {
                throw Error(`Table -> template must be provided for custom column "${column.prop}". Please note that any other character than letters, underscores and dashes of prop names are automatically converted to dashes.`);
            }
        }
    }
    /**
     *
     *  Used to get the class for the column alignment.
     *
     *  (i) Automatically aligns columns to the right if
     *  they have no align specified and are present
     *  in the defaultRightAlign Array.
     *
     */
    getColumnAlign(column) {
        if (!column.align) {
            return this.defaultRightAlign.includes(column.type)
                ? `ot-table__cell--${ColumnAlign.Right}`
                : null;
        }
        return `ot-table__cell--${column.align}`;
    }
    /**
     *
     *  Used to get the slot name for a column, which is
     *  equal to the name of the prop with a custom
     *  prefix to make clear it's about a column.
     *
     *  (i) Because the name of scoped slots only allow
     *  letters, dashes and underscore, every other
     *  characters automatically converted to a dash.
     *
     */
    getColumnSlotName(column) {
        return `column_${column.prop.replace(/[^a-z-_]/gi, '-')}`;
    }
    /**
     *
     *  Used to get the value of the record for the forwarded column.
     *
     *  @param transform If the data should be transformed, based on the type of column
     *
     *  @todo Finish transforms when/if $localization is available
     *
     */
    getValue(record, column) {
        return this.recordData(record)[column.prop];
    }
};
__decorate([
    InjectReactive('records')
], TableBodyvue_type_script_lang_ts_TableBody.prototype, "records", void 0);
__decorate([
    InjectReactive('columns')
], TableBodyvue_type_script_lang_ts_TableBody.prototype, "columns", void 0);
__decorate([
    InjectReactive('pagination')
], TableBodyvue_type_script_lang_ts_TableBody.prototype, "pagination", void 0);
__decorate([
    InjectReactive('recordData')
], TableBodyvue_type_script_lang_ts_TableBody.prototype, "recordData", void 0);
__decorate([
    InjectReactive('fullColspan')
], TableBodyvue_type_script_lang_ts_TableBody.prototype, "fullColspan", void 0);
__decorate([
    InjectReactive('empty')
], TableBodyvue_type_script_lang_ts_TableBody.prototype, "empty", void 0);
TableBodyvue_type_script_lang_ts_TableBody = __decorate([
    vue_class_component_esm({
        components: {
            Spinner: Spinner,
        },
    })
], TableBodyvue_type_script_lang_ts_TableBody);
/* harmony default export */ var TableBodyvue_type_script_lang_ts_ = (TableBodyvue_type_script_lang_ts_TableBody);

// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/TableBody.vue?vue&type=script&lang=ts&
 /* harmony default export */ var table_TableBodyvue_type_script_lang_ts_ = (TableBodyvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/TableBody.vue





/* normalize component */

var TableBody_component = normalizeComponent(
  table_TableBodyvue_type_script_lang_ts_,
  TableBodyvue_type_template_id_48de7b60_render,
  TableBodyvue_type_template_id_48de7b60_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var table_TableBody = (TableBody_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/PaginationTable/table/TableFoot.vue?vue&type=template&id=0f43eb81&
var TableFootvue_type_template_id_0f43eb81_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',{staticClass:"ot-table__foot"},[(_vm.$scopedSlots['foot'])?_c('tr',{staticClass:"ot-table__row ot-table__row--foot"},[_c('td',{staticClass:"ot-table__cell ot-table__cell--foot",attrs:{"colspan":_vm.fullColspan}},[_vm._t("foot")],2)]):_vm._e()])}
var TableFootvue_type_template_id_0f43eb81_staticRenderFns = []


// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/TableFoot.vue?vue&type=template&id=0f43eb81&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/PaginationTable/table/TableFoot.vue?vue&type=script&lang=ts&




let TableFootvue_type_script_lang_ts_TableFoot = class TableFoot extends external_vue_default.a {
};
__decorate([
    InjectReactive('columns')
], TableFootvue_type_script_lang_ts_TableFoot.prototype, "columns", void 0);
__decorate([
    InjectReactive('pagination')
], TableFootvue_type_script_lang_ts_TableFoot.prototype, "pagination", void 0);
__decorate([
    InjectReactive('fullColspan')
], TableFootvue_type_script_lang_ts_TableFoot.prototype, "fullColspan", void 0);
TableFootvue_type_script_lang_ts_TableFoot = __decorate([
    vue_class_component_esm
], TableFootvue_type_script_lang_ts_TableFoot);
/* harmony default export */ var TableFootvue_type_script_lang_ts_ = (TableFootvue_type_script_lang_ts_TableFoot);

// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/TableFoot.vue?vue&type=script&lang=ts&
 /* harmony default export */ var table_TableFootvue_type_script_lang_ts_ = (TableFootvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/TableFoot.vue





/* normalize component */

var TableFoot_component = normalizeComponent(
  table_TableFootvue_type_script_lang_ts_,
  TableFootvue_type_template_id_0f43eb81_render,
  TableFootvue_type_template_id_0f43eb81_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var table_TableFoot = (TableFoot_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/PaginationTable/table/Table.vue?vue&type=script&lang=ts&




// The custom table's parts are split over the following components



let Tablevue_type_script_lang_ts_Table = class Table extends external_vue_default.a {
    constructor() {
        super(...arguments);
        // Columns that are painted
        this.loadedColumns = [];
        // Records that are painted
        this.loadedRecords = [];
    }
    /**
     *  Used to get the empty state of the table.
     */
    get empty() {
        return !this.pagination.loading && !(this.pagination.page && this.pagination.page.data.length);
    }
    /**
     *
     *  Used for giving the foot row(s) the full width.
     *
     *  (i) Plus one for the default added actions column
     *
     */
    get fullColspan() {
        return this.columns.length + 1;
    }
    /**
     *  Used to load the records, which are always present in the pagination's data prop.
     */
    async loadRecords() {
        if (this.pagination.page && this.pagination.page.data) {
            this.loadedRecords = this.pagination.page.data;
            return;
        }
        await this.pagination.getPage({ page: 1 });
        this.loadedRecords = this.pagination.page
            ? this.pagination.page.data
            : [];
    }
    /**
     *  Used to load and validate the columns. Making sure there's
     *  a template provided for columns with a custom column
     *  type and adding a true show state by default.
     */
    loadColumns() {
        this.loadedColumns = [];
        for (const column of this.columns) {
            this.loadedColumns.push({
                show: true,
                ...column,
            });
        }
    }
};
__decorate([
    ProvideReactive('columns')
], Tablevue_type_script_lang_ts_Table.prototype, "loadedColumns", void 0);
__decorate([
    ProvideReactive('records')
], Tablevue_type_script_lang_ts_Table.prototype, "loadedRecords", void 0);
__decorate([
    InjectReactive('columns')
], Tablevue_type_script_lang_ts_Table.prototype, "columns", void 0);
__decorate([
    InjectReactive('pagination')
], Tablevue_type_script_lang_ts_Table.prototype, "pagination", void 0);
__decorate([
    Prop({ type: Number })
], Tablevue_type_script_lang_ts_Table.prototype, "actionsWidth", void 0);
__decorate([
    ProvideReactive('empty')
], Tablevue_type_script_lang_ts_Table.prototype, "empty", null);
__decorate([
    ProvideReactive('fullColspan')
], Tablevue_type_script_lang_ts_Table.prototype, "fullColspan", null);
__decorate([
    Watch('pagination.page.data', { immediate: true })
], Tablevue_type_script_lang_ts_Table.prototype, "loadRecords", null);
__decorate([
    Watch('columns', { immediate: true, deep: true })
], Tablevue_type_script_lang_ts_Table.prototype, "loadColumns", null);
Tablevue_type_script_lang_ts_Table = __decorate([
    vue_class_component_esm({
        components: {
            TableHead: table_TableHead,
            TableBody: table_TableBody,
            TableFoot: table_TableFoot,
        },
    })
], Tablevue_type_script_lang_ts_Table);
/* harmony default export */ var Tablevue_type_script_lang_ts_ = (Tablevue_type_script_lang_ts_Table);

// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/Table.vue?vue&type=script&lang=ts&
 /* harmony default export */ var table_Tablevue_type_script_lang_ts_ = (Tablevue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/pagination/PaginationTable/table/Table.vue





/* normalize component */

var Table_component = normalizeComponent(
  table_Tablevue_type_script_lang_ts_,
  Tablevue_type_template_id_6e85b8ae_render,
  Tablevue_type_template_id_6e85b8ae_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var table_Table = (Table_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/pagination/PaginationTable/PaginationTable.vue?vue&type=script&lang=ts&




// Actual table component

// Used to control the (data of the) pagination table

/**
 *
 *  Custom pagination table component, used to paint custom tables based on a pagination object.
 *
 *  #### Columns
 *  Besides the pagination object, an Array with columns must be provided.
 *
 *  > Every column must implement the Column interface, found in the `table/types.ts` file
 *
 *  ##### Column types
 *  There are multiple column types, defined with the `ColumnType` enum, for which
 *  of some the data of the cell is automatically transformed.
 *
 *  | Type                      | Transform                                            |
 *  | :------------------------ | :--------------------------------------------------- |
 *  | `ColumnType.Boolean`      | No                                                   |
 *  | `ColumnType.Custom`       | No, a custom template must be provided               |
 *  | `ColumnType.Date`         | Yes, using the $localization's dateTime formatter    |
 *  | `ColumnType.Email`        | Yes, turning it into a mailto: link                  |
 *  | `ColumnType.Number`       | No                                                   |
 *  | `ColumnType.Phone`        | Yes, turning it into a tel: link                     |
 *  | `ColumnType.String`       | No                                                   |
 *
 *  #### Scoped slots per column
 *  The dynamic forwarding of scoped body slots allows us to paint custom
 *  stuff in every cell of a row, by providing it as following.
 *
 *      <template #column_{name_of_record_prop}="{ record, value }">
 *          Record: full object for which the cell is painted
 *          Value: the value of the property for this cell
 *      </template>
 *
 *  > If the column type is `ColumnType.Custom`, a template **must** be provided
 *
 *  #### Actions slot
 *  Content of the action cells can be forwarded by the actions slot,
 *  which also recieves the record for which the cell is painted.
 *
 *      <template #actions="{ record }">
 *          Actions for the record
 *      </template>
 *
 *  #### Custom foot row
 *  Content for a custom foot row (which gets the full colspan) can
 *  be forwarded by the foot slot.
 *
 *      <template #foot>
 *          Custom footer content
 *      </template>
 *
 */
let PaginationTablevue_type_script_lang_ts_PaginationTable = class PaginationTable extends external_vue_default.a {
};
__decorate([
    ProvideReactive('columns'),
    Prop({ type: Array, required: true })
], PaginationTablevue_type_script_lang_ts_PaginationTable.prototype, "columns", void 0);
__decorate([
    ProvideReactive('pagination'),
    Prop({ type: Object, required: true })
], PaginationTablevue_type_script_lang_ts_PaginationTable.prototype, "pagination", void 0);
__decorate([
    Prop()
], PaginationTablevue_type_script_lang_ts_PaginationTable.prototype, "disableControls", void 0);
__decorate([
    ProvideReactive('recordData'),
    Prop({
        default() {
            return (data) => data;
        },
    })
], PaginationTablevue_type_script_lang_ts_PaginationTable.prototype, "recordData", void 0);
__decorate([
    Prop({ type: Number })
], PaginationTablevue_type_script_lang_ts_PaginationTable.prototype, "actionsWidth", void 0);
PaginationTablevue_type_script_lang_ts_PaginationTable = __decorate([
    vue_class_component_esm({
        components: {
            Table: table_Table,
            PaginationControls: PaginationControls,
        },
    })
], PaginationTablevue_type_script_lang_ts_PaginationTable);
/* harmony default export */ var PaginationTablevue_type_script_lang_ts_ = (PaginationTablevue_type_script_lang_ts_PaginationTable);

// CONCATENATED MODULE: ./src/pagination/PaginationTable/PaginationTable.vue?vue&type=script&lang=ts&
 /* harmony default export */ var PaginationTable_PaginationTablevue_type_script_lang_ts_ = (PaginationTablevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/pagination/PaginationTable/PaginationTable.vue?vue&type=style&index=0&id=723d9fa0&lang=scss&scoped=true&
var PaginationTablevue_type_style_index_0_id_723d9fa0_lang_scss_scoped_true_ = __webpack_require__("04e2");

// CONCATENATED MODULE: ./src/pagination/PaginationTable/PaginationTable.vue






/* normalize component */

var PaginationTable_component = normalizeComponent(
  PaginationTable_PaginationTablevue_type_script_lang_ts_,
  PaginationTablevue_type_template_id_723d9fa0_scoped_true_render,
  PaginationTablevue_type_template_id_723d9fa0_scoped_true_staticRenderFns,
  false,
  null,
  "723d9fa0",
  null
  
)

/* harmony default export */ var PaginationTable_PaginationTable = (PaginationTable_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/form/Form/Form.vue?vue&type=template&id=56f026f3&
var Formvue_type_template_id_56f026f3_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_vm._t("default")],2)}
var Formvue_type_template_id_56f026f3_staticRenderFns = []


// CONCATENATED MODULE: ./src/form/Form/Form.vue?vue&type=template&id=56f026f3&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/form/Form/Form.vue?vue&type=script&lang=ts&





let Formvue_type_script_lang_ts_OtForm = class OtForm extends external_vue_default.a {
    constructor() {
        super(...arguments);
        this.inFormCollapse = false;
    }
    async submit() {
        try {
            await this.form.submit();
            this.$emit('success');
        }
        catch (e) {
            this.$emit('error', e);
        }
    }
};
__decorate([
    Provide('inFormCollapse')
], Formvue_type_script_lang_ts_OtForm.prototype, "inFormCollapse", void 0);
__decorate([
    ProvideReactive('form'),
    Prop()
], Formvue_type_script_lang_ts_OtForm.prototype, "form", void 0);
Formvue_type_script_lang_ts_OtForm = __decorate([
    vue_class_component_esm({})
], Formvue_type_script_lang_ts_OtForm);
/* harmony default export */ var Formvue_type_script_lang_ts_ = (Formvue_type_script_lang_ts_OtForm);

// CONCATENATED MODULE: ./src/form/Form/Form.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Form_Formvue_type_script_lang_ts_ = (Formvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/form/Form/Form.vue





/* normalize component */

var Form_component = normalizeComponent(
  Form_Formvue_type_script_lang_ts_,
  Formvue_type_template_id_56f026f3_render,
  Formvue_type_template_id_56f026f3_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Form = (Form_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/form/FormCollapse.vue?vue&type=template&id=0c9735e5&scoped=true&
var FormCollapsevue_type_template_id_0c9735e5_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-collapse",class:{ open: _vm.open, disabled: _vm.disabled }},[_c('div',{staticClass:"form-collapse__header",on:{"click":function($event){_vm.open = !_vm.open}}},[_c('div',{staticClass:"header__content"},[_c('strong',{staticClass:"header__title ot-text-intro-strong"},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.optional)?_c('span',{staticClass:"ot-input-label--optional"},[_vm._v(" Optional ")]):_vm._e()]),_c('p',{staticClass:"header__text"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])]),_c('div',{staticClass:"header__actions"},[_c('button',{staticClass:"ot-button is-tiny is-dark",attrs:{"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.buttonTitle)+" "),_c('i',{staticClass:"oti ot-button-icon--right",class:_vm.buttonIcon})])])]),(!_vm.disabled)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.open),expression:"open"}],staticClass:"form-collapse__content"},[_vm._t("default")],2):_vm._e()])}
var FormCollapsevue_type_template_id_0c9735e5_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/form/FormCollapse.vue?vue&type=template&id=0c9735e5&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/form/FormCollapse.vue?vue&type=script&lang=ts&




let FormCollapsevue_type_script_lang_ts_OtFormCollapse = class OtFormCollapse extends external_vue_default.a {
    constructor() {
        super(...arguments);
        this.inFormCollapse = true;
        this.open = false;
    }
    mounted() {
        this.open = this.defaultOpen;
    }
    /**
     *
     *  Used to get the title and icon of the
     *  button, based on the open state.
     *
     *  @todo Translate and replace with carrot
     *  up and down icons when added?
     *
     */
    get buttonTitle() {
        return this.open ? 'Close' : 'Open';
    }
    get buttonIcon() {
        return this.open ? 'oti-drop-up' : 'oti-drop-down';
    }
};
__decorate([
    Provide('inFormCollapse')
], FormCollapsevue_type_script_lang_ts_OtFormCollapse.prototype, "inFormCollapse", void 0);
__decorate([
    Prop({ type: String, required: true })
], FormCollapsevue_type_script_lang_ts_OtFormCollapse.prototype, "title", void 0);
__decorate([
    Prop({ type: String })
], FormCollapsevue_type_script_lang_ts_OtFormCollapse.prototype, "subtitle", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], FormCollapsevue_type_script_lang_ts_OtFormCollapse.prototype, "optional", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], FormCollapsevue_type_script_lang_ts_OtFormCollapse.prototype, "disabled", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], FormCollapsevue_type_script_lang_ts_OtFormCollapse.prototype, "defaultOpen", void 0);
FormCollapsevue_type_script_lang_ts_OtFormCollapse = __decorate([
    vue_class_component_esm
], FormCollapsevue_type_script_lang_ts_OtFormCollapse);
/* harmony default export */ var FormCollapsevue_type_script_lang_ts_ = (FormCollapsevue_type_script_lang_ts_OtFormCollapse);

// CONCATENATED MODULE: ./src/form/FormCollapse.vue?vue&type=script&lang=ts&
 /* harmony default export */ var form_FormCollapsevue_type_script_lang_ts_ = (FormCollapsevue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/form/FormCollapse.vue?vue&type=style&index=0&id=0c9735e5&lang=scss&scoped=true&
var FormCollapsevue_type_style_index_0_id_0c9735e5_lang_scss_scoped_true_ = __webpack_require__("db0e");

// CONCATENATED MODULE: ./src/form/FormCollapse.vue






/* normalize component */

var FormCollapse_component = normalizeComponent(
  form_FormCollapsevue_type_script_lang_ts_,
  FormCollapsevue_type_template_id_0c9735e5_scoped_true_render,
  FormCollapsevue_type_template_id_0c9735e5_scoped_true_staticRenderFns,
  false,
  null,
  "0c9735e5",
  null
  
)

/* harmony default export */ var FormCollapse = (FormCollapse_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/form/FormInput.vue?vue&type=template&id=e4c46fe8&
var FormInputvue_type_template_id_e4c46fe8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OtFormField',{attrs:{"label":_vm.type !== 'toggle' ? _vm.label : undefined,"error":_vm.prop && _vm.prop.errors && _vm.prop.errors[0] ? _vm.prop.errors[0].data.error : null,"description":_vm.description,"required":_vm.required,"optional":_vm.optional}},[_c(_vm.comp,_vm._b({tag:"component",staticClass:"input",attrs:{"label":_vm.type === 'toggle' ? _vm.label : undefined,"type":_vm.type,"value":_vm.inputValue},on:{"input":_vm.onInput}},'component',_vm.$attrs,false))],1)}
var FormInputvue_type_template_id_e4c46fe8_staticRenderFns = []


// CONCATENATED MODULE: ./src/form/FormInput.vue?vue&type=template&id=e4c46fe8&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/form/FormInput.vue?vue&type=script&lang=ts&





let FormInputvue_type_script_lang_ts_OtFormInput = class OtFormInput extends external_vue_default.a {
    get comp() {
        return 'OtInput';
    }
    get prop() {
        if (!this.form.props[this.name]) {
            throw new helpers["StringError"](`Prop ${this.name} not found in form`);
        }
        return this.form.props[this.name];
    }
    onInput(value) {
        this.prop.value = value;
        this.$emit('input', value);
    }
    get optional() {
        return !!this.inFormCollapse;
    }
    get required() {
        return this.prop && this.prop.rules && this.prop.rules.includes('required');
    }
    get inputValue() {
        return this.prop.value;
    }
};
__decorate([
    Prop()
], FormInputvue_type_script_lang_ts_OtFormInput.prototype, "type", void 0);
__decorate([
    Prop()
], FormInputvue_type_script_lang_ts_OtFormInput.prototype, "label", void 0);
__decorate([
    Prop()
], FormInputvue_type_script_lang_ts_OtFormInput.prototype, "description", void 0);
__decorate([
    Prop()
], FormInputvue_type_script_lang_ts_OtFormInput.prototype, "name", void 0);
__decorate([
    InjectReactive('form')
], FormInputvue_type_script_lang_ts_OtFormInput.prototype, "form", void 0);
__decorate([
    Inject('inFormCollapse')
], FormInputvue_type_script_lang_ts_OtFormInput.prototype, "inFormCollapse", void 0);
FormInputvue_type_script_lang_ts_OtFormInput = __decorate([
    vue_class_component_esm
], FormInputvue_type_script_lang_ts_OtFormInput);
/* harmony default export */ var FormInputvue_type_script_lang_ts_ = (FormInputvue_type_script_lang_ts_OtFormInput);

// CONCATENATED MODULE: ./src/form/FormInput.vue?vue&type=script&lang=ts&
 /* harmony default export */ var form_FormInputvue_type_script_lang_ts_ = (FormInputvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/form/FormInput.vue





/* normalize component */

var FormInput_component = normalizeComponent(
  form_FormInputvue_type_script_lang_ts_,
  FormInputvue_type_template_id_e4c46fe8_render,
  FormInputvue_type_template_id_e4c46fe8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FormInput = (FormInput_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/form/FormRow.vue?vue&type=template&id=99c8670e&scoped=true&
var FormRowvue_type_template_id_99c8670e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row"},[_vm._t("default")],2)}
var FormRowvue_type_template_id_99c8670e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/form/FormRow.vue?vue&type=template&id=99c8670e&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/form/FormRow.vue?vue&type=script&lang=ts&



let FormRowvue_type_script_lang_ts_OtFormRow = class OtFormRow extends external_vue_default.a {
};
FormRowvue_type_script_lang_ts_OtFormRow = __decorate([
    vue_class_component_esm
], FormRowvue_type_script_lang_ts_OtFormRow);
/* harmony default export */ var FormRowvue_type_script_lang_ts_ = (FormRowvue_type_script_lang_ts_OtFormRow);

// CONCATENATED MODULE: ./src/form/FormRow.vue?vue&type=script&lang=ts&
 /* harmony default export */ var form_FormRowvue_type_script_lang_ts_ = (FormRowvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/form/FormRow.vue?vue&type=style&index=0&id=99c8670e&lang=scss&scoped=true&
var FormRowvue_type_style_index_0_id_99c8670e_lang_scss_scoped_true_ = __webpack_require__("1445");

// CONCATENATED MODULE: ./src/form/FormRow.vue






/* normalize component */

var FormRow_component = normalizeComponent(
  form_FormRowvue_type_script_lang_ts_,
  FormRowvue_type_template_id_99c8670e_scoped_true_render,
  FormRowvue_type_template_id_99c8670e_scoped_true_staticRenderFns,
  false,
  null,
  "99c8670e",
  null
  
)

/* harmony default export */ var FormRow = (FormRow_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/form/FormField.vue?vue&type=template&id=18c55068&scoped=true&
var FormFieldvue_type_template_id_18c55068_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ot-input-field"},[(_vm.label)?_c('label',{staticClass:"ot-input-label",attrs:{"for":_vm.forLabel}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.optional)?_c('span',{staticClass:"ot-input-label--optional"},[_vm._v("Optional")]):(_vm.required)?_c('span',{staticClass:"ot-input-label--required"},[_vm._v("*")]):_vm._e()]):_vm._e(),(_vm.description)?_c('label',{staticClass:"ot-input-sublabel",attrs:{"for":_vm.forLabel},domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),_c('div',{staticClass:"ot-input-field__content"},[_vm._t("default")],2),_vm._t("errors",function(){return [_c('OtFormError',{attrs:{"error":_vm.error}})]})],2)}
var FormFieldvue_type_template_id_18c55068_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/form/FormField.vue?vue&type=template&id=18c55068&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/form/FormField.vue?vue&type=script&lang=ts&




let FormFieldvue_type_script_lang_ts_OtInputField = class OtInputField extends external_vue_default.a {
    get forLabel() {
        // Needed due to 'for' being a reserved keyword
        return this.for;
    }
};
__decorate([
    Prop()
], FormFieldvue_type_script_lang_ts_OtInputField.prototype, "for", void 0);
__decorate([
    Prop()
], FormFieldvue_type_script_lang_ts_OtInputField.prototype, "label", void 0);
__decorate([
    Prop()
], FormFieldvue_type_script_lang_ts_OtInputField.prototype, "description", void 0);
__decorate([
    Prop({ type: Boolean })
], FormFieldvue_type_script_lang_ts_OtInputField.prototype, "optional", void 0);
__decorate([
    Prop({ type: Boolean })
], FormFieldvue_type_script_lang_ts_OtInputField.prototype, "required", void 0);
__decorate([
    Prop()
], FormFieldvue_type_script_lang_ts_OtInputField.prototype, "error", void 0);
FormFieldvue_type_script_lang_ts_OtInputField = __decorate([
    vue_class_component_esm
], FormFieldvue_type_script_lang_ts_OtInputField);
/* harmony default export */ var FormFieldvue_type_script_lang_ts_ = (FormFieldvue_type_script_lang_ts_OtInputField);

// CONCATENATED MODULE: ./src/form/FormField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var form_FormFieldvue_type_script_lang_ts_ = (FormFieldvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/form/FormField.vue?vue&type=style&index=0&id=18c55068&lang=scss&scoped=true&
var FormFieldvue_type_style_index_0_id_18c55068_lang_scss_scoped_true_ = __webpack_require__("f2a9");

// CONCATENATED MODULE: ./src/form/FormField.vue






/* normalize component */

var FormField_component = normalizeComponent(
  form_FormFieldvue_type_script_lang_ts_,
  FormFieldvue_type_template_id_18c55068_scoped_true_render,
  FormFieldvue_type_template_id_18c55068_scoped_true_staticRenderFns,
  false,
  null,
  "18c55068",
  null
  
)

/* harmony default export */ var FormField = (FormField_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/form/FormError.vue?vue&type=template&id=668b06d4&scoped=true&
var FormErrorvue_type_template_id_668b06d4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.internalError)?_c('label',{staticClass:"ot-input-error"},[_c('i',{staticClass:"oti oti-alert is-small"}),_vm._v(" "+_vm._s(_vm.internalError)+" ")]):_vm._e()}
var FormErrorvue_type_template_id_668b06d4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/form/FormError.vue?vue&type=template&id=668b06d4&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/form/FormError.vue?vue&type=script&lang=ts&




let FormErrorvue_type_script_lang_ts_OtFormError = class OtFormError extends external_vue_default.a {
    constructor() {
        super(...arguments);
        this.prop = null;
        this.internalError = "";
    }
    created() {
        if (this.name && this.form && this.form.props[this.name]) {
            this.prop = this.form.props[this.name];
        }
    }
    onErrorChanged() {
        this.internalError = this.error;
    }
    onPropErrorsChanged() {
        const prop = this.prop;
        if (prop && prop.errors[0] && prop.errors[0].data) {
            this.internalError = prop.errors[0].data.error;
        }
        else {
            this.internalError = "";
        }
    }
};
__decorate([
    Prop()
], FormErrorvue_type_script_lang_ts_OtFormError.prototype, "error", void 0);
__decorate([
    Prop()
], FormErrorvue_type_script_lang_ts_OtFormError.prototype, "name", void 0);
__decorate([
    Inject('form')
], FormErrorvue_type_script_lang_ts_OtFormError.prototype, "form", void 0);
__decorate([
    Watch('error')
], FormErrorvue_type_script_lang_ts_OtFormError.prototype, "onErrorChanged", null);
__decorate([
    Watch('prop.errors')
], FormErrorvue_type_script_lang_ts_OtFormError.prototype, "onPropErrorsChanged", null);
FormErrorvue_type_script_lang_ts_OtFormError = __decorate([
    vue_class_component_esm
], FormErrorvue_type_script_lang_ts_OtFormError);
/* harmony default export */ var FormErrorvue_type_script_lang_ts_ = (FormErrorvue_type_script_lang_ts_OtFormError);

// CONCATENATED MODULE: ./src/form/FormError.vue?vue&type=script&lang=ts&
 /* harmony default export */ var form_FormErrorvue_type_script_lang_ts_ = (FormErrorvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/form/FormError.vue?vue&type=style&index=0&id=668b06d4&lang=scss&scoped=true&
var FormErrorvue_type_style_index_0_id_668b06d4_lang_scss_scoped_true_ = __webpack_require__("d395");

// CONCATENATED MODULE: ./src/form/FormError.vue






/* normalize component */

var FormError_component = normalizeComponent(
  form_FormErrorvue_type_script_lang_ts_,
  FormErrorvue_type_template_id_668b06d4_scoped_true_render,
  FormErrorvue_type_template_id_668b06d4_scoped_true_staticRenderFns,
  false,
  null,
  "668b06d4",
  null
  
)

/* harmony default export */ var FormError = (FormError_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/crud/CrudSorter/CrudSorter.vue?vue&type=template&id=7a14db59&scoped=true&
var CrudSortervue_type_template_id_7a14db59_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-sort"},[_c('div',{staticClass:"form-sort__trigger",on:{"click":function($event){return _vm.modal.open()}}},[_vm._t("trigger",function(){return [_c('button',{staticClass:"ot-button is-small is-dark"},[_vm._v(" Sort "+_vm._s(_vm.relation.type)+" "),_c('i',{staticClass:"ot-button-icon--right oti oti-menu is-small"})])]})],2),_c('OtInlineModal',{ref:"modal",attrs:{"width":"400"}},[[_c('div',{staticClass:"form-sort__wrapper"},[_c('div',{staticClass:"form-sort__content"},[_c('h3',{staticClass:"has-margin"},[_vm._v("Sort "+_vm._s(_vm.relation.type))]),_c('OtLazyList',{attrs:{"list":_vm.list}},[_c('div',{staticClass:"form-sort__list"},[_c('SlickList',{attrs:{"lockAxis":"y","lockToContainerEdges":true},on:{"sort-end":_vm.sortEnd},model:{value:(_vm.list.data),callback:function ($$v) {_vm.$set(_vm.list, "data", $$v)},expression:"list.data"}},_vm._l((_vm.list.data),function(item,index){return _c('SlickItem',{key:item.guid,staticClass:"form-sort__item",attrs:{"index":index}},[_c('div',{staticClass:"form-sort__item__info"},[_vm._t("item",function(){return [_vm._v(" "+_vm._s(item.guid)+" ")]},null,item)],2),_c('i',{staticClass:"oti oti-menu"})])}),1)],1)])],1),_c('div',{staticClass:"form-sort__footer"},[_c('button',{staticClass:"ot-button is-dark is-tiny",on:{"click":_vm.cancel}},[_vm._v(" Cancel ")]),_c('button',{staticClass:"ot-button is-tiny",attrs:{"disabled":!_vm.hasLocalChanges || _vm.loading},on:{"click":_vm.save}},[_vm._v(" Save & Close ")])])])]],2)],1)}
var CrudSortervue_type_template_id_7a14db59_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/crud/CrudSorter/CrudSorter.vue?vue&type=template&id=7a14db59&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-slicksort/dist/vue-slicksort.umd.js
var vue_slicksort_umd = __webpack_require__("11b0");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/crud/CrudSorter/CrudSorter.vue?vue&type=script&lang=ts&






let CrudSortervue_type_script_lang_ts_OtCrudSorter = class OtCrudSorter extends external_vue_default.a {
    constructor() {
        super(...arguments);
        this.hasLocalChanges = false;
        this.loading = false;
    }
    created() {
        this.sorter = new helpers["Sorter"](this.relation);
        this.list = new helpers["LazyList"](this.relation, this.sorter.getPage);
        external_vue_default.a.observable(this.sorter);
        external_vue_default.a.observable(this.list);
        void this.list.init({
            defaults: {
                per_page: 5,
            },
        });
    }
    sortEnd(data) {
        this.sorter.move(data.oldIndex, data.newIndex);
        this.updateHasLocalChanges();
    }
    cancel() {
        void this.modal.close();
    }
    async save() {
        try {
            this.loading = true;
            await this.sorter.save();
            this.hasLocalChanges = false;
            void this.modal.close();
            this.$emit('success');
        }
        catch (e) {
            this.$emit('error', e);
        }
        finally {
            this.loading = true;
        }
    }
    updateHasLocalChanges() {
        this.hasLocalChanges = this.sorter.hasLocalChanges();
    }
};
__decorate([
    Prop()
], CrudSortervue_type_script_lang_ts_OtCrudSorter.prototype, "relation", void 0);
__decorate([
    Ref('modal')
], CrudSortervue_type_script_lang_ts_OtCrudSorter.prototype, "modal", void 0);
__decorate([
    Ref('container')
], CrudSortervue_type_script_lang_ts_OtCrudSorter.prototype, "container", void 0);
CrudSortervue_type_script_lang_ts_OtCrudSorter = __decorate([
    vue_class_component_esm({
        components: {
            SlickList: vue_slicksort_umd["SlickList"],
            SlickItem: vue_slicksort_umd["SlickItem"],
        },
    })
], CrudSortervue_type_script_lang_ts_OtCrudSorter);
/* harmony default export */ var CrudSortervue_type_script_lang_ts_ = (CrudSortervue_type_script_lang_ts_OtCrudSorter);

// CONCATENATED MODULE: ./src/crud/CrudSorter/CrudSorter.vue?vue&type=script&lang=ts&
 /* harmony default export */ var CrudSorter_CrudSortervue_type_script_lang_ts_ = (CrudSortervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/crud/CrudSorter/CrudSorter.vue?vue&type=style&index=0&id=7a14db59&lang=scss&scoped=true&
var CrudSortervue_type_style_index_0_id_7a14db59_lang_scss_scoped_true_ = __webpack_require__("0872");

// CONCATENATED MODULE: ./src/crud/CrudSorter/CrudSorter.vue






/* normalize component */

var CrudSorter_component = normalizeComponent(
  CrudSorter_CrudSortervue_type_script_lang_ts_,
  CrudSortervue_type_template_id_7a14db59_scoped_true_render,
  CrudSortervue_type_template_id_7a14db59_scoped_true_staticRenderFns,
  false,
  null,
  "7a14db59",
  null
  
)

/* harmony default export */ var CrudSorter = (CrudSorter_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/crud/CrudSelect/CrudSelect.vue?vue&type=template&id=c808982e&scoped=true&
var CrudSelectvue_type_template_id_c808982e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crud-select"},[_c('OtDropdown',{ref:"select_dropdown",attrs:{"fill":true},scopedSlots:_vm._u([{key:"trigger",fn:function(ref){
var opened = ref.opened;
return [_vm._t("trigger",function(){return [_c('div',{staticClass:"crud-select__trigger"},[_c('div',{staticClass:"ot-select",class:{
                            'ot-highlight': opened,
                        }},[_vm._t("triggerText",function(){return [_vm._v(" Select ")]},null,{ item: _vm.value })],2)])]})]}},{key:"content",fn:function(){return [(!_vm.form)?_c('div',{staticClass:"crud-select__content"},[_c('div',{staticClass:"crud-select__filters"},[_c('OtInput',{attrs:{"type":"search","placeholder":"Search"},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}}),(_vm.canCreate)?_c('button',{staticClass:"ot-button is-tiny is-success",on:{"click":function($event){return _vm.newForm()}}},[_vm._v("New")]):_vm._e()],1),_c('OtLazyList',{attrs:{"list":_vm.list}},[_c('div',{staticClass:"crud-select__list"},_vm._l((_vm.list.data),function(model){return _c('div',{key:model.guid,staticClass:"crud-select__list__item",class:{ selected: _vm.value === model },on:{"click":function($event){return _vm.select(model)}}},[_c('div',{staticClass:"crud-select__list__item__content"},[_vm._t("item",function(){return [_vm._v(" "+_vm._s(model.guid)+" ")]},null,model)],2),(_vm.canEdit)?_c('div',{staticClass:"crud-select__list__item__action",on:{"click":function (e) { return _vm.editForm(e, model); }}},[_c('i',{staticClass:"oti oti-edit is-small"})]):_vm._e()])}),0)])],1):_c('div',{staticClass:"crud-select__form"},[_vm._t("form",null,null,{ form: _vm.form, save: _vm.saveForm, cancel: _vm.closeForm })],2)]},proxy:true}],null,true)})],1)}
var CrudSelectvue_type_template_id_c808982e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/crud/CrudSelect/CrudSelect.vue?vue&type=template&id=c808982e&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/crud/CrudSelect/CrudSelect.vue?vue&type=script&lang=ts&







let CrudSelectvue_type_script_lang_ts_OtCrudSelect = class OtCrudSelect extends external_vue_default.a {
    constructor() {
        super(...arguments);
        this.searchValue = '';
        this.model = null;
        this.form = null;
    }
    get canCreate() {
        return (this.relation.mixins
            && this.relation.mixins.includes(helpers["CrudRoute"].Create.mixin));
    }
    get canEdit() {
        return (this.relation.mixins
            && this.relation.mixins.includes(helpers["CrudRoute"].Update.mixin));
    }
    created() {
        this.list = new helpers["LazyList"](this.relation);
        external_vue_default.a.observable(this.list);
        void this.list.init({
            defaults: {
                per_page: 10,
            },
        });
    }
    select(model) {
        this.$emit('input', model);
        this.selectDropdown.close();
    }
    newForm() {
        const model = external_vue_default.a.observable(this.relation.new());
        this.model = model;
        this.form = external_vue_default.a.observable(new helpers["ModelForm"](this.relation, model));
    }
    editForm(e, model) {
        e.stopPropagation();
        this.model = model;
        this.form = new helpers["ModelForm"](this.relation, this.model);
    }
    async saveForm() {
        try {
            await this.form.submit();
            this.select(this.model);
            this.closeForm();
            void this.list.refresh();
            this.$emit('success');
        }
        catch (e) {
            this.$emit('error', e);
        }
    }
    closeForm() {
        this.model = null;
        this.form = null;
    }
    async onSearchValue() {
        if (this.searchValue) {
            await this.list.addFilter('name', this.searchValue);
        }
        else {
            await this.list.removeFilter('name');
        }
    }
};
__decorate([
    Prop()
], CrudSelectvue_type_script_lang_ts_OtCrudSelect.prototype, "relation", void 0);
__decorate([
    Prop()
], CrudSelectvue_type_script_lang_ts_OtCrudSelect.prototype, "value", void 0);
__decorate([
    Ref('select_dropdown')
], CrudSelectvue_type_script_lang_ts_OtCrudSelect.prototype, "selectDropdown", void 0);
__decorate([
    Watch('searchValue')
], CrudSelectvue_type_script_lang_ts_OtCrudSelect.prototype, "onSearchValue", null);
CrudSelectvue_type_script_lang_ts_OtCrudSelect = __decorate([
    vue_class_component_esm({
        components: {
            OtDropdown: Dropdown,
            OtLazyList: LazyList,
        },
    })
], CrudSelectvue_type_script_lang_ts_OtCrudSelect);
/* harmony default export */ var CrudSelectvue_type_script_lang_ts_ = (CrudSelectvue_type_script_lang_ts_OtCrudSelect);

// CONCATENATED MODULE: ./src/crud/CrudSelect/CrudSelect.vue?vue&type=script&lang=ts&
 /* harmony default export */ var CrudSelect_CrudSelectvue_type_script_lang_ts_ = (CrudSelectvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/crud/CrudSelect/CrudSelect.vue?vue&type=style&index=0&id=c808982e&lang=scss&scoped=true&
var CrudSelectvue_type_style_index_0_id_c808982e_lang_scss_scoped_true_ = __webpack_require__("ffcf");

// CONCATENATED MODULE: ./src/crud/CrudSelect/CrudSelect.vue






/* normalize component */

var CrudSelect_component = normalizeComponent(
  CrudSelect_CrudSelectvue_type_script_lang_ts_,
  CrudSelectvue_type_template_id_c808982e_scoped_true_render,
  CrudSelectvue_type_template_id_c808982e_scoped_true_staticRenderFns,
  false,
  null,
  "c808982e",
  null
  
)

/* harmony default export */ var CrudSelect = (CrudSelect_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/crud/CrudMultiSelect/CrudMultiSelect.vue?vue&type=template&id=61923796&scoped=true&
var CrudMultiSelectvue_type_template_id_61923796_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crud-multi-select"},[_c('OtDropdown',{ref:"select_dropdown",attrs:{"fill":true},scopedSlots:_vm._u([{key:"trigger",fn:function(ref){
var opened = ref.opened;
return [_vm._t("trigger",function(){return [_c('div',{staticClass:"crud-multi-select__trigger"},[_c('div',{staticClass:"ot-select",class:{
                            'ot-highlight': opened,
                        }},[_vm._t("triggerText",function(){return [_vm._v(" Select ")]})],2)])]})]}},{key:"content",fn:function(){return [_c('div',{staticClass:"crud-multi-select__content"},[_c('div',{staticClass:"crud-multi-select__filters"},[_c('OtInput',{attrs:{"type":"search","placeholder":"Search"},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}})],1),_c('OtLazyList',{attrs:{"list":_vm.list}},[_c('div',{staticClass:"crud-multi-select__list"},_vm._l((_vm.list.data),function(model){return _c('div',{key:model.guid,staticClass:"crud-multi-select__list__item",class:{ selected: _vm.value === model },on:{"click":function($event){return _vm.select(model)}}},[_c('div',{staticClass:"crud-multi-select__list__item__check"},[_c('OtInput',{attrs:{"type":"checkbox","value":_vm.value && _vm.value.includes(model)}})],1),_c('div',{staticClass:"\n                                    crud-multi-select__list__item__content\n                                "},[_vm._t("item",function(){return [_vm._v(" "+_vm._s(model.guid)+" ")]},null,model)],2)])}),0)])],1)]},proxy:true}],null,true)})],1)}
var CrudMultiSelectvue_type_template_id_61923796_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/crud/CrudMultiSelect/CrudMultiSelect.vue?vue&type=template&id=61923796&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/crud/CrudMultiSelect/CrudMultiSelect.vue?vue&type=script&lang=ts&







let CrudMultiSelectvue_type_script_lang_ts_OtCrudSelect = class OtCrudSelect extends external_vue_default.a {
    constructor() {
        super(...arguments);
        this.searchValue = "";
    }
    created() {
        this.list = new helpers["LazyList"](this.relation);
        external_vue_default.a.observable(this.list);
        void this.list.init({
            defaults: {
                per_page: 10,
            },
        });
    }
    select(model) {
        const index = this.value ? this.value.indexOf(model) : -1;
        let newValue;
        if (index > -1) {
            newValue = Array.from(this.value);
            newValue.splice(index, 1);
        }
        else {
            newValue = Array.from(this.value || []);
            newValue.push(model);
        }
        this.$emit("input", newValue);
    }
    async onSearchValue() {
        if (this.searchValue) {
            await this.list.addFilter("name", this.searchValue);
        }
        else {
            await this.list.removeFilter("name");
        }
    }
};
__decorate([
    Prop()
], CrudMultiSelectvue_type_script_lang_ts_OtCrudSelect.prototype, "relation", void 0);
__decorate([
    Prop()
], CrudMultiSelectvue_type_script_lang_ts_OtCrudSelect.prototype, "value", void 0);
__decorate([
    Ref("select_dropdown")
], CrudMultiSelectvue_type_script_lang_ts_OtCrudSelect.prototype, "selectDropdown", void 0);
__decorate([
    Watch("searchValue")
], CrudMultiSelectvue_type_script_lang_ts_OtCrudSelect.prototype, "onSearchValue", null);
CrudMultiSelectvue_type_script_lang_ts_OtCrudSelect = __decorate([
    vue_class_component_esm({
        components: {
            OtDropdown: Dropdown,
            OtLazyList: LazyList,
        },
    })
], CrudMultiSelectvue_type_script_lang_ts_OtCrudSelect);
/* harmony default export */ var CrudMultiSelectvue_type_script_lang_ts_ = (CrudMultiSelectvue_type_script_lang_ts_OtCrudSelect);

// CONCATENATED MODULE: ./src/crud/CrudMultiSelect/CrudMultiSelect.vue?vue&type=script&lang=ts&
 /* harmony default export */ var CrudMultiSelect_CrudMultiSelectvue_type_script_lang_ts_ = (CrudMultiSelectvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/crud/CrudMultiSelect/CrudMultiSelect.vue?vue&type=style&index=0&id=61923796&lang=scss&scoped=true&
var CrudMultiSelectvue_type_style_index_0_id_61923796_lang_scss_scoped_true_ = __webpack_require__("e239");

// CONCATENATED MODULE: ./src/crud/CrudMultiSelect/CrudMultiSelect.vue






/* normalize component */

var CrudMultiSelect_component = normalizeComponent(
  CrudMultiSelect_CrudMultiSelectvue_type_script_lang_ts_,
  CrudMultiSelectvue_type_template_id_61923796_scoped_true_render,
  CrudMultiSelectvue_type_template_id_61923796_scoped_true_staticRenderFns,
  false,
  null,
  "61923796",
  null
  
)

/* harmony default export */ var CrudMultiSelect = (CrudMultiSelect_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/crud/CrudPicker/CrudPicker.vue?vue&type=template&id=188cf208&scoped=true&
var CrudPickervue_type_template_id_188cf208_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-picker"},[_c('OtDropdown',{ref:"select_dropdown",attrs:{"fill":true},scopedSlots:_vm._u([{key:"trigger",fn:function(ref){
var opened = ref.opened;
return [_vm._t("trigger",function(){return [_c('div',{staticClass:"form-picker__trigger"},[_c('div',{staticClass:"ot-select",class:{
                            'ot-highlight': opened,
                        }},[_vm._t("triggerText",function(){return [_vm._v(" "+_vm._s(!_vm.picker.count ? 'Select' : ((_vm.picker.count) + " selected"))+" ")]},{"count":_vm.picker.count})],2)])]},{"count":_vm.picker.count})]}},{key:"content",fn:function(){return [(!_vm.form)?_c('div',{staticClass:"form-picker__content"},[_c('div',{staticClass:"form-picker__filters"},[_c('OtInput',{attrs:{"type":"search","placeholder":"Search metadata"},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}}),(_vm.canCreate)?_c('button',{staticClass:"ot-button is-tiny is-success",on:{"click":_vm.openForm}},[_vm._v(" New ")]):_vm._e(),_c('button',{staticClass:"ot-button is-tiny",attrs:{"disabled":!_vm.picker.hasLocalChanges},on:{"click":_vm.save}},[_vm._v(" Save ")])],1),_c('OtLazyList',{attrs:{"list":_vm.list}},[_c('div',{key:_vm.nonce,staticClass:"form-picker__list"},_vm._l((_vm.list.data),function(model){return _c('div',{key:model.guid,staticClass:"form-picker__list__item",on:{"click":function (e) { return _vm.toggleModel(e, model); }}},[_c('div',{staticClass:"form-picker__list__item__check"},[_c('OtInput',{attrs:{"type":"checkbox","value":_vm.picker.linked[model.guid]}})],1),_c('div',{staticClass:"form-picker__list__item__content"},[_vm._t("item",function(){return [_vm._v(" "+_vm._s(model.guid)+" ")]},null,model)],2),(_vm.canUpdate)?_c('div',{staticClass:"form-picker__list__item__action",on:{"click":function (e) { return _vm.openForm(model, e); }}},[_c('i',{staticClass:"oti oti-edit is-small"})]):_vm._e()])}),0)])],1):_c('div',{staticClass:"form-picker__form"},[_vm._t("form",null,{"form":_vm.form,"save":_vm.saveForm,"cancel":_vm.closeForm})],2)]},proxy:true}],null,true)}),(_vm.canSort)?_c('OtCrudSorter',{attrs:{"relation":_vm.relation},scopedSlots:_vm._u([{key:"item",fn:function(item){return [_vm._t("item",function(){return [_vm._v(" "+_vm._s(item.guid)+" ")]},null,item)]}},{key:"trigger",fn:function(){return [_c('div',{staticClass:"form-picker__actions"},[_c('div',{staticClass:"form-picker__sort__trigger"},[_c('button',{staticClass:"ot-button is-dark is-tiny",attrs:{"disabled":_vm.picker.hasLocalChanges}},[_vm._v(" Sort "+_vm._s(_vm.relation.type)+" "),_c('i',{staticClass:"\n                                ot-button-icon--right\n                                oti oti-menu\n                                is-small\n                            "})])])])]},proxy:true}],null,true)}):_vm._e()],1)}
var CrudPickervue_type_template_id_188cf208_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/crud/CrudPicker/CrudPicker.vue?vue&type=template&id=188cf208&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/crud/CrudPicker/CrudPicker.vue?vue&type=script&lang=ts&





let CrudPickervue_type_script_lang_ts_OtCrudPicker = class OtCrudPicker extends external_vue_default.a {
    constructor() {
        super(...arguments);
        this.searchValue = '';
        this.nonce = 0;
        this.saveLoading = false;
        this.model = null;
        this.form = null;
    }
    get canCreate() {
        return (this.relation.mixins
            && this.relation.mixins.includes(helpers["CrudRoute"].Create.mixin));
    }
    get canUpdate() {
        return (this.relation.mixins
            && this.relation.mixins.includes(helpers["CrudRoute"].Update.mixin));
    }
    get canSort() {
        return (this.relation.mixins
            && this.relation.mixins.includes(helpers["CrudRoute"].Sort.mixin));
    }
    created() {
        this.picker = new helpers["Picker"](this.relation);
        this.list = new helpers["LazyList"](this.picker.getPickerPage);
        external_vue_default.a.observable(this.picker);
        external_vue_default.a.observable(this.list);
        void this.list.init({
            defaults: {
                per_page: 10,
            },
        });
    }
    get hasLocalChanges() {
        return this.picker.hasLocalChanges;
    }
    async save() {
        if (!this.picker.hasLocalChanges) {
            return;
        }
        this.saveLoading = true;
        try {
            await this.picker.save();
            this.nonce++;
            this.selectDropdown.close();
            this.$emit('success');
        }
        catch (e) {
            this.$emit('error', e);
            throw e;
        }
        finally {
            this.saveLoading = false;
        }
    }
    toggleModel(e, model) {
        e.preventDefault();
        if (this.picker.linked[model.guid]) {
            this.picker.unlink(model);
        }
        else {
            this.picker.link(model);
        }
        // Enforce rerender, since Vue's reactivity doesn't support object key updates
        this.nonce++;
        this.$emit('input');
    }
    openForm(model, event) {
        if (event) {
            event.stopPropagation();
        }
        if (!model) {
            model = external_vue_default.a.observable(this.relation.new());
        }
        this.model = model;
        this.form = external_vue_default.a.observable(new helpers["ModelForm"](this.relation, model));
    }
    async saveForm() {
        try {
            await this.form.submit();
            this.closeForm();
            void this.list.refresh();
            this.$emit('success');
        }
        catch (e) {
            this.$emit('error', e);
        }
    }
    closeForm() {
        this.model = null;
        this.form = null;
    }
    async onNewModel() {
        // Check if model editor is closed
        if (!this.model) {
            return;
        }
        await this.list.refresh();
    }
    async onSearchValue() {
        if (this.searchValue) {
            await this.list.addFilter('name', this.searchValue);
        }
        else {
            await this.list.removeFilter('name');
        }
    }
};
__decorate([
    Prop()
], CrudPickervue_type_script_lang_ts_OtCrudPicker.prototype, "relation", void 0);
__decorate([
    Ref('select_dropdown')
], CrudPickervue_type_script_lang_ts_OtCrudPicker.prototype, "selectDropdown", void 0);
__decorate([
    Ref('modal')
], CrudPickervue_type_script_lang_ts_OtCrudPicker.prototype, "modal", void 0);
__decorate([
    Watch('model.isNew')
], CrudPickervue_type_script_lang_ts_OtCrudPicker.prototype, "onNewModel", null);
__decorate([
    Watch('searchValue')
], CrudPickervue_type_script_lang_ts_OtCrudPicker.prototype, "onSearchValue", null);
CrudPickervue_type_script_lang_ts_OtCrudPicker = __decorate([
    vue_class_component_esm
], CrudPickervue_type_script_lang_ts_OtCrudPicker);
/* harmony default export */ var CrudPickervue_type_script_lang_ts_ = (CrudPickervue_type_script_lang_ts_OtCrudPicker);

// CONCATENATED MODULE: ./src/crud/CrudPicker/CrudPicker.vue?vue&type=script&lang=ts&
 /* harmony default export */ var CrudPicker_CrudPickervue_type_script_lang_ts_ = (CrudPickervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/crud/CrudPicker/CrudPicker.vue?vue&type=style&index=0&id=188cf208&lang=scss&scoped=true&
var CrudPickervue_type_style_index_0_id_188cf208_lang_scss_scoped_true_ = __webpack_require__("0a80");

// CONCATENATED MODULE: ./src/crud/CrudPicker/CrudPicker.vue






/* normalize component */

var CrudPicker_component = normalizeComponent(
  CrudPicker_CrudPickervue_type_script_lang_ts_,
  CrudPickervue_type_template_id_188cf208_scoped_true_render,
  CrudPickervue_type_template_id_188cf208_scoped_true_staticRenderFns,
  false,
  null,
  "188cf208",
  null
  
)

/* harmony default export */ var CrudPicker = (CrudPicker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/crud/CrudNestedPicker/CrudNestedPicker.vue?vue&type=template&id=533652ab&scoped=true&
var CrudNestedPickervue_type_template_id_533652ab_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crud-nested-picker"},[_c('OtDropdown',{ref:"dropdown",attrs:{"fill":_vm.fill},scopedSlots:_vm._u([{key:"trigger",fn:function(ref){
var opened = ref.opened;
return [_vm._t("trigger",function(){return [_c('div',{staticClass:"crud-nested-picker__trigger"},[_c('div',{staticClass:"ot-select",class:{
                            'ot-highlight': opened,
                        }},[_vm._t("triggerText",function(){return [_vm._v(" Select ")]})],2)])]})]}},{key:"content",fn:function(){return [_c('div',{staticClass:"crud-nested-picker__content"},[(!_vm.sumsModel)?_c('div',{staticClass:"crud-nested-picker__level-one"},[_c('div',{staticClass:"crud-nested-picker__header"},[_c('OtInput',{attrs:{"type":"search","placeholder":"Search"},model:{value:(_vm.searchValueSums),callback:function ($$v) {_vm.searchValueSums=$$v},expression:"searchValueSums"}})],1),_c('div',{staticClass:"crud-nested-picker__list"},[_c('OtPagination',{attrs:{"pagination":_vm.sumsPagination},scopedSlots:_vm._u([{key:"controls",fn:function(){return [_c('OtPaginationControls',{attrs:{"pagination":_vm.sumsPagination,"disable-per-page":true}})]},proxy:true}],null,false,1778787531)},[[(_vm.sumsPagination.page)?_c('div',_vm._l((_vm.sumsPagination.page
                                            .data),function(item){return _c('div',{key:item.guid,staticClass:"crud-nested-picker__item",on:{"click":function($event){return _vm.select(item)}}},[_c('div',{staticClass:"\n                                                crud-nested-picker__item__content\n                                            "},[_vm._t("sums-item",function(){return [_vm._v(" "+_vm._s(item.guid)+" ")]},null,item)],2),(_vm.picker.count[item.guid])?_c('div',{staticClass:"\n                                                crud-nested-picker__item__count\n                                            "},[_c('i',{staticClass:"\n                                                    oti oti-check\n                                                    is-small\n                                                "}),_vm._v(" "+_vm._s(_vm.picker.count[item.guid])+" ")]):_vm._e(),_c('div',{staticClass:"\n                                                crud-nested-picker__item__action\n                                            "},[_c('i',{staticClass:"oti oti-arrow-right"})])])}),0):_vm._e()]],2)],1)]):_c('div',{staticClass:"crud-nested-picker__level-two"},[_c('div',{staticClass:"crud-nested-picker__header"},[(!_vm.lockLevelTwo)?_c('div',{staticClass:"crud-nested-picker__header__back",on:{"click":function($event){return _vm.backToSums()}}},[_c('i',{staticClass:"oti oti-arrow-left"})]):_vm._e(),_c('div',{staticClass:"crud-nested-picker__header__actions"},[_c('OtInput',{attrs:{"type":"search","placeholder":"Search"},model:{value:(_vm.searchValue),callback:function ($$v) {_vm.searchValue=$$v},expression:"searchValue"}})],1)]),_c('div',{staticClass:"crud-nested-picker__list"},[_c('OtPagination',{attrs:{"pagination":_vm.nestedPagination},scopedSlots:_vm._u([{key:"controls",fn:function(){return [_c('OtPaginationControls',{attrs:{"pagination":_vm.nestedPagination,"disable-per-page":true}})]},proxy:true}])},[[(_vm.nestedPagination.page)?_c('div',{key:_vm.toggleNonce},_vm._l((_vm.nestedPagination.page
                                            .data),function(item){return _c('div',{key:item.guid,staticClass:"crud-nested-picker__item",on:{"click":function($event){return _vm.toggle(item)}}},[_c('div',{staticClass:"\n                                                crud-nested-picker__item__content\n                                            "},[_vm._t("item",function(){return [_vm._v(" "+_vm._s(item.guid)+" ")]},null,item)],2),_c('div',{staticClass:"\n                                                crud-nested-picker__item__check\n                                            "},[_c('OtInput',{attrs:{"type":"checkbox","value":_vm.picker.linked[
                                                        _vm.sumsModel.guid
                                                    ][item.guid]}})],1)])}),0):_vm._e()]],2)],1)]),_c('div',{staticClass:"crud-nested-picker__footer"},[_c('button',{staticClass:"ot-button is-tiny is-dark",on:{"click":_vm.close}},[_vm._v(" Cancel ")]),_c('button',{staticClass:"ot-button is-tiny",attrs:{"disabled":!_vm.picker.hasLocalChanges},on:{"click":_vm.save}},[_c('i',{staticClass:"ot-button-icon--left oti oti-check is-small"}),_vm._v(" Apply ")])])])]},proxy:true}],null,true)})],1)}
var CrudNestedPickervue_type_template_id_533652ab_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/crud/CrudNestedPicker/CrudNestedPicker.vue?vue&type=template&id=533652ab&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/crud/CrudNestedPicker/CrudNestedPicker.vue?vue&type=script&lang=ts&






let CrudNestedPickervue_type_script_lang_ts_OtCrudNestedPicker = class OtCrudNestedPicker extends external_vue_default.a {
    constructor() {
        super(...arguments);
        this.searchValueSums = null;
        this.searchValue = null;
        this.sumsModel = null;
        this.toggleNonce = 0;
        this.nestedPagination = null;
    }
    /**
     *  Construct the picker and load the first level on mounted.
     */
    async created() {
        this.picker = new helpers["NestedPicker"](this.relation);
        this.sumsPagination = new helpers["Pagination"](this.picker.getSumsPage);
        external_vue_default.a.observable(this.picker);
        external_vue_default.a.observable(this.sumsPagination);
        if (this.preselectedSumsModel) {
            await this.select(this.preselectedSumsModel);
        }
        /**
         *  Only initialise the sums pagination if the user
         *  is allowed to navigate back to the first level.
         */
        if (!this.lockLevelTwo) {
            void this.sumsPagination.init({
                defaults: {
                    per_page: 5,
                },
            });
        }
    }
    async save() {
        try {
            await this.picker.save();
            this.dropdown.close();
            this.$emit('success');
        }
        catch (e) {
            this.$emit('error', e);
        }
    }
    async select(model) {
        this.nestedPagination = new helpers["Pagination"](this.picker.getNestedPage);
        external_vue_default.a.observable(this.nestedPagination);
        this.sumsModel = model;
        await this.nestedPagination.init({
            defaults: {
                per_page: 5,
                guid: model.guid,
            },
        });
    }
    toggle(model) {
        if (this.picker.linked[this.sumsModel.guid][model.guid]) {
            this.picker.unlink(this.sumsModel.guid, model);
        }
        else {
            this.picker.link(this.sumsModel.guid, model);
        }
        this.toggleNonce++;
    }
    backToSums() {
        this.nestedPagination = null;
        this.sumsModel = null;
    }
    close() {
        this.backToSums();
        this.dropdown.close();
    }
    async onSearchValueSums() {
        if (this.searchValueSums) {
            await this.sumsPagination.addFilter('name', this.searchValueSums);
        }
        else {
            await this.sumsPagination.removeFilter('name');
        }
    }
    async onSearchValue() {
        if (this.nestedPagination) {
            if (this.searchValue) {
                await this.nestedPagination.addFilter('name', this.searchValue);
            }
            else {
                await this.nestedPagination.removeFilter('name');
            }
        }
    }
};
__decorate([
    Prop({ type: Object })
], CrudNestedPickervue_type_script_lang_ts_OtCrudNestedPicker.prototype, "relation", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], CrudNestedPickervue_type_script_lang_ts_OtCrudNestedPicker.prototype, "fill", void 0);
__decorate([
    Prop({ type: Object })
], CrudNestedPickervue_type_script_lang_ts_OtCrudNestedPicker.prototype, "preselectedSumsModel", void 0);
__decorate([
    Prop({ type: Boolean })
], CrudNestedPickervue_type_script_lang_ts_OtCrudNestedPicker.prototype, "lockLevelTwo", void 0);
__decorate([
    Ref('dropdown')
], CrudNestedPickervue_type_script_lang_ts_OtCrudNestedPicker.prototype, "dropdown", void 0);
__decorate([
    Watch('searchValueSums')
], CrudNestedPickervue_type_script_lang_ts_OtCrudNestedPicker.prototype, "onSearchValueSums", null);
__decorate([
    Watch('searchValue')
], CrudNestedPickervue_type_script_lang_ts_OtCrudNestedPicker.prototype, "onSearchValue", null);
CrudNestedPickervue_type_script_lang_ts_OtCrudNestedPicker = __decorate([
    vue_class_component_esm({
        components: {
            OtDropdown: Dropdown,
        },
    })
], CrudNestedPickervue_type_script_lang_ts_OtCrudNestedPicker);
/* harmony default export */ var CrudNestedPickervue_type_script_lang_ts_ = (CrudNestedPickervue_type_script_lang_ts_OtCrudNestedPicker);

// CONCATENATED MODULE: ./src/crud/CrudNestedPicker/CrudNestedPicker.vue?vue&type=script&lang=ts&
 /* harmony default export */ var CrudNestedPicker_CrudNestedPickervue_type_script_lang_ts_ = (CrudNestedPickervue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/crud/CrudNestedPicker/CrudNestedPicker.vue?vue&type=style&index=0&id=533652ab&lang=scss&scoped=true&
var CrudNestedPickervue_type_style_index_0_id_533652ab_lang_scss_scoped_true_ = __webpack_require__("5290");

// CONCATENATED MODULE: ./src/crud/CrudNestedPicker/CrudNestedPicker.vue






/* normalize component */

var CrudNestedPicker_component = normalizeComponent(
  CrudNestedPicker_CrudNestedPickervue_type_script_lang_ts_,
  CrudNestedPickervue_type_template_id_533652ab_scoped_true_render,
  CrudNestedPickervue_type_template_id_533652ab_scoped_true_staticRenderFns,
  false,
  null,
  "533652ab",
  null
  
)

/* harmony default export */ var CrudNestedPicker = (CrudNestedPicker_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Notification.vue?vue&type=template&id=735eb4f4&
var Notificationvue_type_template_id_735eb4f4_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ot-notification",class:[_vm.type]},[_c('div',{staticClass:"ot-notification-content"},[(_vm.icon)?_c('div',{staticClass:"ot-notification-content__info-icon"},[_c('i',{staticClass:"oti",class:[_vm.icon]})]):_vm._e(),_c('div',{staticClass:"ot-notification-content__text-container"},[_c('p',{staticClass:"ot-notification-content__text"},[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('p',{staticClass:"ot-notification-content__sub-text"},[_vm._v(" "+_vm._s(_vm.description)+" ")]):_vm._e()])])])}
var Notificationvue_type_template_id_735eb4f4_staticRenderFns = []


// CONCATENATED MODULE: ./src/Notification.vue?vue&type=template&id=735eb4f4&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Notification.vue?vue&type=script&lang=ts&




let Notificationvue_type_script_lang_ts_Notification = class Notification extends external_vue_default.a {
};
__decorate([
    Prop()
], Notificationvue_type_script_lang_ts_Notification.prototype, "icon", void 0);
__decorate([
    Prop()
], Notificationvue_type_script_lang_ts_Notification.prototype, "title", void 0);
__decorate([
    Prop()
], Notificationvue_type_script_lang_ts_Notification.prototype, "description", void 0);
__decorate([
    Prop({ default: 'is-info' })
], Notificationvue_type_script_lang_ts_Notification.prototype, "type", void 0);
Notificationvue_type_script_lang_ts_Notification = __decorate([
    vue_class_component_esm
], Notificationvue_type_script_lang_ts_Notification);
/* harmony default export */ var Notificationvue_type_script_lang_ts_ = (Notificationvue_type_script_lang_ts_Notification);

// CONCATENATED MODULE: ./src/Notification.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_Notificationvue_type_script_lang_ts_ = (Notificationvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./src/Notification.vue





/* normalize component */

var Notification_component = normalizeComponent(
  src_Notificationvue_type_script_lang_ts_,
  Notificationvue_type_template_id_735eb4f4_render,
  Notificationvue_type_template_id_735eb4f4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var src_Notification = (Notification_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"e80778a2-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Avatar.vue?vue&type=template&id=7bfcd087&scoped=true&
var Avatarvue_type_template_id_7bfcd087_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar-icon",class:[
        ("avatar-icon--" + _vm.size),
        {
            'shadow-depth-1': this.shadow,
        } ]},[(_vm.initials)?_c('div',{staticClass:"avatar-icon__initials"},[_vm._v(" "+_vm._s(_vm.initials)+" ")]):_vm._e(),_c('div',{staticClass:"avatar-icon__image",style:(_vm.image)})])}
var Avatarvue_type_template_id_7bfcd087_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/Avatar.vue?vue&type=template&id=7bfcd087&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader??ref--12-2!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/Avatar.vue?vue&type=script&lang=ts&



let Avatarvue_type_script_lang_ts_OtAvatar = 
/**
 *  @vuese
 *  This component is used for creating an avatar icon. Meaning a circle shaped
 *  component which holds an image (with possibly a default/fallback image) or
 *  the initials of a user or company.
 *  <br><br>
 *  The icon is also able to invoke an edit function. Just forward the function
 *  to invoke via the @edit="" listener and the icon will show an edit button at the bottom and invoke
 *  the forwarded function if clicked. Due to design limitations this is only possible
 *  for avatar icons with a size of 120.
 */
class OtAvatar extends external_vue_default.a {
    // Returns the background image CSS object with either the set image or fallback image if set, otherwise null
    get image() {
        return !this.imageUrl && !this.defaultImageUrl
            ? null
            : {
                backgroundImage: `url('${this.imageUrl || this.defaultImageUrl}')`,
            };
    }
    get initials() {
        if (!this.name || !this.name.length) {
            return '';
        }
        const splitName = this.name.split(' ');
        if (splitName.length < 2) {
            return this.name.slice(0, 1).toUpperCase() + this.name.slice(1, 2);
        }
        return (splitName[0].slice(0, 1).toUpperCase()
            + splitName[splitName.length - 1].slice(0, 1));
    }
};
__decorate([
    Prop({ type: String })
], Avatarvue_type_script_lang_ts_OtAvatar.prototype, "imageUrl", void 0);
__decorate([
    Prop({ type: String })
], Avatarvue_type_script_lang_ts_OtAvatar.prototype, "defaultImageUrl", void 0);
__decorate([
    Prop({ type: String })
], Avatarvue_type_script_lang_ts_OtAvatar.prototype, "name", void 0);
__decorate([
    Prop({ type: String, default: '120' })
], Avatarvue_type_script_lang_ts_OtAvatar.prototype, "size", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], Avatarvue_type_script_lang_ts_OtAvatar.prototype, "shadow", void 0);
Avatarvue_type_script_lang_ts_OtAvatar = __decorate([
    vue_class_component_esm
    /**
     *  @vuese
     *  This component is used for creating an avatar icon. Meaning a circle shaped
     *  component which holds an image (with possibly a default/fallback image) or
     *  the initials of a user or company.
     *  <br><br>
     *  The icon is also able to invoke an edit function. Just forward the function
     *  to invoke via the @edit="" listener and the icon will show an edit button at the bottom and invoke
     *  the forwarded function if clicked. Due to design limitations this is only possible
     *  for avatar icons with a size of 120.
     */
], Avatarvue_type_script_lang_ts_OtAvatar);
/* harmony default export */ var Avatarvue_type_script_lang_ts_ = (Avatarvue_type_script_lang_ts_OtAvatar);

// CONCATENATED MODULE: ./src/Avatar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var src_Avatarvue_type_script_lang_ts_ = (Avatarvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./src/Avatar.vue?vue&type=style&index=0&id=7bfcd087&lang=scss&scoped=true&
var Avatarvue_type_style_index_0_id_7bfcd087_lang_scss_scoped_true_ = __webpack_require__("5cf2");

// CONCATENATED MODULE: ./src/Avatar.vue






/* normalize component */

var Avatar_component = normalizeComponent(
  src_Avatarvue_type_script_lang_ts_,
  Avatarvue_type_template_id_7bfcd087_scoped_true_render,
  Avatarvue_type_template_id_7bfcd087_scoped_true_staticRenderFns,
  false,
  null,
  "7bfcd087",
  null
  
)

/* harmony default export */ var Avatar = (Avatar_component.exports);
// CONCATENATED MODULE: ./src/index.ts
































/* harmony default export */ var src_0 = ({
    install: (Vue) => {
        // Layout
        Vue.component('OtDashboardLayout', DashboardLayout);
        Vue.component('OtHeader', Header);
        Vue.component('OtHeaderAction', Header_HeaderAction);
        Vue.component('OtFooter', Footer);
        Vue.component('OtSidebar', Sidebar);
        Vue.component('OtSplash', Splash);
        // Card
        Vue.component('OtCard', card_Card);
        Vue.component('OtCardHeader', card_CardHeader);
        Vue.component('OtCardContent', CardContent);
        Vue.component('OtCardFooter', card_CardFooter);
        // Modals and dialogs
        Vue.component('OtRouterModal', RouterModal);
        Vue.component('OtInlineModal', InlineModal);
        Vue.component('OtDialog', Dialog);
        // Pagination
        Vue.component('OtLazyList', LazyList);
        Vue.component('OtPagination', Pagination);
        Vue.component('OtPaginationControls', PaginationControls);
        Vue.component('OtPaginationTable', PaginationTable_PaginationTable);
        // Form
        Vue.component('OtForm', Form);
        Vue.component('OtFormCollapse', FormCollapse);
        Vue.component('OtFormInput', FormInput);
        Vue.component('OtFormRow', FormRow);
        Vue.component('OtFormField', FormField);
        Vue.component('OtFormError', FormError);
        // CRUD
        Vue.component('OtCrudSorter', CrudSorter);
        Vue.component('OtCrudSelect', CrudSelect);
        Vue.component('OtCrudMultiSelect', CrudMultiSelect);
        Vue.component('OtCrudPicker', CrudPicker);
        Vue.component('OtCrudNestedPicker', CrudNestedPicker);
        // Others
        Vue.component('OtDropdown', Dropdown);
        Vue.component('OtNotification', src_Notification);
        Vue.component('OtAvatar', Avatar);
        Vue.component('OtSpinner', Spinner);
    },
});


// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src_0);



/***/ }),

/***/ "ffcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudSelect_vue_vue_type_style_index_0_id_c808982e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("b995");
/* harmony import */ var _node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudSelect_vue_vue_type_style_index_0_id_c808982e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_vue_style_loader_index_js_ref_8_oneOf_1_0_node_modules_vue_cli_service_node_modules_css_loader_dist_cjs_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_3_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_4_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_CrudSelect_vue_vue_type_style_index_0_id_c808982e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ })

/******/ });
});
//# sourceMappingURL=ot.umd.js.map